/* web-vitals 5.1.0, Apache-2.0; see web-vitals-LICENSE */
var webVitals=function(e){"use strict";let t=-1;const n=e=>{addEventListener("pageshow",(n=>{n.persisted&&(t=n.timeStamp,e(n))}),!0)},i=(e,t,n,i)=>{let s,r;return o=>{t.value>=0&&(o||i)&&(r=t.value-(s??0),(r||void 0===s)&&(s=t.value,t.delta=r,t.rating=((e,t)=>e>t[1]?"poor":e>t[0]?"needs-improvement":"good")(t.value,n),e(t)))}},s=e=>{requestAnimationFrame((()=>requestAnimationFrame((()=>e()))))},r=()=>{const e=performance.getEntriesByType("navigation")[0];if(e&&e.responseStart>0&&e.responseStart<performance.now())return e},o=()=>{const e=r();return e?.activationStart??0},c=(e,n=-1)=>{const i=r();let s="navigate";t>=0?s="back-forward-cache":i&&(document.prerendering||o()>0?s="prerender":document.wasDiscarded?s="restore":i.type&&(s=i.type.replace(/_/g,"-")));return{name:e,value:n,rating:"good",delta:0,entries:[],id:`v5-${Date.now()}-${Math.floor(8999999999999*Math.random())+1e12}`,navigationType:s}},a=new WeakMap;function d(e,t){return a.get(e)||a.set(e,new t),a.get(e)}class h{t;i=0;o=[];h(e){if(e.hadRecentInput)return;const t=this.o[0],n=this.o.at(-1);this.i&&t&&n&&e.startTime-n.startTime<1e3&&e.startTime-t.startTime<5e3?(this.i+=e.value,this.o.push(e)):(this.i=e.value,this.o=[e]),this.t?.(e)}}const f=(e,t,n={})=>{try{if(PerformanceObserver.supportedEntryTypes.includes(e)){const i=new PerformanceObserver((e=>{Promise.resolve().then((()=>{t(e.getEntries())}))}));return i.observe({type:e,buffered:!0,...n}),i}}catch{}},u=e=>{let t=!1;return()=>{t||(e(),t=!0)}};let l=-1;const m=new Set,v=()=>"hidden"!==document.visibilityState||document.prerendering?1/0:0,p=e=>{if("hidden"===document.visibilityState){if("visibilitychange"===e.type)for(const e of m)e();isFinite(l)||(l="visibilitychange"===e.type?e.timeStamp:0,removeEventListener("prerenderingchange",p,!0))}},g=()=>{if(l<0){const e=o(),t=document.prerendering?void 0:globalThis.performance.getEntriesByType("visibility-state").filter((t=>"hidden"===t.name&&t.startTime>e))[0]?.startTime;l=t??v(),addEventListener("visibilitychange",p,!0),addEventListener("prerenderingchange",p,!0),n((()=>{setTimeout((()=>{l=v()}))}))}return{get firstHiddenTime(){return l},onHidden(e){m.add(e)}}},y=e=>{document.prerendering?addEventListener("prerenderingchange",(()=>e()),!0):e()},b=[1800,3e3],E=(e,t={})=>{y((()=>{const r=g();let a,d=c("FCP");const h=f("paint",(e=>{for(const t of e)"first-contentful-paint"===t.name&&(h.disconnect(),t.startTime<r.firstHiddenTime&&(d.value=Math.max(t.startTime-o(),0),d.entries.push(t),a(!0)))}));h&&(a=i(e,d,b,t.reportAllChanges),n((n=>{d=c("FCP"),a=i(e,d,b,t.reportAllChanges),s((()=>{d.value=performance.now()-n.timeStamp,a(!0)}))})))}))},L=[.1,.25];let P=0,T=1/0,_=0;const M=e=>{for(const t of e)t.interactionId&&(T=Math.min(T,t.interactionId),_=Math.max(_,t.interactionId),P=_?(_-T)/7+1:0)};let w;const C=()=>w?P:performance.interactionCount??0,I=()=>{"interactionCount"in performance||w||(w=f("event",M,{type:"event",buffered:!0,durationThreshold:0}))};let F=0;class k{u=[];l=new Map;m;v;p(){F=C(),this.u.length=0,this.l.clear()}L(){const e=Math.min(this.u.length-1,Math.floor((C()-F)/50));return this.u[e]}h(e){if(this.m?.(e),!e.interactionId&&"first-input"!==e.entryType)return;const t=this.u.at(-1);let n=this.l.get(e.interactionId);if(n||this.u.length<10||e.duration>t.P){if(n?e.duration>n.P?(n.entries=[e],n.P=e.duration):e.duration===n.P&&e.startTime===n.entries[0].startTime&&n.entries.push(e):(n={id:e.interactionId,entries:[e],P:e.duration},this.l.set(n.id,n),this.u.push(n)),this.u.sort(((e,t)=>t.P-e.P)),this.u.length>10){const e=this.u.splice(10);for(const t of e)this.l.delete(t.id)}this.v?.(n)}}}const A=e=>{const t=globalThis.requestIdleCallback||setTimeout;"hidden"===document.visibilityState?e():(e=u(e),addEventListener("visibilitychange",e,{once:!0,capture:!0}),t((()=>{e(),removeEventListener("visibilitychange",e,{capture:!0})})))},B=[200,500];class S{m;h(e){this.m?.(e)}}const N=[2500,4e3],q=[800,1800],H=e=>{document.prerendering?y((()=>H(e))):"complete"!==document.readyState?addEventListener("load",(()=>H(e)),!0):setTimeout(e)};return e.CLSThresholds=L,e.FCPThresholds=b,e.INPThresholds=B,e.LCPThresholds=N,e.TTFBThresholds=q,e.onCLS=(e,t={})=>{const r=g();E(u((()=>{let o,a=c("CLS",0);const u=d(t,h),l=e=>{for(const t of e)u.h(t);u.i>a.value&&(a.value=u.i,a.entries=u.o,o())},m=f("layout-shift",l);m&&(o=i(e,a,L,t.reportAllChanges),r.onHidden((()=>{l(m.takeRecords()),o(!0)})),n((()=>{u.i=0,a=c("CLS",0),o=i(e,a,L,t.reportAllChanges),s((()=>o()))})),setTimeout(o))})))},e.onFCP=E,e.onINP=(e,t={})=>{if(!globalThis.PerformanceEventTiming||!("interactionId"in PerformanceEventTiming.prototype))return;const s=g();y((()=>{I();let r,o=c("INP");const a=d(t,k),h=e=>{A((()=>{for(const t of e)a.h(t);const t=a.L();t&&t.P!==o.value&&(o.value=t.P,o.entries=t.entries,r())}))},u=f("event",h,{durationThreshold:t.durationThreshold??40});r=i(e,o,B,t.reportAllChanges),u&&(u.observe({type:"first-input",buffered:!0}),s.onHidden((()=>{h(u.takeRecords()),r(!0)})),n((()=>{a.p(),o=c("INP"),r=i(e,o,B,t.reportAllChanges)})))}))},e.onLCP=(e,t={})=>{y((()=>{const r=g();let a,h=c("LCP");const l=d(t,S),m=e=>{t.reportAllChanges||(e=e.slice(-1));for(const t of e)l.h(t),t.startTime<r.firstHiddenTime&&(h.value=Math.max(t.startTime-o(),0),h.entries=[t],a())},v=f("largest-contentful-paint",m);if(v){a=i(e,h,N,t.reportAllChanges);const r=u((()=>{m(v.takeRecords()),v.disconnect(),a(!0)})),o=e=>{e.isTrusted&&(A(r),removeEventListener(e.type,o,{capture:!0}))};for(const e of["keydown","click","visibilitychange"])addEventListener(e,o,{capture:!0});n((n=>{h=c("LCP"),a=i(e,h,N,t.reportAllChanges),s((()=>{h.value=performance.now()-n.timeStamp,a(!0)}))}))}}))},e.onTTFB=(e,t={})=>{let s=c("TTFB"),a=i(e,s,q,t.reportAllChanges);H((()=>{const d=r();d&&(s.value=Math.max(d.responseStart-o(),0),s.entries=[d],a(!0),n((()=>{s=c("TTFB",0),a=i(e,s,q,t.reportAllChanges),a(!0)})))}))},e}({});

  (() => {
    const root = document.currentScript.previousElementSibling;
    if (!root || root.dataset.mbCleanReady === 'true') return;
    root.dataset.mbCleanReady = 'true';

    const state = {
      productData: null,
      selectedOptions: [],
      selectedVariant: null,
      pairedOfferSelected: false,
      bundles: [],
      bundleSelections: {},
      bundleEnabled: {},
      accentSelections: {},
      accentSelectionCleared: {},
      bundleProperties: {},
      preloadedImages: new Set(),
      preloadedVideos: new Set(),
      preloadedVideoNodes: [],
      galleryAdjacentPreloadToken: 0,
      accentPrefetchObserver: null,
      accentPrefetchScheduled: new Set(),
      galleryTransition: null,
      lightboxIndex: 0,
      lightboxReturnFocus: null,
      addonLightboxThumbs: null,
      focusedBundleThumb: null,
      mobileTrackKey: '',
      mobileTrackThumbs: [],
      mobileTrackScrollRaf: null,
      mobileTrackAnalyticsTimer: null,
      mobileTrackProgrammaticTimer: null,
      mobileTrackProgrammatic: false,
      mobileTrackProgrammaticTarget: null,
      mobileTrackPendingThumb: null,
      mobileTrackUserStartMediaId: null,
      mobileGalleryHydrationToken: 0,
      lightboxScrollRaf: null,
      lightboxProgrammaticScroll: null,
      lightboxZoomHintTimer: null,
      lightboxScrollLock: null,
      mobileGalleryRaf: null,
      mobileGalleryMeasureRaf: null,
      mobileGalleryThumbCenterRaf: null,
      mobileGalleryProgress: 0,
      mobileGalleryTargetProgress: 0,
      mobileGalleryBuyboxTop: null,
      mobileGalleryViewportTop: null,
      mobileGalleryWidth: null,
      galleryAnalyticsObserver: null,
      galleryExposureTracked: false,
      galleryInteractionCount: 0,
      galleryLastInteraction: 'initial',
      galleryViewedMedia: new Set(),
      galleryFurthestPosition: 0,
      galleryFirstInteractionAt: null,
      galleryVisibleStartedAt: null,
      galleryVisibleMs: 0,
      galleryInViewport: false,
      galleryEngagementObserver: null,
      upsellImpressionObserver: null,
      upsellImpressionTimers: new Map(),
      upsellImpressionKeys: new Set(),
      upsellInteractionKeys: new Set(),
      gallerySummarySent: false,
      galleryFallbackUsed: false,
      galleryEligibleMediaCount: 0,
      lightboxOpenedAt: null,
      lightboxVisibleMs: 0,
      zoomedMedia: new Set(),
      videoAnalytics: new Map(),
      videoStarts: 0,
      videoWatchSeconds: 0,
      pendingAtcSource: 'primary',
      experimentExposureSent: false,
      experimentAssignmentPublished: false,
      experimentAssignmentRetries: 0,
      experimentAssignmentRetryTimer: null,
      webVitalsSent: false,
      webVitals: { lcp: null, inp: null, cls: null },
      mediaLoadToken: 0,
    };

    const productConfig = JSON.parse(root.querySelector('[data-mb-clean-product]')?.textContent || '{}');
    const product = productConfig.product;
    if (!product) return;
    const initialVariantId = productConfig.currentVariantId;
    let resetVariant = null;
    let resetOptions = null;

    const form = root.querySelector('form');
    const buybox = root.querySelector('.mb-clean-buybox');
    const hiddenId = root.querySelector('.product-variant-id');
    const addButton = root.querySelector('.mb-clean-atc');
    const galleryMain = root.querySelector('.mb-clean-gallery__main');
    const gallery = root.querySelector('.mb-clean-gallery');
    let mainImage = root.querySelector('[data-mb-main-image]') || root.querySelector('.mb-clean-gallery__image');
    const mainVideo = root.querySelector('[data-mb-main-video]');
    if (!mainImage && galleryMain) {
      mainImage = document.createElement('img');
      mainImage.className = 'mb-clean-gallery__image';
      mainImage.setAttribute('data-mb-main-image', '');
      mainImage.loading = 'eager';
      mainImage.decoding = 'async';
      galleryMain.insertBefore(mainImage, mainVideo || null);
    }
    const galleryBack = root.querySelector('[data-mb-gallery-back]');
    const mobileTrack = root.querySelector('[data-mb-gallery-track]');
    const thumbRail = root.querySelector('[data-mb-gallery-thumbs]');
    const galleryScrollButtons = Array.from(root.querySelectorAll('[data-mb-gallery-scroll]'));
    const thumbs = Array.from(root.querySelectorAll('[data-mb-thumb]'));
    const dotContainer = root.querySelector('.mb-clean-gallery__dots');
    let dots = Array.from(root.querySelectorAll('.mb-clean-gallery__dots span'));
    const counter = root.querySelector('.mb-clean-gallery__count');
    const qty = root.querySelector('[data-mb-qty]');
    const addonsGroup = root.querySelector('[data-mb-addons-group]');
    const addons = root.querySelector('[data-mb-addons]');
    const infoAccordion = root.querySelector('[data-mb-info-accordion]');
    const stickyAtc = root.querySelector('[data-mb-sticky-atc]');
    const stickySubmit = root.querySelector('[data-mb-sticky-submit]');
    const stickyImage = root.querySelector('.mb-clean-sticky-atc__media img');
    const stickyTitle = root.querySelector('[data-mb-sticky-title]');
    const stickyVariant = root.querySelector('[data-mb-sticky-variant]');
    const stickyCount = root.querySelector('[data-mb-sticky-count]');
    const teslaScreenHelp = root.querySelector('[data-mb-tesla-screen-help]');
    const lightbox = root.querySelector('[data-mb-lightbox]');
    const lightboxOpen = root.querySelector('[data-mb-lightbox-open]');
    const lightboxTrack = root.querySelector('[data-mb-lightbox-track]');
    const lightboxCount = root.querySelector('[data-mb-lightbox-count]');
    const lightboxPrev = root.querySelector('[data-mb-lightbox-prev]');
    const lightboxNext = root.querySelector('[data-mb-lightbox-next]');
    const lightboxZoomHint = root.querySelector('[data-mb-lightbox-zoom-hint]');
    const galleryOpenLabel = lightboxOpen?.getAttribute('aria-label') || 'Open product media gallery';
    const addonGalleryLabel = lightbox?.querySelector('[role="dialog"]')?.getAttribute('aria-label') || galleryOpenLabel;
    const stickyDisplayTitle = stickyTitle?.dataset.stickyTitle || product.title;
    const optionGroups = Array.from(root.querySelectorAll('[data-mb-option-group]'));
    const selectOptionTemplates = new WeakMap();
    const productSubtitle = root.querySelector('[data-mb-product-subtitle]');
    const productSummary = productSubtitle?.dataset.productSummary || '';
    const shipBadges = Array.from(root.querySelectorAll('[data-mb-ship-badge]'));
    const eyebrow = root.querySelector('[data-mb-eyebrow]');
    const eyebrowPrimary = root.querySelector('[data-mb-eyebrow-primary]');
    const eyebrowSecondary = root.querySelector('[data-mb-eyebrow-secondary]');
    const productVariants = product.variants || [];
    const productOptions = Array.isArray(product.options) ? product.options : [];
    const teslaModelOptionIndex = productOptions.findIndex((name) => /model/i.test(String(name || '')));
    const analyticsColorOptionIndex = productOptions.findIndex((name) => /(color|colour|finish)/i.test(String(name || '')));
    const mediaItems = product.media || [];
    const usesMainProductAccentMedia = productConfig.mainProductAccentMedia === true;
    const rgxPipeDelimiter = /\s*\|\s*/;
    const rgxCommaDelimiter = /\s*,\s*/;
    const rgxMultiSpace = /\s\s+/g;
    const galleryExperimentConfig = window.MagBakGalleryExperiment || {};
    const galleryQuery = new URLSearchParams(window.location.search);
    const managedTrackingConfig = productConfig.trackingConfig;
    const hasManagedTrackingConfig = managedTrackingConfig
      && typeof managedTrackingConfig === 'object'
      && Number(managedTrackingConfig.version) >= 1;
    // Temporary diagnostic capture; the collector isolates this product from reports.
    const validationCaptureEndsAt = Date.parse('2026-09-09T04:15:00Z');
    const validationCaptureOnly = product.handle === 'magbak-for-iphone-18-series'
      && managedTrackingConfig?.liveTracking !== true && Date.now() < validationCaptureEndsAt;
    const galleryAnalyticsEnabled = validationCaptureOnly || (hasManagedTrackingConfig
      ? managedTrackingConfig.liveTracking === true
      : product.handle === 'magbak-for-iphone-17-series');
    const galleryExperimentUnitId = (() => {
      const storageKey = 'mb_experiment_unit_v1';
      try {
        const saved = window.localStorage.getItem(storageKey);
        if (saved) return cleanAnalyticsValue(saved, 80);
        const id = window.crypto?.randomUUID?.()
          || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
        window.localStorage.setItem(storageKey, id);
        return id;
      } catch (error) {
        return `session-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
      }
    })();
    const managedConfiguredExperiment = hasManagedTrackingConfig
      && managedTrackingConfig.liveTracking === true
      && managedTrackingConfig.experimentEligible === true
      && managedTrackingConfig.activeExperiment
      && typeof managedTrackingConfig.activeExperiment === 'object'
      ? managedTrackingConfig.activeExperiment
      : null;
    const managedExperimentVariants = Array.isArray(managedConfiguredExperiment?.variants)
      ? managedConfiguredExperiment.variants.filter((variant) => {
        return variant && typeof variant.key === 'string' && Number(variant.allocation) > 0;
      })
      : [];
    const managedExperimentValid = Boolean(
      managedConfiguredExperiment?.id
      && managedExperimentVariants.some((variant) => variant.key === 'live')
      && managedExperimentVariants.some((variant) => variant.key === 'variant')
    );
    const experimentHashBucket = (value) => {
      let hash = 2166136261;
      for (let index = 0; index < value.length; index += 1) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
      }
      return (hash >>> 0) / 4294967296;
    };
    const assignedManagedVariant = (() => {
      if (!managedExperimentValid) return null;
      if (managedConfiguredExperiment.active === false) return null;
      const version = Number(managedConfiguredExperiment.version || 1);
      const assignmentKey = `mb_experiment_assignment:${managedConfiguredExperiment.id}`;
      try {
        const saved = JSON.parse(window.localStorage.getItem(assignmentKey) || 'null');
        if (
          saved?.version === version
          && managedExperimentVariants.some((variant) => variant.key === saved.variant)
        ) return saved.variant;
      } catch (error) {}
      const totalAllocation = managedExperimentVariants.reduce((sum, variant) => sum + Number(variant.allocation), 0);
      const bucket = experimentHashBucket(`${galleryExperimentUnitId}:${managedConfiguredExperiment.id}:${version}`) * totalAllocation;
      let cursor = 0;
      const assigned = managedExperimentVariants.find((variant) => {
        cursor += Number(variant.allocation);
        return bucket < cursor;
      })?.key || 'live';
      try {
        window.localStorage.setItem(assignmentKey, JSON.stringify({ version, variant: assigned }));
      } catch (error) {}
      return assigned;
    })();
    const forcedQaVariant = galleryQuery.get('mb_exp_qa') || galleryQuery.get('mb_gallery_variant');
    const forcedQaMatchesExperiment = !galleryQuery.get('mb_exp_id')
      || galleryQuery.get('mb_exp_id') === managedConfiguredExperiment?.id;
    const galleryExperimentQa = managedExperimentValid
      && forcedQaMatchesExperiment
      && ['live', 'variant'].includes(forcedQaVariant);
    const managedExperimentCanAssign = managedExperimentValid && managedConfiguredExperiment.active !== false;
    const galleryExperimentId = managedExperimentValid && (managedExperimentCanAssign || galleryExperimentQa)
      ? String(managedConfiguredExperiment.id)
      : galleryExperimentConfig.id || root.dataset.mbGalleryExperiment || 'no_experiment';
    const galleryExperimentVariant = managedExperimentValid && (managedExperimentCanAssign || galleryExperimentQa)
      ? (galleryExperimentQa ? forcedQaVariant : assignedManagedVariant)
      : galleryExperimentConfig.variant || root.dataset.mbGalleryVariant || 'live';
    root.dataset.mbGalleryExperiment = galleryExperimentId;
    root.dataset.mbGalleryVariant = galleryExperimentVariant;
    const pairedOfferConfig = productConfig.pairedOffer || {};
    const nativePairedOffer = Boolean(pairedOfferConfig.nativeBundle);
    let nativePairData = pairedOfferConfig.nativeBundle;
    let pairStockCheckPending = false;
    const pairedOfferQaVariant = galleryQuery.get('mb_paired_offer_qa');
    const pairedOfferQa = ['live', 'variant'].includes(pairedOfferQaVariant);
    const pairedOfferRenderedVariant = pairedOfferQa
      ? pairedOfferQaVariant
      : galleryExperimentVariant;
    const pairedOfferOptionIndex = productOptions.findIndex((name) => {
      return String(name || '').toLowerCase() === String(pairedOfferConfig.optionName || '').toLowerCase();
    });
    const pairedOfferDiscountPercent = Math.max(0, Math.min(30, Number(pairedOfferConfig.discountPercent || 0)));
    const pairedOfferFixedPrice = Math.max(0, Math.round(Number(pairedOfferConfig.fixedPrice || 0)));
    const pairedOfferEnabled = pairedOfferConfig.enabled === true && pairedOfferOptionIndex >= 0;
    const pairedOfferVisible = pairedOfferEnabled && (nativePairedOffer || pairedOfferRenderedVariant === 'variant');
    root.dataset.mbPairedOfferVariant = pairedOfferRenderedVariant;
    // The shared relationship writer is the only current-format cart contract.
    // Persisted carts using older properties remain readable in the cart, but
    // newly-created groups never fall back to writing the legacy payload.
    const relationshipWriterEnabled = () => Boolean(window.MagBakCartRelationship);
    const galleryUiVersion = 'swipeable_thumbnails_v1';
    const galleryAnalyticsProduction = /(^|\.)magbak\.com$/i.test(window.location.hostname)
      && !galleryQuery.has('preview_theme_id')
      && !galleryExperimentQa
      && !pairedOfferQa
      && !window.Shopify?.designMode;
    const galleryMeasurementSessionId = (() => {
      const storageKey = 'mb_measurement_session_v1';
      const now = Date.now();
      try {
        const saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        if (saved?.id && now - Number(saved.touchedAt || 0) < 30 * 60 * 1000) {
          window.sessionStorage.setItem(storageKey, JSON.stringify({ id: saved.id, touchedAt: now }));
          return cleanAnalyticsValue(saved.id, 80);
        }
        const id = window.crypto?.randomUUID?.()
          || `${now.toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
        window.sessionStorage.setItem(storageKey, JSON.stringify({ id, touchedAt: now }));
        return id;
      } catch (error) {
        return `${now.toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
      }
    })();

    const optionValues = (variant) => variant?.options || [variant?.option1, variant?.option2, variant?.option3].filter(Boolean);
    const displayOptionValue = (value) => {
      const normalized = String(value || '').trim();
      if (!normalized || normalized === 'Default Title') return '';
      return normalized.replace(/^iPhone\s+/i, '').trim();
    };
    const displayOptionSummary = (values) => values.filter(Boolean).map(displayOptionValue).join(' | ');
    const selectedDisplayOptions = () => state.selectedOptions.map((value, index) => {
      return state.pairedOfferSelected && index === pairedOfferOptionIndex
        ? pairedOfferConfig.label
        : value;
    });
    const displaySelectedOptionSummary = () => displayOptionSummary(selectedDisplayOptions());
    const normalizeDeviceModel = (value) => String(value || '')
      .toLowerCase()
      .replace(/\b(apple|iphone|samsung|galaxy|google|pixel)\b/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(rgxMultiSpace, ' ')
      .trim();
    const deviceModelTokens = (value) => normalizeDeviceModel(value).split(' ').filter(Boolean);
    const deviceModelMatches = (candidateValue, parentValue) => {
      const parentTokens = deviceModelTokens(parentValue);
      const candidateTokens = deviceModelTokens(candidateValue);
      if (!parentTokens.length || parentTokens.length !== candidateTokens.length) return false;
      // Compare as sorted multisets. Testing "same length + every token present"
      // lets duplicates through: "11 & 11 Pro" -> [11,11,pro] wrongly matches
      // "11 Pro XL" -> [11,pro,xl], attaching the wrong model's accessory.
      return parentTokens.slice().sort().join(' ') === candidateTokens.slice().sort().join(' ');
    };
    const deviceLikeValue = (value) => {
      const norm = normalizeDeviceModel(value);
      return !!norm && (/\d/.test(norm) || /\b(ultra|pro|plus|mini|max|fold|flip|fe|se)\b/.test(norm));
    };
    const addonHasDeviceVariants = (productInfo, variantChoices) => {
      const list = (variantChoices && variantChoices.length ? variantChoices : productInfo?.variants) || [];
      return list.some((variant) => (variant.options || []).some(deviceLikeValue) || deviceLikeValue(variant.title));
    };
    function moneyFromShopifySample(cents, sample) {
      const template = String(sample || '');
      const pattern = /1([^0-9]*)234([^0-9]*)567([^0-9]*)89/;
      const match = template.match(pattern);
      if (!match || match[1] !== match[2]) return null;
      const amount = Number(cents) || 0;
      const [whole, fraction] = (amount / 100).toFixed(amount % 100 === 0 ? 0 : 2).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, () => match[1]);
      const formatted = grouped + (fraction ? match[3] + fraction : '');
      return template.replace(pattern, () => formatted);
    }
    const money = (cents) => {
      if (state.productData?.euShippingText) {
        const localized = moneyFromShopifySample(cents, productConfig.moneySample || state.productData?.money_sample);
        if (localized !== null) return localized;
      }
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
      }).format((Number(cents) || 0) / 100);
    };
    const cleanUrl = (url) => url ? url.replace(/^\/\//, `${window.location.protocol}//`) : '';
    const galleryImageWidths = [700, 900, 1100, 1400];
    const galleryImageSizes = '(min-width: 990px) calc((100vw - 608px) * .92), 100vw';
    const thumbnailImageWidths = [120, 180, 260];
    const thumbnailImageSizes = '120px';
    const isShopifyImageUrl = (src) => {
      if (!src) return false;
      try {
        const url = new URL(cleanUrl(src), window.location.origin);
        return /\/cdn\/shop\//.test(url.pathname) || /(^|\.)cdn\.shopify\.com$/i.test(url.hostname);
      } catch (error) {
        return false;
      }
    };
    const resizedImageSrc = (src, width) => {
      const cleaned = cleanUrl(src);
      if (!cleaned || !width || !isShopifyImageUrl(cleaned)) return cleaned;
      try {
        const url = new URL(cleaned, window.location.origin);
        url.searchParams.set('width', String(width));
        return url.toString();
      } catch (error) {
        return cleaned;
      }
    };
    const responsiveImageSrcset = (src, widths) => {
      if (!isShopifyImageUrl(src)) return '';
      return widths.map((width) => `${resizedImageSrc(src, width)} ${width}w`).join(', ');
    };
    const setResponsiveImageSource = (image, src, options = {}) => {
      if (!image || !src) return;
      const widths = options.widths || galleryImageWidths;
      const fallbackWidth = options.fallbackWidth || widths[widths.length - 1];
      const srcset = responsiveImageSrcset(src, widths);
      if (options.loading) image.loading = options.loading;
      if (options.fetchPriority) image.fetchPriority = options.fetchPriority;
      if (srcset) {
        image.setAttribute('sizes', options.sizes || galleryImageSizes);
        image.setAttribute('srcset', srcset);
      } else {
        image.removeAttribute('sizes');
        image.removeAttribute('srcset');
      }
      image.src = resizedImageSrc(src, fallbackWidth);
    };
    const clearResponsiveImageSource = (image) => {
      if (!image) return;
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.removeAttribute('fetchpriority');
    };
    const dataSaverEnabled = () => window.navigator?.connection?.saveData === true;
    const requestGalleryIdle = (callback) => {
      window.setTimeout(callback, 160);
    };
    const variantMeta = (variant) => state.productData?.variant_metafields?.[variant?.id] || {};
    function isVariantHiddenForCountry(meta, country) {
      if (meta?.force_hide === true) return true;
      const countryCode = String(country || '').trim().toUpperCase();
      const exclusions = meta?.country_exclusions;
      return Boolean(countryCode) && Array.isArray(exclusions)
        && exclusions.some((code) => String(code).trim().toUpperCase() === countryCode);
    }
    function isOutsideEuAssortment(variant, eligibleIds) {
      return Array.isArray(eligibleIds) && !eligibleIds.includes(String(variant?.id));
    }
    const isHidden = (variant) => isVariantHiddenForCountry(variantMeta(variant), state.productData?.country)
      || isOutsideEuAssortment(variant, state.productData?.euEligibleVariantIds);
    const isAvailableVariant = (variant) => variant && variant.available && !isHidden(variant);
    const currentQuantity = () => Math.max(1, Number(qty?.value || 1));
    function canNotifyVariant(variant, meta, marketEligible, hidden, pairedOffer) {
      return marketEligible === true && !hidden && !pairedOffer
        && variant?.available === false && meta?.notify === true
        && meta?.inventory_policy === 'deny';
    }
    const notifyDialog = root.querySelector('[data-mb-notify-dialog]');
    const canNotifySelection = () => Boolean(notifyDialog?.showModal) && canNotifyVariant(
      state.selectedVariant, variantMeta(state.selectedVariant),
      state.productData?.notifyMarketEligible, isHidden(state.selectedVariant), state.pairedOfferSelected,
    );
    const notifyForm = notifyDialog?.querySelector('[data-mb-notify-form]');
    const notifyEmail = notifyDialog?.querySelector('[data-mb-notify-email]');
    const notifyStatus = notifyDialog?.querySelector('[data-mb-notify-status]');
    let notifyVariantId = null;
    let notifyPending = false;
    let notifyReturnFocus = null;
    function openNotifyDialog() {
      if (!canNotifySelection() || notifyDialog.open) return;
      notifyReturnFocus = document.activeElement;
      if (notifyVariantId !== state.selectedVariant.id) {
        notifyVariantId = state.selectedVariant.id;
        notifyForm.hidden = false;
        notifyStatus.textContent = '';
        notifyStatus.dataset.error = 'false';
      }
      const variantTitle = state.selectedVariant.title === 'Default Title' ? '' : state.selectedVariant.title;
      notifyDialog.querySelector('[data-mb-notify-product]').textContent = product.title;
      const variantLabel = notifyDialog.querySelector('[data-mb-notify-variant]');
      variantLabel.textContent = variantTitle;
      variantLabel.hidden = !variantTitle;
      const notifyImage = notifyDialog.querySelector('[data-mb-notify-image]');
      const notifyMedia = notifyDialog.querySelector('[data-mb-notify-media]');
      const heroSrc = variantImageSrc(state.selectedVariant);
      notifyMedia.hidden = !heroSrc;
      notifyImage.alt = [product.title, variantTitle].filter(Boolean).join(' — ');
      notifyImage.onerror = () => { notifyMedia.hidden = true; };
      if (heroSrc) notifyImage.src = resizedImageSrc(heroSrc, 240);
      else notifyImage.removeAttribute('src');
      notifyDialog.showModal();
      // Keep the mobile keyboard closed until the shopper taps the email field.
      notifyDialog.querySelector('[data-mb-notify-close]').focus({ preventScroll: true });
    }
    notifyDialog?.querySelector('[data-mb-notify-close]')?.addEventListener('click', () => notifyDialog.close());
    notifyDialog?.addEventListener('close', () => notifyReturnFocus?.focus());
    function notifySubscriptionPayload(email, variantId) {
      return { data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } } },
      } };
    }
    notifyForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (notifyPending || !notifyForm.reportValidity()) return;
      if (!canNotifySelection() || notifyVariantId !== state.selectedVariant.id) {
        notifyStatus.dataset.error = 'true';
        notifyStatus.textContent = 'Your selection has changed. Close this window and try again.';
        return;
      }
      const requestedVariantId = notifyVariantId;
      const submit = notifyForm.querySelector('[type="submit"]');
      notifyPending = true;
      submit.disabled = true;
      submit.textContent = 'Submitting…';
      notifyStatus.textContent = '';
      notifyStatus.dataset.error = 'false';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=JGMnr5', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
          body: JSON.stringify(notifySubscriptionPayload(notifyEmail.value.trim(), requestedVariantId)),
          signal: controller.signal,
        });
        if (response.status !== 202) throw new Error('Subscription not accepted');
        if (notifyVariantId === requestedVariantId) {
          notifyForm.hidden = true;
          notifyStatus.textContent = 'You’re on the list! We’ll email you when this option is back in stock.';
          notifyDialog.querySelector('[data-mb-notify-close]').focus();
        }
      } catch (error) {
        if (notifyVariantId === requestedVariantId) {
          notifyStatus.dataset.error = 'true';
          notifyStatus.textContent = 'We couldn’t confirm your request. Please try again.';
        }
      } finally {
        clearTimeout(timeout);
        notifyPending = false;
        submit.disabled = false;
        submit.textContent = 'Notify Me ✉️';
      }
    });
    optionGroups.forEach((group) => {
      const select = group.querySelector('select[data-mb-option-input]');
      if (!select) return;
      selectOptionTemplates.set(select, Array.from(select.options).map((option) => option.cloneNode(true)));
    });
    const discountedPrice = (variant, bundle) => {
      let price = Number(variant?.price || 0);
      const amount = Number(bundle?.discount_amount || 0);
      if (amount <= 0) return price;
      if (bundle.discount_type === 'Percent') return Math.round(price * (1 - Math.min(amount, 100) / 100));
      return Math.max(0, price - amount);
    };
    const addonRegularPrice = (variant) => Number(variant?.compare_at_price || variant?.price || 0);
    const addonPriceHTML = (item) => {
      const selectedVariants = variantsForSelectedAddon(item);
      const pricedVariants = selectedVariants.length ? selectedVariants : (item.variant ? [item.variant] : []);
      const regular = pricedVariants.reduce((sum, variant) => sum + addonRegularPrice(variant), 0);
      const price = pricedVariants.reduce((sum, variant) => sum + discountedPrice(variant, item.bundle), 0);
      if (item.included) {
        // match the regular upsell layout: main price + struck price + Save badge
        const compare = regular > 0 ? `<s>+${money(regular)}</s><em>Save ${money(regular)}</em>` : '';
        return `<strong data-mb-addon-price><span>Included</span>${compare}</strong>`;
      }
      const savings = Math.max(0, regular - price);
      const compare = savings > 0 ? `<s>+${money(regular)}</s><em>Save ${money(savings)}</em>` : '';
      return `<strong data-mb-addon-price><span>+${money(price)}</span>${compare}</strong>`;
    };
    const imageSrc = (image) => {
      if (!image) return '';
      if (typeof image === 'string') return cleanUrl(image);
      return cleanUrl(image.src || image.url || image.preview_image?.src || image.preview_image?.url || image.image?.src || image.image?.url);
    };
    const firstMediaSrc = (item) => {
      return imageSrc(item?.featured_image)
        || imageSrc(item?.featured_media)
        || imageSrc(item?.image)
        || imageSrc(item?.images?.[0])
        || imageSrc(item?.media?.[0]);
    };
    const variantImageSrc = (variant) => cleanUrl(
      variant?.featured_image?.src
      || variant?.featured_media?.preview_image?.src
      || variant?.featured_media?.preview_image?.url
      || product.featured_image
    );
    const escapeHTML = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[char]));
    const escapeAttribute = escapeHTML;
    const normalizeCartPropertyAttributes = (attributes) => {
      return attributes && typeof attributes === 'object' && !Array.isArray(attributes) ? attributes : {};
    };
    const cartPropertyStateKey = (item, property) => {
      return [
        item?.bundle?.id || item?.product?.id || 'addon',
        property?.key || property?.name || 'property',
      ].join(':');
    };
    const cartPropertyAttributesHTML = (attributes = {}) => {
      const blocked = new Set(['class', 'cls', 'key', 'name', 'value']);
      return Object.entries(normalizeCartPropertyAttributes(attributes)).map(([key, value]) => {
        if (blocked.has(key) || value === false || value === null || value === undefined) return '';
        if (value === true) return ` ${escapeAttribute(key)}`;
        return ` ${escapeAttribute(key)}="${escapeAttribute(value)}"`;
      }).join('');
    };
    const plainText = (value) => {
      const div = document.createElement('div');
      div.innerHTML = String(value || '');
      return div.textContent.replace(/\s+/g, ' ').trim();
    };
    // PDP eyebrow badges. A variant override is any STRING in variant_metafields; null/undefined
    // means no override, so the product-level badge is inherited. Do not collapse this to `||` —
    // that would treat a suppressed override as absent and fall back to the product copy.
    // Shopify refuses to store blank metafield values, so hiding a badge on one variant is done
    // with an explicit token. Keep in sync with pdp_badge_hide_tokens in
    // snippets/mb-product-top-content.liquid.
    const BADGE_HIDE_TOKENS = new Set(['-', '\u2013', '\u2014', 'none', 'hide', 'off', 'n/a']);
    const resolveBadgeCopy = (variant, key) => {
      const override = variantMeta(variant)[key];
      const hasOverride = typeof override === 'string';
      const raw = hasOverride ? override : state.productData?.metafields?.[key];
      const text = String(raw == null ? '' : raw).trim();
      if (!text) return '';
      if (hasOverride && BADGE_HIDE_TOKENS.has(text.toLowerCase())) return '';
      return text;
    };
    const parseShipMessage = (variant) => {
      const raw = String(variantMeta(variant).ships || state.productData?.metafields?.ships || '').trim();
      if (!raw) return null;
      const parts = raw.split(rgxPipeDelimiter).filter(Boolean);
      const tone = String(parts[parts.length - 1] || '').toLowerCase() === 'low' ? 'low' : 'standard';
      const text = tone === 'low' ? parts.slice(0, -1).join(' | ').trim() : parts.join(' | ').trim();
      return text ? { text, tone } : null;
    };
    const isPreorderVariant = (variant) => {
      if (!variant) return false;
      const inventoryManagedByShopify = String(variant.inventory_management || '').toLowerCase() === 'shopify';
      const inventoryQuantity = Number(variant.inventory_quantity);
      const oversellingInventory = inventoryManagedByShopify
        && Number.isFinite(inventoryQuantity)
        && inventoryQuantity <= 0
        && String(variant.inventory_policy || '').toLowerCase() === 'continue';
      const shippingMessage = parseShipMessage(variant);
      const explicitlyPreorder = /\bpre[\s-]?order\b/i.test(String(shippingMessage?.text || ''));
      const delayedShipping = shippingMessage?.tone === 'standard';
      return oversellingInventory || explicitlyPreorder || delayedShipping;
    };
    const isInStockVariant = (variant) => {
      if (!isAvailableVariant(variant) || isPreorderVariant(variant)) return false;
      if (String(variant.inventory_management || '').toLowerCase() !== 'shopify') return true;
      const inventoryQuantity = Number(variant.inventory_quantity);
      return Number.isFinite(inventoryQuantity) && inventoryQuantity > 0;
    };
    const truncateWords = (value, limit = 52) => {
      const words = String(value || '').split(/\s+/).filter(Boolean);
      if (words.length <= limit) return words.join(' ');
      return `${words.slice(0, limit).join(' ')}...`;
    };
    const parseInfoSections = (html) => {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = String(html || '');
      const richText = wrapper.querySelector('.metafield-rich_text_field') || wrapper;
      const sections = [];
      let currentTitle = 'Description';
      let currentNodes = [];
      const normalizeInfoTitle = (title) => {
        const cleanTitle = String(title || '').replace(/:\s*$/, '').trim();
        const normalized = cleanTitle.toLowerCase().replace(/[’']/g, "'");
        if (!cleanTitle || normalized === 'choose your case') return 'Description';
        if (normalized === 'features' || normalized === 'key features') return 'Key Features';
        if (normalized === "what's included" || normalized === 'whats included') return "What's Included";
        return cleanTitle;
      };

      const commitSection = () => {
        if (!currentNodes.length) return;
        const content = document.createElement('div');
        currentNodes.forEach((node) => content.appendChild(node.cloneNode(true)));
        const sectionHTML = content.innerHTML.trim();
        if (sectionHTML) sections.push({ title: currentTitle, html: sectionHTML });
        currentNodes = [];
      };

      const directChildren = Array.from(richText.children).filter((node) => {
        const tagName = node.tagName?.toLowerCase();
        return ['div', 'p', 'h2', 'h3', 'ul', 'ol'].includes(tagName);
      });
      const blockNodes = Array.from(richText.querySelectorAll('p, h2, h3, ul, ol'));
      const children = directChildren.length ? directChildren : blockNodes;

      children.forEach((element) => {
        const tagName = element.tagName?.toLowerCase();
        const strong = Array.from(element.querySelectorAll('strong')).find((node) => /:\s*$/.test(node.textContent.trim()));
        const strongText = strong?.textContent.trim() || '';
        const isHeading = tagName === 'h2' || tagName === 'h3';
        const isStrongLabel = strongText && /:\s*$/.test(strongText);

        if (isHeading || isStrongLabel) {
          commitSection();
          currentTitle = normalizeInfoTitle(isHeading ? element.textContent : strongText);

          if (isStrongLabel && element.textContent.trim() !== strongText) {
            const labelContent = element.cloneNode(true);
            const label = Array.from(labelContent.querySelectorAll('strong')).find((node) => node.textContent.trim() === strongText);
            label?.remove();
            if (labelContent.textContent.trim()) currentNodes.push(labelContent);
          }
          return;
        }

        currentNodes.push(element);
      });

      commitSection();

      if (!sections.length && richText.innerHTML.trim()) {
        sections.push({ title: 'Description', html: richText.innerHTML.trim() });
      }

      return sections;
    };
    const selectedInfoSections = (variant) => {
      const variantDescription = variantMeta(variant).description;
      const fallbackDescription = product.description ? `<div class="metafield-rich_text_field">${product.description}</div>` : '';
      const variantSections = parseInfoSections(variantDescription);
      return variantSections.length ? variantSections : parseInfoSections(fallbackDescription);
    };
    function setInfoItemOpen(button, open) {
      const item = button.closest('[data-mb-info-item]');
      const panel = item?.querySelector('[data-mb-info-panel]');
      if (!item || !panel) return;

      button.setAttribute('aria-expanded', String(open));
      item.classList.toggle('is-open', open);

      if (open) {
        panel.hidden = false;
        panel.style.height = '0px';
        panel.offsetHeight;
        panel.style.height = `${panel.scrollHeight}px`;
        panel.addEventListener('transitionend', function handleOpen(event) {
          if (event.propertyName !== 'height') return;
          panel.style.height = 'auto';
        }, { once: true });
        return;
      }

      panel.style.height = `${panel.scrollHeight}px`;
      panel.offsetHeight;
      panel.style.height = '0px';
      panel.addEventListener('transitionend', function handleClose(event) {
        if (event.propertyName !== 'height') return;
        panel.hidden = true;
      }, { once: true });
    }
    function renderInfoAccordion(variant) {
      if (!infoAccordion) return;
      const sections = selectedInfoSections(variant).filter((section) =>
        !Array.isArray(state.productData?.euEligibleVariantIds) || !/screen protector/i.test(section.html || '')
      );
      if (!sections.length) {
        infoAccordion.hidden = true;
        infoAccordion.innerHTML = '';
        return;
      }

      infoAccordion.hidden = false;
      infoAccordion.innerHTML = sections.map((section, index) => {
        const panelId = `mb-clean-info-${root.id || 'section'}-${index}`;
        return `
          <div class="mb-clean-info__item" data-mb-info-item>
            <button class="mb-clean-info__toggle" type="button" aria-expanded="false" aria-controls="${panelId}">
              <span>${escapeHTML(section.title)}</span>
              <i aria-hidden="true"></i>
            </button>
            <div class="mb-clean-info__panel" id="${panelId}" data-mb-info-panel hidden>
              <div class="mb-clean-info__content rte">${section.html}</div>
            </div>
          </div>
        `;
      }).join('');

      const infoLinkLabel = infoAccordion.dataset.mbInfoLinkLabel;
      const infoLinkHref = infoAccordion.dataset.mbInfoLinkHref;
      if (infoLinkLabel && infoLinkHref) {
        infoAccordion.insertAdjacentHTML('beforeend', `
          <div class="mb-clean-info__item mb-clean-info__item--link" data-mb-info-item>
            <a class="mb-clean-info__toggle mb-clean-info__link" href="${escapeHTML(infoLinkHref)}">
              <span>${escapeHTML(infoLinkLabel)}</span>
              <i aria-hidden="true"></i>
            </a>
          </div>
        `);
      }

      infoAccordion.querySelectorAll('button.mb-clean-info__toggle').forEach((button) => {
        button.addEventListener('click', () => setInfoItemOpen(button, button.getAttribute('aria-expanded') !== 'true'));
      });
    }
    const optionDescription = (value) => {
      const v = String(value || '').toLowerCase();
      const isWallet = /wallet/.test(String(product?.title || productConfig?.productData?.product?.title || '').toLowerCase());
      if (isWallet && v.includes('tracking')) return 'Apple FindMy & Google Find Hub Compatible';
      if (isWallet && v.includes('classic')) return 'Minimal, Functional, and Practical';
      if (state.productData?.euEnglish && product?.handle === 'magbak-for-iphone-17-series') {
        if (v.includes('elite')) return 'Built-in kickstand and finger loop';
        if (v.includes('classic')) return 'Slim, minimalist everyday protection';
      }
      if (v.includes('elite')) return 'Feature rich and customizable!';
      if (v.includes('classic')) return 'Minimalist and timeless!';
      if (v.includes('clear')) return 'Show your phone! Yellow-resistant.';
      if (v.includes('pro')) return 'Premium magnetic protection';
      return 'Compatible MagBak configuration';
    };
    const isRimcaseProduct = () => /rimcase/.test(`${product?.handle || ''} ${product?.title || ''}`.toLowerCase());
    const addonIdentityFrom = (bundle, productInfo) => `${bundle?.tagline || ''} ${productInfo?.title || ''} ${productInfo?.handle || ''}`.toLowerCase();
    const isTeslaChargerIdentity = (identity) => /phone mount and charger|tesla.*charger|charger.*tesla/.test(String(identity || '').toLowerCase());
    const isRimcaseTeslaChargerIdentity = (bundle, productInfo) => isRimcaseProduct() && isTeslaChargerIdentity(addonIdentityFrom(bundle, productInfo));
    const isModelYChargerVariant = (variant) => {
      const text = `${variant?.title || ''} ${variant?.sku || ''}`.toLowerCase();
      return (variant?.options || []).some((value) => /^model\s*y$/i.test(String(value || '').trim())) || /\bmodel\s*y\b/.test(text);
    };
    const filterRimcaseTeslaChargerVariants = (bundle, productInfo, variants) => {
      if (!isRimcaseTeslaChargerIdentity(bundle, productInfo)) return variants;
      const modelYVariants = variants.filter(isModelYChargerVariant);
      return modelYVariants.length ? modelYVariants : variants;
    };
    const rimcaseChargerVariantLabel = (variant) => {
      return (variant?.options || [])
        .filter((value) => !/^model\s*y$/i.test(String(value || '').trim()))
        .filter(Boolean)
        .join(' / ');
    };
    const bundleVariantLabel = (variant) => {
      const title = String(variant?.title || '').trim();
      if (!title || title === 'Default Title') return 'Default';
      return (variant.options || []).filter(Boolean).join(' / ') || title;
    };
    // The subtitle slot is for the shopper's *selection*, not a second copy of the
    // title. An add-on with variants shows which one is picked; one without shows
    // nothing. Previously this fell back to the tagline, which is also what the card
    // title resolves to for most add-ons -- so 18 of 19 optionless rows rendered the
    // same string twice ("Add a Charger for the Car" above "Add a Charger for the
    // Car"). The only copy this drops site-wide is the "2" in iPhone 17's
    // "2 Extra MagSticks", and that disappears when it migrates anyway.
    //
    // Engraving add-ons never reach here: the hasProperties branch at the render site
    // takes precedence and shows the text the shopper typed.
    const bundleVariantMeta = (bundle, productInfo, variant, config) => {
      if (isRimcaseTeslaChargerIdentity(bundle, productInfo)) {
        return rimcaseChargerVariantLabel(variant) || '';
      }
      const label = bundleVariantLabel(variant);
      if (label !== 'Default') return label;
      return '';
    };
    const looksVisualOption = (name, values, swatches = {}) => {
      const normalized = String(name || '').toLowerCase();
      if (/(color|colour|finish|material)/.test(normalized)) return true;
      return values.some((value) => {
        const swatch = swatches?.[name]?.[value];
        return swatch?.color || swatch?.image || /(black|white|clear|brown|tan|beige|gold|red|blue|green|orange|pink|purple|gray|grey|olive)/i.test(value);
      });
    };
    const euDisplayText = (value) => {
      const text = String(value ?? '');
      if (!state.productData?.euEnglish) return text;
      const replacements = {"ALUMINUM": "ALUMINIUM", "Aluminum": "Aluminium", "aluminum": "aluminium", "Personalization": "Personalisation", "personalization": "personalisation", "Personalize": "Personalise", "personalize": "personalise", "Customizable": "Customisable", "customizable": "customisable", "Color": "Colour", "color": "colour", "Gray": "Grey", "gray": "grey", "Cart": "Basket", "cart": "basket"};
      return text.replace(/\b(ALUMINUM|Aluminum|aluminum|Personalization|personalization|Personalize|personalize|Customizable|customizable|Color|color|Gray|gray|Cart|cart)\b/g, (word) => replacements[word]);
    };
    const bundleOptionDisplayName = (name) => {
      const normalized = String(name || '').toLowerCase();
      if (normalized.includes('accent pack')) return 'Buttons';
      if (normalized.includes('lens frame')) return 'Lens frame';
      if (/(device|model|iphone)/.test(normalized)) return 'Model';
      if (/(color|colour|finish)/.test(normalized)) return euDisplayText('Color');
      if (normalized.includes('material')) return 'Material';
      if (normalized.includes('type') || normalized.includes('style')) return 'Style';
      return name;
    };
    const addonIdentity = (item) => addonIdentityFrom(item?.bundle, item?.product);
    const isAccentPackAddon = (item) => /color|accent(?:\s+|-)pack|button set/.test(addonIdentity(item));
    const isButtonPackAddon = (item) => /button set|button pack/.test(addonIdentity(item));
    const isEliteColorAccentAddon = (item) => isAccentPackAddon(item) && !isButtonPackAddon(item);
    const accentSelectionKey = (item) => String(item?.bundle?.id || item?.product?.id || '');
    const accentVariantIds = (item) => state.accentSelections[accentSelectionKey(item)] || [];
    const accentSelectedVariants = (item) => {
      const variantsById = new Map((item?.variantChoices || []).map((variant) => [String(variant.id), variant]));
      return accentVariantIds(item).map((id) => variantsById.get(String(id))).filter(Boolean);
    };
    const variantsForSelectedAddon = (item) => {
      if (!isAccentPackAddon(item)) return item?.variant ? [item.variant] : [];
      return accentSelectedVariants(item);
    };
    const isTeslaChargerAddon = (item) => isTeslaChargerIdentity(addonIdentity(item));
    const addonDisplayTitle = (item) => {
      const identity = addonIdentity(item);
      if (addonCartProperties(item).length && /wallet/.test(identity)) return 'Personalize Your Wallet';
      if (addonCartProperties(item).length && /airpods/.test(identity)) return 'Personalize Your AirPods Case';
      if (isEliteColorAccentAddon(item)) return item.bundle?.tagline || 'Add Elite Color Accents';
      if (isButtonPackAddon(item)) return item.bundle?.tagline || item.product?.title || 'Case Button Set';
      if (/camera lens|lens protection/.test(identity)) return 'Camera Lens Protector';
      if (/wallet/.test(identity)) return 'MagBak Wallet';
      if (/magstick/.test(identity)) return 'Extra MagSticks';
      if (/airpods/.test(identity)) return 'AirPods Pro 3 Silicone Case';
      return item.bundle?.tagline || item.product?.title || '';
    };
    const configuredUpsellPosition = (item) => {
      const pmetas = state.productData?.metafields || {};
      const configuredBundles = pmetas.inline_bundles || [];
      const configuredOffers = configuredBundles.length ? configuredBundles : (pmetas.inline_upsells || []);
      const bundleId = String(item?.bundle?.id || '');
      const productId = String(item?.product?.id || '');
      const configuredIndex = configuredOffers.findIndex((offer) => (
        (bundleId && String(offer?.id || '') === bundleId)
        || (productId && String(offer?.product?.id || '') === productId)
      ));
      return configuredIndex >= 0 ? configuredIndex + 1 : null;
    };
    const addonUpsellMetadata = (item, variant = item?.variant) => {
      const offerId = String(item?.bundle?.id || '');
      const productId = String(item?.product?.id || '');
      const handle = cleanAnalyticsValue(item?.product?.handle, 100);
      const key = offerId
        ? `offer:${offerId}`
        : productId
          ? `product:${productId}`
          : handle
            ? `handle:${handle}`
            : '';
      return {
        upsell_key: key,
        upsell_offer_id: offerId,
        upsell_product_id: productId,
        upsell_variant_id: String(variant?.id || ''),
        upsell_handle: handle,
        upsell_label: cleanAnalyticsValue(addonDisplayTitle(item), 100),
        upsell_offer_type: item?.included ? 'included_free' : 'paid_optional',
        // Preserve the canonical merchandised order. `state.bundles` contains
        // only offers compatible with the selected configuration, so its index
        // is not stable across devices and case models.
        upsell_position: configuredUpsellPosition(item),
      };
    };
    const eligibleUpsellKeys = () => state.bundles
      .filter((item) => item && !item.included)
      .map((item) => addonUpsellMetadata(item).upsell_key)
      .filter(Boolean);
    const trackUpsellEvent = (eventName, item, action, variant = item?.variant, extra = {}) => {
      const metadata = addonUpsellMetadata(item, variant);
      if (!metadata.upsell_key) return;
      sendGalleryAnalytics(eventName, {
        ...metadata,
        upsell_action: action,
        ...extra,
        ...analyticsConfiguration(),
      });
    };
    const trackUpsellInteraction = (item, action = 'open', variant = item?.variant) => {
      const key = addonUpsellMetadata(item, variant).upsell_key;
      if (!key || state.upsellInteractionKeys.has(key)) return;
      state.upsellInteractionKeys.add(key);
      trackUpsellEvent('pdp_upsell_interaction', item, action, variant);
    };
    const trackUpsellSelection = (item, action, variant = item?.variant) => {
      trackUpsellEvent('pdp_upsell_selection', item, action, variant);
    };
    const relationshipAnalytics = (link) => {
      const parsed = window.MagBakCartRelationship?.safeParseLink?.(link || '');
      if (!parsed?.ok) return {};
      return {
        relationship_node: parsed.link.node,
        relationship_parent: parsed.link.parent || '',
        relationship_kind: parsed.link.kind,
      };
    };
    // Build measurement events from the in-memory offer configuration rather
    // than reading attribution fields back from Shopify line properties. During
    // the shadow phase the cart still dual-writes its legacy fields, but the
    // reporting manifest is already independent of them.
    const prepareUpsellAddToCart = (entries, cartGroup, context) => {
      const events = entries.map(({ item, relationshipLink }) => ({
        ...addonUpsellMetadata(item, item.variant),
        upsell_action: 'add_to_cart',
        cart_group_id: cartGroup,
        ...relationshipAnalytics(relationshipLink),
        ...context,
      }));
      return () => events.forEach((params) => sendGalleryAnalytics('pdp_upsell_atc', params));
    };
    const clearUpsellImpressionTracking = () => {
      state.upsellImpressionObserver?.disconnect?.();
      state.upsellImpressionObserver = null;
      state.upsellImpressionTimers.forEach((timer) => window.clearTimeout(timer));
      state.upsellImpressionTimers.clear();
    };
    const setupUpsellImpressionTracking = () => {
      clearUpsellImpressionTracking();
      if (!galleryAnalyticsEnabled || !('IntersectionObserver' in window)) return;

      state.upsellImpressionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const label = entry.target;
          const item = state.bundles[Number(label.dataset.mbAddonIndex)];
          const metadata = addonUpsellMetadata(item);
          const key = metadata.upsell_key;
          if (!item || !key || state.upsellImpressionKeys.has(key)) return;

          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
            const timer = state.upsellImpressionTimers.get(key);
            if (timer) window.clearTimeout(timer);
            state.upsellImpressionTimers.delete(key);
            return;
          }
          if (state.upsellImpressionTimers.has(key)) return;

          const timer = window.setTimeout(() => {
            state.upsellImpressionTimers.delete(key);
            if (!label.isConnected || state.upsellImpressionKeys.has(key)) return;
            state.upsellImpressionKeys.add(key);
            trackUpsellEvent('pdp_upsell_impression', item, 'view');
            state.upsellImpressionObserver?.unobserve?.(label);
          }, 1000);
          state.upsellImpressionTimers.set(key, timer);
        });
      }, { threshold: [0, 0.5] });

      addons?.querySelectorAll('label[data-mb-addon-index]').forEach((label) => {
        state.upsellImpressionObserver.observe(label);
      });
    };
    const addonCartProperties = (item) => {
      return item?.bundle?.variant_metafields?.[item?.variant?.id]?.cart_properties || [];
    };
    // Keep the fulfillment allowlist narrowly scoped to engraving. Other add-ons
    // with shopper-entered properties retain their existing cart contract.
    const isEngravingAddon = (item) => addonCartProperties(item)
      .some((property) => String(property?.key || '').trim() === 'Engrave Text');
    const addonPropertyInputsHTML = (item, addonIndex) => {
      const properties = addonCartProperties(item).filter((property) => property?.key);
      if (!properties.length) return '';

      return `
        <span class="mb-clean-addons-properties" data-mb-addon-properties>
          ${properties.map((property, propertyIndex) => {
            const inputId = `mb-addon-property-${root.id || 'section'}-${addonIndex}-${propertyIndex}`;
            const stateKey = cartPropertyStateKey(item, property);
            const value = state.bundleProperties[stateKey] || '';
            const label = escapeHTML(property.name || property.key);
            const attributes = {
              type: 'text',
              autocomplete: 'off',
              ...normalizeCartPropertyAttributes(property.attributes),
            };
            return `
              <span class="mb-clean-addons-property">
                <span class="mb-clean-addons-property__label">${label}</span>
                <input
                  id="${escapeAttribute(inputId)}"
                  class="mb-clean-addons-property__input ${escapeAttribute(property.css_classes || '')}"
                  aria-label="${label}"
                  value="${escapeAttribute(value)}"
                  data-mb-addon-property
                  data-mb-addon-index="${addonIndex}"
                  data-property-key="${escapeAttribute(property.key)}"
                  data-property-state-key="${escapeAttribute(stateKey)}"
                  ${cartPropertyAttributesHTML(attributes)}
                >
              </span>
            `;
          }).join('')}
        </span>
      `;
    };
    const addonPropertySummary = (item) => {
      return addonCartProperties(item).map((property) => {
        const stateKey = cartPropertyStateKey(item, property);
        const rawValue = String(state.bundleProperties[stateKey] || '').trim();
        if (!rawValue) return '';
        const value = String(property.css_classes || '').includes('uppercase') ? rawValue.toUpperCase() : rawValue;
        const label = property.name || property.key;
        return label ? `${label}: ${value}` : value;
      }).filter(Boolean).join(' / ');
    };
    const selectedBundleEntries = () => {
      return Array.from(addons?.querySelectorAll('[data-mb-addon-index]') || []).map((label) => {
        const input = label.querySelector('[data-mb-addon-input]');
        const item = state.bundles[Number(label.dataset.mbAddonIndex)];
        return input?.checked && item ? { item, label, input } : null;
      }).filter(Boolean);
    };
    const readAddonCartProperties = (entry) => {
      let valid = true;
      const properties = {};
      entry.label.querySelectorAll('[data-mb-addon-property]').forEach((input) => {
        const rawValue = String(input.value || '').trim();
        if (input.hasAttribute('required') && !input.reportValidity()) valid = false;
        if (!rawValue) return;
        const value = input.classList.contains('uppercase') ? rawValue.toUpperCase() : rawValue;
        properties[input.dataset.propertyKey] = value;
      });
      return { valid, properties };
    };
    async function refreshCartDrawer(cart) {
      if (!cart?.renderContents || !cart.getSectionsToRender) return;

      const sectionIds = cart.getSectionsToRender().map((section) => section.id);
      if (!sectionIds.length) return;

      const sectionsUrl = new URL(window.location.pathname, window.location.origin);
      sectionsUrl.searchParams.set('sections', sectionIds.join(','));
      const cartUrl = ajaxCartUrl(window.routes?.cart_url, '/cart.js');

      const [cartResponse, sectionsResponse] = await Promise.all([
        fetchWithRetry(cartUrl, {
          headers: { Accept: 'application/json' },
        }),
        fetchWithRetry(sectionsUrl.toString(), {
          headers: { Accept: 'application/json' },
        }),
      ]);

      if (!cartResponse.ok || !sectionsResponse.ok) {
        throw new Error('Unable to refresh cart. Please try again in a moment.');
      }

      const cartState = await cartResponse.json();
      const sections = await sectionsResponse.json();
      cart.renderContents({ ...cartState, sections });
    }
    const ajaxCartUrl = (route, fallback) => {
      const url = new URL(route || fallback, window.location.origin);
      if (!url.pathname.endsWith('.js')) url.pathname = `${url.pathname}.js`;
      return url.toString();
    };
    const wait = (delay) => new Promise((resolve) => {
      window.setTimeout(resolve, delay);
    });
    async function fetchWithRetry(url, options = {}, attempts = 4) {
      let response = null;

      for (let attempt = 0; attempt < attempts; attempt += 1) {
        response = await fetch(url, options);
        if (response.status !== 429) return response;
        await wait(500 * (attempt + 1));
      }

      return response;
    }
    const parseCartAddResponse = (responseText) => {
      try {
        return JSON.parse(responseText || '{}');
      } catch (error) {
        return null;
      }
    };
    const isDeviceLockedAddon = (item) => /camera lens|lens protect|screen protector/.test(addonIdentity(item));
    const visualOptionIndexes = (item) => {
      const optionNames = item.product.options || [];
      return optionNames.reduce((indexes, optionName, optionIndex) => {
        const values = Array.from(new Set(item.variantChoices.map((variant) => variant.options?.[optionIndex]).filter(Boolean)));
        if (values.length > 1 && looksVisualOption(optionName, values, item.bundle.swatches)) indexes.push(optionIndex);
        return indexes;
      }, []);
    };
    const linkedColorValues = (item, indexes) => {
      if (indexes.length < 2) return [];
      const firstValues = Array.from(new Set(item.variantChoices.map((variant) => variant.options?.[indexes[0]]).filter(Boolean)));
      return firstValues.filter((value) => {
        return indexes.every((optionIndex) => item.variantChoices.some((variant) => variant.options?.[optionIndex] === value))
          && item.variantChoices.some((variant) => indexes.every((optionIndex) => variant.options?.[optionIndex] === value));
      });
    };
    const normalizeColorLabel = (value) => String(value || '').trim().toLowerCase().replace(/^cherry$/, 'burgundy');
    const parentCaseColor = () => {
      const colorOptionIndex = productOptions.findIndex((name) => /(color|colour|finish)/i.test(String(name || '')));
      if (colorOptionIndex >= 0) return normalizeColorLabel(state.selectedOptions[colorOptionIndex]);

      const skuColor = String(state.selectedVariant?.sku || '').match(/(?:^|[-_])(BK|BE|CH|RD|BL|LB|LG|OR|UM|PR)$/i)?.[1]?.toUpperCase();
      return {
        BK: 'black',
        BE: 'beige',
        CH: 'burgundy',
        RD: 'red',
        BL: 'blue',
        LB: 'light blue',
        LG: 'light gray',
        OR: 'orange',
        UM: 'umber',
        PR: 'purple',
      }[skuColor] || '';
    };
    const isEliteParentCase = () => {
      const text = [
        product.title,
        state.selectedVariant?.title,
        ...(state.selectedOptions || []),
      ].filter(Boolean).join(' ');
      return /\belite\b/i.test(text) || /^E/i.test(String(state.selectedVariant?.sku || '').trim());
    };
    const accentVariantMatchesParentColor = (variant) => {
      const color = isEliteParentCase() ? parentCaseColor() : '';
      return !!color && (variant?.options || []).some((value) => normalizeColorLabel(value) === color);
    };
    const deviceModelSeparator = /\s*(?:&|\||,| and )\s*/i;
    const splitDeviceModels = (value) => String(value || '').split(deviceModelSeparator).map((part) => part.trim()).filter(Boolean);
    const variantDeviceModels = (variant) => [...(variant?.options || []), variant?.title].flatMap(splitDeviceModels);
    const matchedParentDeviceModel = (variant) => {
      const parentDevice = state.selectedOptions[0];
      if (!parentDevice) return '';
      const candidateModels = variantDeviceModels(variant);
      return splitDeviceModels(parentDevice).find((model) => candidateModels.some((candidate) => deviceModelMatches(candidate, model))) || '';
    };
    const variantMatchesParentDevice = (variant) => {
      const parentDevice = state.selectedOptions[0];
      return !parentDevice || !!matchedParentDeviceModel(variant);
    };
    const addonVariantSubtitle = (item) => {
      const selectedAccents = isAccentPackAddon(item) ? accentSelectedVariants(item) : [];
      if (selectedAccents.length > 1) return `${selectedAccents.length} colors selected`;
      const displayVariant = selectedAccents[0] || item.variant;
      const label = bundleVariantMeta(item.bundle, item.product, displayVariant, item.config);
      const optionValues = (displayVariant?.options || []).filter(Boolean);
      if (isAccentPackAddon(item) && optionValues.length > 1) {
        const firstValue = String(optionValues[0]).trim();
        if (optionValues.every((value) => normalizeColorLabel(value) === normalizeColorLabel(firstValue))) {
          return firstValue;
        }
      }
      if (isDeviceLockedAddon(item) && item.deviceAutoMatched && deviceModelSeparator.test(label)) {
        // A multi-model addon label ("11 & 11 Pro") is narrowed to the model the
        // shopper actually picked -- but only when they picked one. If the parent
        // variant spans models too, there is nothing to narrow to and the first
        // half would be shown alone ("Pixel 11"), under-describing what ships.
        const parentModels = splitDeviceModels(state.selectedOptions[0] || '');
        if (parentModels.length === 1) return matchedParentDeviceModel(displayVariant) || label;
        return label;
      }
      return label;
    };
    const PLATFORM_TERMS = {
      apple: /\b(apple|iphone|ipad|ios|find ?my|findmy|airpods|mac)\b/i,
      android: /\b(android|samsung|galaxy|pixel|google|find ?hub|wear ?os)\b/i,
    };
    const valuePlatform = (value) => {
      const text = String(value || '');
      if (PLATFORM_TERMS.apple.test(text)) return 'apple';
      if (PLATFORM_TERMS.android.test(text)) return 'android';
      return '';
    };
    // For an upsell's own option values, a value that names both platforms
    // ("Apple & Android") is cross-platform and must survive on either parent.
    // valuePlatform tests Apple first, so without this it read as apple-only and
    // the consolidated wallet tier vanished from every Android PDP.
    const upsellValuePlatform = (value) => {
      const text = String(value || '');
      const isApple = PLATFORM_TERMS.apple.test(text);
      const isAndroid = PLATFORM_TERMS.android.test(text);
      if (isApple && isAndroid) return '';
      if (isApple) return 'apple';
      if (isAndroid) return 'android';
      return '';
    };
    const parentPlatform = () => {
      for (const value of (state.selectedOptions || [])) {
        const platform = valuePlatform(value);
        if (platform) return platform;
      }
      return valuePlatform(`${product.title || ''} ${product.handle || ''}`);
    };
    const filterUpsellVariantsByPlatform = (productInfo, variants) => {
      const platform = parentPlatform();
      if (!platform) return variants;
      const optionNames = productInfo?.options || [];
      let nextVariants = variants;
      optionNames.forEach((optionName, optionIndex) => {
        const values = Array.from(new Set(nextVariants.map((variant) => variant.options?.[optionIndex]).filter(Boolean)));
        const platformsPresent = Array.from(new Set(values.map(upsellValuePlatform).filter(Boolean)));
        if (!platformsPresent.length) return; // not a platform-keyed option
        const filtered = nextVariants.filter((variant) => {
          const vp = upsellValuePlatform(variant.options?.[optionIndex]);
          return vp === platform || vp === ''; // keep this platform + neutral ("No Tracking", "Apple & Android")
        });
        if (filtered.length) nextVariants = filtered;
      });
      return nextVariants;
    };
    const fallbackSwatchColor = (value) => {
      const v = String(value || '').toLowerCase();
      if (v.includes('black')) return '#111416';
      if (v.includes('white')) return '#f4f5f6';
      if (v.includes('clear')) return '#faf9ef';
      if (v.includes('brown')) return '#7a4d34';
      if (v.includes('tan')) return '#c8a77e';
      if (v.includes('beige')) return '#e6dcc7';
      if (v.includes('gold')) return '#d7bf84';
      if (v.includes('red')) return '#F61F1F';
      if (v.includes('blue')) return '#508bc1';
      if (v.includes('lime')) return '#88EF01';
      if (v.includes('olive')) return '#228b22';
      if (v.includes('green')) return '#228b22';
      if (v.includes('orange')) return '#FF8A00';
      if (v.includes('pink')) return '#f5a8bd';
      if (v.includes('purple')) return '#7054a8';
      if (v.includes('gray') || v.includes('grey')) return '#e2e2e2';
      return '#d8dadd';
    };
    const twoToneSwatchStyle = (value) => {
      const parts = String(value || '').split('/').map((part) => part.trim()).filter(Boolean);
      if (parts.length < 2) return '';
      const first = fallbackSwatchColor(parts[0]);
      const second = fallbackSwatchColor(parts[1]);
      return `--swatch: ${first}; --swatch-bg: linear-gradient(135deg, ${first} 0 calc(50% - 0.05rem), rgba(255, 255, 255, 0.88) calc(50% - 0.05rem), rgba(255, 255, 255, 0.88) calc(50% + 0.05rem), ${second} calc(50% + 0.05rem) 100%);`;
    };
    const swatchSoldOutMarker = (value) => {
      const v = String(value || '').toLowerCase();
      let line = '#5f6770';
      let edge = 'rgba(255, 255, 255, 0.78)';
      if (v.includes('black') || v.includes('midnight') || v.includes('nappa') || v.includes('green') || v.includes('blue') || v.includes('purple') || v.includes('red') || v.includes('brown') || v.includes('dark gray') || v.includes('dark grey')) {
        line = '#d6dade';
        edge = 'rgba(0, 0, 0, 0.38)';
      }
      return `--swatch-oos-line: ${line}; --swatch-oos-line-edge: ${edge};`;
    };
    const swatchStyle = (item, optionName, value) => {
      const swatch = item.bundle.swatches?.[optionName]?.[value];
      const image = swatch?.image?.src || swatch?.image?.url || (typeof swatch?.image === 'string' ? swatch.image : '');
      const soldOutMarker = swatchSoldOutMarker(value);
      const twoTone = twoToneSwatchStyle(value);
      if (twoTone) return `${twoTone} ${soldOutMarker}`;
      if (image) return `background-image: url('${escapeHTML(image)}'); ${soldOutMarker}`;
      return `--swatch: ${escapeHTML(swatch?.color || fallbackSwatchColor(value))}; ${soldOutMarker}`;
    };
    const bundleValuesForLevel = (item, optionIndex, selectedValues) => {
      return Array.from(new Set(item.variantChoices.filter((variant) => {
        return selectedValues.slice(0, optionIndex).every((value, index) => !value || variant.options?.[index] === value);
      }).map((variant) => variant.options?.[optionIndex]).filter(Boolean)));
    };
    const nearestBundleVariant = (item, nextOptions) => {
      return item.variantChoices.find((variant) => nextOptions.every((value, index) => !value || variant.options?.[index] === value))
        || item.variantChoices.find((variant) => nextOptions.slice(0, -1).every((value, index) => !value || variant.options?.[index] === value))
        || item.variantChoices[0];
    };
    const variantOptionControls = (item, addonIndex) => {
      if (item.variantChoices.length < 2) return '';
      if (isDeviceLockedAddon(item) && item.deviceAutoMatched) return '';
      const optionNames = item.product.options || [];
      const selectedValues = item.variant.options || [];
      const linkedIndexes = visualOptionIndexes(item);
      const linkedValues = linkedColorValues(item, linkedIndexes);
      const accentSelectionCleared = isAccentPackAddon(item)
        && state.accentSelectionCleared[String(item.bundle.id)] === true;
      const selectedAccentIds = new Set(accentVariantIds(item).map(String));

      if (isTeslaChargerAddon(item)) {
        const controls = optionNames.map((optionName, optionIndex) => {
          const values = bundleValuesForLevel(item, optionIndex, selectedValues);
          if (values.length < 2) return '';
          const label = escapeHTML(bundleOptionDisplayName(optionName));
          const options = values.map((value) => {
            const optionValue = escapeAttribute(value);
            const selected = selectedValues[optionIndex] === value ? ' selected' : '';
            return `<option value="${optionValue}"${selected}>${escapeHTML(value)}</option>`;
          }).join('');

          return `
            <span class="mb-clean-addons-select">
              <span class="mb-clean-addons-select__label">${label}</span>
              <select
                data-mb-addon-option-select
                data-mb-addon-index="${addonIndex}"
                data-option-index="${optionIndex}"
                aria-label="${label}"
              >${options}</select>
            </span>
          `;
        }).join('');
        return controls ? `
          <span class="mb-clean-addons-options" data-option-type="select">
            <span>${controls}</span>
          </span>
        ` : '';
      }

      if (linkedValues.length > 1) {
        const selectedColor = linkedValues.find((value) => linkedIndexes.every((optionIndex) => selectedValues[optionIndex] === value))
          || selectedValues[linkedIndexes[0]];
        const controls = linkedValues.map((value) => {
          const candidateOptions = [...selectedValues];
          linkedIndexes.forEach((optionIndex) => { candidateOptions[optionIndex] = value; });
          const candidateVariant = nearestBundleVariant(item, candidateOptions);
          const isSelected = !accentSelectionCleared && (isAccentPackAddon(item)
            ? selectedAccentIds.has(String(candidateVariant?.id))
            : selectedColor === value);
          const selected = isSelected ? ' is-selected' : '';
          const buttonLabel = escapeHTML(value);
          const splitTone = String(value || '').includes('/') ? ' mb-clean-addons-choice--split' : '';
          return `
            <button
              type="button"
              class="mb-clean-addons-choice mb-clean-addons-choice--swatch${splitTone}${selected}"
              data-mb-addon-option
              data-mb-addon-index="${addonIndex}"
              data-option-scope="linked-colors"
              data-option-index="${linkedIndexes.join(',')}"
              data-option-value="${buttonLabel}"
              style="${swatchStyle(item, optionNames[linkedIndexes[0]], value)}"
              aria-label="${euDisplayText('Color')}: ${escapeHTML(euDisplayText(value))}"
              aria-pressed="${isSelected}"
            ><span>${escapeHTML(euDisplayText(value))}</span></button>
          `;
        }).join('');

        return `
          <span class="mb-clean-addons-options" data-option-type="swatch">
            <span>${controls}</span>
          </span>
        `;
      }

      return optionNames.map((optionName, optionIndex) => {
        const values = bundleValuesForLevel(item, optionIndex, selectedValues);
        if (values.length < 2) return '';

        const visual = looksVisualOption(optionName, values, item.bundle.swatches);
        const controls = values.map((value) => {
          const candidateOptions = [...selectedValues];
          candidateOptions[optionIndex] = value;
          const candidateVariant = nearestBundleVariant(item, candidateOptions);
          const isSelected = !accentSelectionCleared && (isAccentPackAddon(item)
            ? selectedAccentIds.has(String(candidateVariant?.id))
            : selectedValues[optionIndex] === value);
          const selected = isSelected ? ' is-selected' : '';
          const buttonLabel = escapeHTML(value);
          if (visual) {
            const splitTone = String(value || '').includes('/') ? ' mb-clean-addons-choice--split' : '';
            return `
              <button
                type="button"
                class="mb-clean-addons-choice mb-clean-addons-choice--swatch${splitTone}${selected}"
                data-mb-addon-option
                data-mb-addon-index="${addonIndex}"
                data-option-index="${optionIndex}"
                data-option-value="${buttonLabel}"
                style="${swatchStyle(item, optionName, value)}"
                aria-label="${escapeHTML(euDisplayText(optionName))}: ${escapeHTML(euDisplayText(value))}"
                aria-pressed="${isSelected}"
              ><span>${escapeHTML(euDisplayText(value))}</span></button>
            `;
          }

          return `
            <button
              type="button"
              class="mb-clean-addons-choice mb-clean-addons-choice--pill${selected}"
              data-mb-addon-option
              data-mb-addon-index="${addonIndex}"
              data-option-index="${optionIndex}"
              data-option-value="${buttonLabel}"
              aria-pressed="${isSelected}"
            >${escapeHTML(euDisplayText(value))}</button>
          `;
        }).join('');

        return `
          <span class="mb-clean-addons-options" data-option-type="${visual ? 'swatch' : 'pill'}">
            <span>${controls}</span>
          </span>
        `;
      }).join('');
    };
    const mediaPreviewSrc = (media) => cleanUrl(media?.src || media?.preview_image?.src || media?.preview_image?.url || media?.image?.src);
    const isMobileGallery = () => window.matchMedia?.('(max-width: 749px)').matches;
    const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    function centerMobileGalleryThumb(thumb, behavior = 'auto') {
      if (!isMobileGallery() || !thumbRail?.contains(thumb) || thumbRail.clientWidth <= 0 || thumb.offsetWidth <= 0) return;
      const maxLeft = Math.max(0, thumbRail.scrollWidth - thumbRail.clientWidth);
      const left = Math.max(0, Math.min(maxLeft, thumb.offsetLeft - ((thumbRail.clientWidth - thumb.offsetWidth) / 2)));
      if (Math.abs(thumbRail.scrollLeft - left) < 0.5) return;
      thumbRail.scrollTo({ left, behavior });
    }

    function requestMobileGallerySelectedThumbCenter() {
      if (state.mobileGalleryThumbCenterRaf) return;
      state.mobileGalleryThumbCenterRaf = window.requestAnimationFrame(() => {
        state.mobileGalleryThumbCenterRaf = null;
        centerMobileGalleryThumb(thumbRail?.querySelector('.mb-clean-gallery__thumb.is-selected'), 'auto');
        updateGalleryScrollIndicators();
      });
    }

    function setMobileGalleryProgress(progress) {
      const nextProgress = Math.max(0, Math.min(1, progress));
      const progressChanged = Math.abs(nextProgress - state.mobileGalleryProgress) >= 0.0005;
      const thumbWidth = 6.8 - (1.6 * nextProgress);
      const thumbHeight = 5.8 - (1.2 * nextProgress);
      const rem = state.cssRem || 10;
      let railBoxHeight = 7.2;
      if (
        Number.isFinite(state.mobileGalleryBuyboxTop)
        && Number.isFinite(state.mobileGalleryViewportTop)
        && Number.isFinite(state.mobileGalleryWidth)
      ) {
        const compactHeight = Math.max(0, (window.innerWidth * 0.55) - (1.32 * rem));
        const visualMainHeight = Math.min(
          state.mobileGalleryWidth - ((state.mobileGalleryWidth - compactHeight) * nextProgress),
          39 * rem
        );
        const availableHeight = (
          state.mobileGalleryBuyboxTop
          - state.mobileGalleryViewportTop
          - visualMainHeight
          - (0.4 * rem)
          - (1.6 * rem)
        ) / rem;
        const minimumHeight = thumbHeight + 0.2;
        railBoxHeight = Math.max(minimumHeight, Math.min(7.2, availableHeight));
      }
      state.mobileGalleryProgress = nextProgress;
      root.classList.toggle('is-mobile-gallery-compact', nextProgress > 0.02);
      root.style.setProperty('--mb-mobile-gallery-progress', nextProgress.toFixed(3));
      root.style.setProperty('--mb-mobile-gallery-rail-box-height', `${railBoxHeight.toFixed(3)}rem`);
      root.style.setProperty('--mb-mobile-gallery-thumb-width', `${thumbWidth.toFixed(3)}rem`);
      root.style.setProperty('--mb-mobile-gallery-thumb-height', `${thumbHeight.toFixed(3)}rem`);
      if (progressChanged) requestMobileGallerySelectedThumbCenter();
    }

    function animateMobileGalleryProgress() {
      state.mobileGalleryRaf = null;
      if (prefersReducedMotion()) {
        setMobileGalleryProgress(state.mobileGalleryTargetProgress);
        return;
      }
      const delta = state.mobileGalleryTargetProgress - state.mobileGalleryProgress;
      if (Math.abs(delta) < 0.004) {
        setMobileGalleryProgress(state.mobileGalleryTargetProgress);
        return;
      }
      setMobileGalleryProgress(state.mobileGalleryProgress + (delta * 0.32));
      state.mobileGalleryRaf = window.requestAnimationFrame(animateMobileGalleryProgress);
    }

    function updateMobileGalleryPinState() {
      state.mobileGalleryMeasureRaf = null;
      if (!gallery || !galleryMain) return;
      if (!isMobileGallery()) {
        window.cancelAnimationFrame(state.mobileGalleryThumbCenterRaf);
        state.mobileGalleryThumbCenterRaf = null;
        root.classList.remove('is-mobile-gallery-compact');
        root.style.removeProperty('--mb-mobile-gallery-progress');
        root.style.removeProperty('--mb-mobile-gallery-rail-box-height');
        root.style.removeProperty('--mb-mobile-gallery-thumb-width');
        root.style.removeProperty('--mb-mobile-gallery-thumb-height');
        state.mobileGalleryProgress = 0;
        state.mobileGalleryTargetProgress = 0;
        return;
      }

      if (state.cssRem == null) state.cssRem = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 10;
      if (state.galleryStickyTop == null) state.galleryStickyTop = parseFloat(window.getComputedStyle(gallery).top) || galleryMain.getBoundingClientRect().top;
      const rem = state.cssRem;
      const galleryRect = gallery.getBoundingClientRect();
      const fullHeight = Math.min(window.innerWidth - (2.4 * rem), 39 * rem);
      const compactHeight = Math.max(0, (window.innerWidth * 0.55) - (1.32 * rem));
      const shrinkRange = Math.max(1, fullHeight - compactHeight);
      const galleryTop = state.galleryStickyTop;
      const buyboxTop = buybox?.getBoundingClientRect().top || Number.POSITIVE_INFINITY;
      state.mobileGalleryBuyboxTop = buyboxTop;
      state.mobileGalleryViewportTop = galleryRect.top;
      state.mobileGalleryWidth = galleryRect.width;
      const thumbnailPusherTop = buyboxTop - (7.6 * rem);
      const collisionGap = 16;
      const collisionProgress = Math.max(0, Math.min(1, (fullHeight - (thumbnailPusherTop - galleryTop - collisionGap)) / shrinkRange));
      const start = root.offsetTop + 12;
      const distance = 180;
      const scrollProgress = Math.max(0, Math.min(1, (window.scrollY - start) / distance));
      const progress = Math.max(scrollProgress, collisionProgress);
      state.mobileGalleryTargetProgress = progress;
      if (!state.mobileGalleryRaf) {
        state.mobileGalleryRaf = window.requestAnimationFrame(animateMobileGalleryProgress);
      }
    }

    function requestMobileGalleryPinUpdate() {
      if (state.mobileGalleryMeasureRaf) return;
      state.mobileGalleryMeasureRaf = window.requestAnimationFrame(updateMobileGalleryPinState);
    }

    function videoSourcesFromThumb(thumb) {
      try {
        return JSON.parse(thumb?.dataset.videoSources || '[]')
          .filter((source) => source?.url && source?.mime_type)
          .map((source) => ({ ...source, url: cleanUrl(source.url) }));
      } catch (error) {
        return [];
      }
    }

    function videoSourcesFromMedia(media) {
      return (media?.sources || [])
        .filter((source) => source?.url && source?.mime_type)
        .map((source) => ({ ...source, url: cleanUrl(source.url) }));
    }

    function preferredVideoSource(sources) {
      return sources.find((source) => source.mime_type === 'video/mp4' && source.height >= 720)
        || sources.find((source) => source.mime_type === 'video/mp4')
        || sources[0];
    }

    function parseExperimentMediaTag(alt) {
      if (!alt) return null;
      const parts = String(alt).split(/\s*\|\s*/);
      for (const part of parts.slice(1)) {
        const match = part.trim().match(/^exp:([a-z0-9][a-z0-9_-]*):(live|variant)$/i);
        if (match) return { id: match[1].toLowerCase(), side: match[2].toLowerCase() };
      }
      return null;
    }

    function parseMediaAlt(alt) {
      const values = { set: new Set(), experiment: parseExperimentMediaTag(alt), gallery: null };
      if (!alt) return values;
      const parts = String(alt).split(rgxPipeDelimiter);
      const selectors = [];
      parts.slice(1).forEach((part) => {
        const upsellTag = part.trim().match(/^upsell:\s*(.*)$/i);
        if (upsellTag) {
          values.gallery = 'upsell';
          selectors.push(upsellTag[1]);
          return;
        }
        if (/^gallery:upsell$/i.test(part.trim())) {
          values.gallery = 'upsell';
          return;
        }
        if (!part.trim().match(/^exp:([a-z0-9][a-z0-9_-]*):(live|variant)$/i) && part.trim()) {
          selectors.push(part.trim());
        }
      });
      values.csv = selectors.length ? selectors[selectors.length - 1] : undefined;
      values.set = new Set(values.csv ? values.csv.split(rgxCommaDelimiter) : []);
      values.key = (parts[0] || '').trim().toLowerCase().replace(rgxMultiSpace, ' ');
      return values;
    }

    function isUpsellGalleryMedia(media) {
      return parseMediaAlt(media?.alt || media?.dataset?.mediaAlt || '').gallery === 'upsell';
    }

    function cleanAnalyticsValue(value, maxLength = 100) {
      return String(value ?? '').replace(rgxMultiSpace, ' ').trim().slice(0, maxLength);
    }

    function galleryAnalyticsBase() {
      return {
        experiment_id: cleanAnalyticsValue(galleryExperimentId, 40),
        experiment_variant: cleanAnalyticsValue(galleryExperimentVariant, 40),
        experiment_unit_id: galleryExperimentUnitId,
        measurement_session_id: galleryMeasurementSessionId,
        gallery_ui_version: galleryUiVersion,
        product_id: String(product.id || ''),
        product_handle: cleanAnalyticsValue(product.handle, 100),
        product_title: cleanAnalyticsValue(product.title, 100),
        variant_id: String(state.selectedVariant?.id || ''),
        variant_sku: cleanAnalyticsValue(state.selectedVariant?.sku, 100),
        selected_options: cleanAnalyticsValue(displaySelectedOptionSummary(), 100),
      };
    }

    const measurementQueue = [];
    let measurementRetryTimer = null;
    let measurementSequence = 0;
    function flushMeasurementQueue() {
      if (measurementRetryTimer) window.clearTimeout(measurementRetryTimer);
      measurementRetryTimer = null;
      const pending = measurementQueue.splice(0);
      pending.forEach(item => {
        if (Date.now() - item.at > 60000) return;
        if (typeof window.Shopify?.analytics?.publish !== "function") {
          measurementQueue.push(item); return;
        }
        try {
          Promise.resolve(window.Shopify.analytics.publish("magbak_experiments:event", item.detail))
            .catch(() => { measurementQueue.push(item); scheduleMeasurementRetry(); });
        } catch { measurementQueue.push(item); }
      });
      if (measurementQueue.length) scheduleMeasurementRetry();
    }
    function scheduleMeasurementRetry() {
      if (!measurementRetryTimer) measurementRetryTimer = window.setTimeout(flushMeasurementQueue, 250);
    }
    function sendGalleryAnalytics(eventName, params = {}, firstPartyOnly = false) {
      if (!galleryAnalyticsEnabled || (validationCaptureOnly && Date.now() >= validationCaptureEndsAt)) return false;
      if (validationCaptureOnly) firstPartyOnly = true;
      const detail = {...galleryAnalyticsBase(), ...params, instrumentation_version: validationCaptureOnly ? "accuracy_v2_validation" : "accuracy_v2",
        atc_attempt_id: params.atc_attempt_id || state.atcAttemptId || "",
        measurement_event_id: galleryMeasurementSessionId + ":" + performance.timeOrigin + ":" + (++measurementSequence),
        measurement_occurred_at: new Date().toISOString()};
      if (!firstPartyOnly) document.dispatchEvent(new CustomEvent(`mb:${eventName}`, {detail}));
      if (!galleryAnalyticsProduction) return false;
      if (measurementQueue.length < 200) {
        measurementQueue.push({at:Date.now(),detail:{event_name:eventName,...detail}});
        flushMeasurementQueue();
      }
      if (!firstPartyOnly) {
        window.dataLayer = window.dataLayer || [];
        if (typeof window.gtag === "function") window.gtag("event",eventName,{...detail,send_to:"G-PX9LQSC0QQ"});
        else window.dataLayer.push({event:eventName,...detail});
      }
      return true;
    }
    const experimentAssignmentParams = {
      assigned_variant: cleanAnalyticsValue(galleryExperimentVariant, 40),
      experiment_surface: 'pdp_gallery',
      tracking_config_version: hasManagedTrackingConfig ? managedTrackingConfig.version : 0,
    };

    function queueExperimentAssignmentRetry() {
      if (
        !galleryAnalyticsProduction
        || state.experimentAssignmentPublished
        || state.experimentAssignmentRetryTimer
        || state.experimentAssignmentRetries >= 20
      ) return;
      state.experimentAssignmentRetries += 1;
      state.experimentAssignmentRetryTimer = window.setTimeout(() => {
        state.experimentAssignmentRetryTimer = null;
        publishExperimentAssignment(true);
      }, 250);
    }

    function publishExperimentAssignment(firstPartyOnly = false) {
      if (galleryExperimentId === 'no_experiment' || state.experimentAssignmentPublished) return;
      state.experimentAssignmentPublished = sendGalleryAnalytics(
        'experiment_assignment',
        experimentAssignmentParams,
        firstPartyOnly
      );
      if (!state.experimentAssignmentPublished) queueExperimentAssignmentRetry();
    }

    if (galleryExperimentId !== 'no_experiment') {
      publishExperimentAssignment();
    }

    function analyticsOptionCategory(name, index) {
      const normalized = String(name || '').toLowerCase();
      if (/device|phone/.test(normalized)) return 'device';
      if (/case|style|model/.test(normalized) && !/device|phone/.test(normalized)) return 'case_model';
      if (/colou?r|finish/.test(normalized)) return index === analyticsColorOptionIndex ? 'base_color' : 'color';
      return `option_${index + 1}`;
    }

    function analyticsConfiguration() {
      const configured = {
        configured_device: 'not_set',
        configured_case_model: 'not_set',
        configured_base_color: 'not_set',
        accent_count: 0,
        addon_count: 0,
      };
      productOptions.forEach((name, index) => {
        const category = analyticsOptionCategory(name, index);
        const selectedValue = state.pairedOfferSelected && index === pairedOfferOptionIndex
          ? pairedOfferConfig.label
          : state.selectedOptions[index];
        const value = cleanAnalyticsValue(selectedValue || 'not_set', 60);
        if (category === 'device') configured.configured_device = value;
        else if (category === 'case_model') configured.configured_case_model = value;
        else if (category === 'base_color' || (category === 'color' && configured.configured_base_color === 'not_set')) {
          configured.configured_base_color = value;
        }
      });
      try {
        const entries = selectedPurchasableEntries();
        configured.addon_count = entries.filter((entry) => !entry.item.included).length;
        configured.accent_count = entries.filter((entry) => isAccentPackAddon(entry.item)).length;
      } catch (error) {
        // Bundle data can still be loading during the first gallery exposure.
      }
      return configured;
    }

    function trackConfigurationChange(optionType, previousValue, nextValue, available = true, source = 'product_option') {
      if (available) return;
      sendGalleryAnalytics('pdp_option_change', {
        option_type: cleanAnalyticsValue(optionType, 40),
        option_previous: cleanAnalyticsValue(previousValue || 'not_set', 60),
        option_value: cleanAnalyticsValue(nextValue || 'not_set', 60),
        selection_available: available ? 'available' : 'unavailable',
        selection_source: cleanAnalyticsValue(source, 32),
        time_to_selection_ms: Math.max(0, Math.round(performance.now())),
        ...analyticsConfiguration(),
      });
    }

    function trackExperimentExposure(visibleThumbs) {
      if (state.experimentExposureSent || galleryExperimentId === 'no_experiment') return;
      state.experimentExposureSent = true;
      const renderedVariant = root.dataset.mbGalleryVariant || galleryExperimentVariant;
      publishExperimentAssignment(true);
      sendGalleryAnalytics('experiment_exposure', {
        assigned_variant: cleanAnalyticsValue(galleryExperimentVariant, 40),
        rendered_variant: cleanAnalyticsValue(renderedVariant, 40),
        experiment_surface: 'pdp_gallery',
        eligible_media_count: visibleThumbs.length,
        media_fallback_used: state.galleryFallbackUsed ? 'yes' : 'no',
        tracking_config_version: hasManagedTrackingConfig ? managedTrackingConfig.version : 0,
      });
      if (renderedVariant !== galleryExperimentVariant || state.galleryFallbackUsed) {
        sendGalleryAnalytics('experiment_integrity', {
          assigned_variant: cleanAnalyticsValue(galleryExperimentVariant, 40),
          rendered_variant: cleanAnalyticsValue(renderedVariant, 40),
          integrity_status: renderedVariant !== galleryExperimentVariant ? 'variant_mismatch' : 'media_fallback',
          eligible_media_count: visibleThumbs.length,
        });
      }
    }

    function setGalleryVisibleTiming(visible) {
      const shouldCount = visible && !document.hidden;
      if (shouldCount && state.galleryVisibleStartedAt === null) {
        state.galleryVisibleStartedAt = performance.now();
      } else if (!shouldCount && state.galleryVisibleStartedAt !== null) {
        state.galleryVisibleMs += Math.max(0, performance.now() - state.galleryVisibleStartedAt);
        state.galleryVisibleStartedAt = null;
      }
    }

    function currentGalleryVisibleMs() {
      return Math.round(state.galleryVisibleMs + (state.galleryVisibleStartedAt === null
        ? 0
        : Math.max(0, performance.now() - state.galleryVisibleStartedAt)));
    }

    function currentLightboxVisibleMs() {
      return Math.round(state.lightboxVisibleMs + (state.lightboxOpenedAt === null
        ? 0
        : Math.max(0, performance.now() - state.lightboxOpenedAt)));
    }

    function trackGallerySummary() {
      if (state.gallerySummarySent || !state.galleryExposureTracked) return;
      state.gallerySummarySent = true;
      setGalleryVisibleTiming(false);
      sendGalleryAnalytics('pdp_gallery_summary', {
        unique_media_count: state.galleryViewedMedia.size,
        furthest_media_position: state.galleryFurthestPosition,
        gallery_interaction_count: state.galleryInteractionCount,
        first_interaction_ms: state.galleryFirstInteractionAt === null ? 0 : Math.round(state.galleryFirstInteractionAt),
        gallery_visible_ms: currentGalleryVisibleMs(),
        lightbox_visible_ms: currentLightboxVisibleMs(),
        zoomed_media_count: state.zoomedMedia.size,
        video_start_count: state.videoStarts,
        video_watch_seconds: Math.round(state.videoWatchSeconds),
        media_fallback_used: state.galleryFallbackUsed ? 'yes' : 'no',
        ...analyticsConfiguration(),
        transport_type: 'beacon',
      });
    }

    function webVitalRating(name, value) {
      if (name === 'LCP') return value <= 2500 ? 'good' : value <= 4000 ? 'needs_improvement' : 'poor';
      if (name === 'INP') return value <= 200 ? 'good' : value <= 500 ? 'needs_improvement' : 'poor';
      return value <= 0.1 ? 'good' : value <= 0.25 ? 'needs_improvement' : 'poor';
    }

    function sendWebVitals() {
      if (state.webVitalsSent || !state.galleryExposureTracked) return;
      state.webVitalsSent = true;
      [['LCP', state.webVitals.lcp], ['INP', state.webVitals.inp], ['CLS', state.webVitals.cls]].forEach(([name, value]) => {
        if (typeof value !== 'number' || !Number.isFinite(value)) return;
        sendGalleryAnalytics('pdp_web_vital', {
          web_vital_name: name,
          web_vital_rating: webVitalRating(name, value),
          web_vital_value: Number(value.toFixed(name === 'CLS' ? 3 : 0)),
          transport_type: 'beacon',
        });
      });
    }

    function videoAnalyticsParams(video, tracker, percent = 0) {
      const list = visibleGalleryThumbs();
      const position = Math.max(0, list.indexOf(tracker.thumb)) + 1;
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      return {
        media_id: String(tracker.thumb?.dataset.mediaId || ''),
        media_position: position,
        media_type: 'video',
        media_label: cleanAnalyticsValue(parseMediaAlt(tracker.thumb?.dataset.mediaAlt).key, 100),
        video_title: cleanAnalyticsValue(parseMediaAlt(tracker.thumb?.dataset.mediaAlt).key || product.title, 100),
        video_provider: 'shopify',
        video_duration: Math.round(duration),
        video_current_time: Math.round(video.currentTime || 0),
        video_percent: Math.round(percent),
        video_context: tracker.context,
        play_trigger: tracker.trigger,
        video_muted: video.muted ? 'yes' : 'no',
        visible: !document.hidden,
        meaningful_watch_threshold_seconds: 7,
      };
    }

    function prepareGalleryVideo(video, thumb, context, trigger = 'autoplay') {
      if (!video || !thumb) return;
      const key = `${thumb.dataset.mediaId || galleryMediaKey(thumb)}:${context}`;
      let tracker = state.videoAnalytics.get(key);
      if (!tracker) {
        tracker = {
          key,
          thumb,
          context,
          trigger,
          started: false,
          engaged: false,
          completed: false,
          watchedSeconds: 0,
          lastTime: null,
          requestedAt: performance.now(),
        };
        state.videoAnalytics.set(key, tracker);
      } else {
        tracker.thumb = thumb;
        tracker.context = context;
        tracker.trigger = trigger;
        tracker.requestedAt = performance.now();
      }
      video._mbAnalyticsTracker = tracker;
      if (video.dataset.mbAnalyticsBound === 'true') return;
      video.dataset.mbAnalyticsBound = 'true';

      video.addEventListener('playing', () => {
        const active = video._mbAnalyticsTracker;
        if (!active) return;
        active.lastTime = video.currentTime || 0;
        if (active.started) return;
        active.started = true;
        state.videoStarts += 1;
        sendGalleryAnalytics('video_start', {
          ...videoAnalyticsParams(video, active, 0),
          video_start_latency_ms: Math.max(0, Math.round(performance.now() - active.requestedAt)),
        });
      });

      video.addEventListener('timeupdate', () => {
        const active = video._mbAnalyticsTracker;
        if (!active || video.paused) return;
        const currentTime = video.currentTime || 0;
        if (!document.hidden && video.getBoundingClientRect().bottom > 0 && video.getBoundingClientRect().top < window.innerHeight && video.getBoundingClientRect().width > 0 && active.lastTime !== null) {
          const delta = currentTime - active.lastTime;
          if (delta > 0 && delta < 2) {
            active.watchedSeconds += delta;
            state.videoWatchSeconds += delta;
          }
        }
        active.lastTime = currentTime;
        const percent = Number.isFinite(video.duration) && video.duration > 0 ? (currentTime / video.duration) * 100 : 0;
        if (!active.engaged && active.watchedSeconds >= 7) {
          active.engaged = true;
          sendGalleryAnalytics('pdp_video_meaningful_watch_7s', videoAnalyticsParams(video, active, percent));
        }
        if (percent >= 98 && !active.completed) {
          active.completed = true;
          sendGalleryAnalytics('video_complete', videoAnalyticsParams(video, active, 100));
        }
      });

      video.addEventListener('pause', () => {
        const active = video._mbAnalyticsTracker;
        if (active) active.lastTime = null;
      });
      video.addEventListener('ended', () => {
        const active = video._mbAnalyticsTracker;
        if (!active) return;
        active.started = false;
        active.engaged = false;
        active.completed = false;
        active.watchedSeconds = 0;
        active.lastTime = null;
      });
      video.addEventListener('error', () => {
        const active = video._mbAnalyticsTracker;
        if (!active) return;
        sendGalleryAnalytics('pdp_video_error', {
          ...videoAnalyticsParams(video, active, 0),
          video_error_code: String(video.error?.code || 0),
        });
      });
    }

    window.addEventListener('pageshow', event => {
      if (event.persisted) { state.webVitalsSent=false; state.webVitals={lcp:null,inp:null,cls:null}; }
    });
    function startGalleryDiagnostics() {
      if (!galleryAnalyticsEnabled || !galleryMain) return;
      if ('IntersectionObserver' in window) {
        state.galleryEngagementObserver = new IntersectionObserver((entries) => {
          state.galleryInViewport = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5);
          setGalleryVisibleTiming(state.galleryInViewport);
        }, { threshold: 0.5 });
        state.galleryEngagementObserver.observe(galleryMain);
      }
        if (!window.mbPdpVitalsBound && window.webVitals) {
          window.mbPdpVitalsBound = true;
          const record = metric => {
            state.webVitals[metric.name.toLowerCase()] = metric.value;
          };
          window.webVitals.onLCP(record, {reportAllChanges:true});
          window.webVitals.onINP(record, {reportAllChanges:true});
          window.webVitals.onCLS(record, {reportAllChanges:true});
        }
      root.querySelectorAll('[data-mb-find-phone]').forEach((helper) => {
        helper.addEventListener('toggle', () => {
          if (!helper.open) return;
          sendGalleryAnalytics('pdp_help_open', {
            help_topic: helper.dataset.mbFindPhoneFamily?.includes('tesla') ? 'screen_compatibility' : 'device_compatibility',
          });
        });
      });
      document.addEventListener('visibilitychange', () => setGalleryVisibleTiming(state.galleryInViewport));
      window.addEventListener('pagehide', () => {
        trackGallerySummary();
        sendWebVitals();
      });
    }

    function setGalleryAnalyticsUserProperties() {
      if (validationCaptureOnly || !galleryAnalyticsEnabled || !galleryAnalyticsProduction) return;
      window.dataLayer = window.dataLayer || [];
      const userProperties = {
        mb_gallery_experiment: cleanAnalyticsValue(galleryExperimentId, 36),
        mb_gallery_variant: cleanAnalyticsValue(galleryExperimentVariant, 36),
        mb_pdp_product: cleanAnalyticsValue(product.handle, 36),
      };
      if (typeof window.gtag === 'function') {
        window.gtag('set', 'user_properties', userProperties);
        return;
      }
      window.dataLayer.push(userProperties);
    }

    function galleryMediaKey(thumb) {
      return [
        thumb?.dataset.mediaId || '',
        thumb?.dataset.currentImage || thumb?.dataset.image || thumb?.dataset.originalImage || '',
      ].join(':');
    }

    function galleryMediaParams(thumb, visibleThumbs, interactionMethod, mediaChanged = true) {
      const list = visibleThumbs?.length ? visibleThumbs : visibleGalleryThumbs();
      const index = Math.max(0, list.indexOf(thumb));
      const asset = thumb?.dataset.currentImage || thumb?.dataset.image || thumb?.dataset.originalImage || '';
      let assetName = '';
      try {
        assetName = new URL(asset, window.location.origin).pathname.split('/').pop() || '';
      } catch (error) {
        assetName = asset.split('/').pop() || '';
      }
      return {
        interaction_method: interactionMethod,
        media_id: String(thumb?.dataset.mediaId || ''),
        media_position: index + 1,
        media_count: list.length,
        media_type: cleanAnalyticsValue(thumb?.dataset.mediaType || 'image', 24),
        media_label: cleanAnalyticsValue(parseMediaAlt(thumb?.dataset.mediaAlt).key, 100),
        media_asset: cleanAnalyticsValue(assetName, 100),
        media_changed: mediaChanged ? 1 : 0,
        unique_media_count: state.galleryViewedMedia.size,
        gallery_interaction_count: state.galleryInteractionCount,
      };
    }

    function trackGalleryMediaView(thumb, visibleThumbs, interactionMethod, mediaChanged = true) {
      if (!galleryAnalyticsEnabled || !thumb) return;
      if (interactionMethod !== 'initial') {
        state.galleryInteractionCount += 1;
        if (state.galleryFirstInteractionAt === null) state.galleryFirstInteractionAt = performance.now();
      }
      state.galleryLastInteraction = interactionMethod;
      state.galleryViewedMedia.add(galleryMediaKey(thumb));
      state.galleryFurthestPosition = Math.max(
        state.galleryFurthestPosition,
        Math.max(0, (visibleThumbs || []).indexOf(thumb)) + 1
      );
      sendGalleryAnalytics('pdp_gallery_media_view', galleryMediaParams(
        thumb,
        visibleThumbs,
        interactionMethod,
        mediaChanged
      ));
      if (interactionMethod !== 'initial') {
        sendGalleryAnalytics('pdp_gallery_interaction', galleryMediaParams(
          thumb,
          visibleThumbs,
          interactionMethod,
          mediaChanged
        ));
      }
    }

    function trackGalleryExposure() {
      if (!galleryAnalyticsEnabled || state.galleryExposureTracked) return;
      state.galleryExposureTracked = true;
      state.galleryAnalyticsObserver?.disconnect();
      setGalleryAnalyticsUserProperties();
      const visibleThumbs = visibleGalleryThumbs();
      const selectedThumb = visibleThumbs.find((thumb) => thumb.classList.contains('is-selected')) || visibleThumbs[0];
      if (selectedThumb) state.galleryViewedMedia.add(galleryMediaKey(selectedThumb));
      sendGalleryAnalytics('pdp_gallery_view', galleryMediaParams(selectedThumb, visibleThumbs, 'initial'));
      trackGalleryMediaView(selectedThumb, visibleThumbs, 'initial');
      trackExperimentExposure(visibleThumbs);
    }

    function startGalleryAnalytics() {
      if (!galleryAnalyticsEnabled || !galleryMain) return;
      if (!('IntersectionObserver' in window)) {
        window.requestAnimationFrame(trackGalleryExposure);
        return;
      }
      state.galleryAnalyticsObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) {
          trackGalleryExposure();
        }
      }, { threshold: 0.5 });
      state.galleryAnalyticsObserver.observe(galleryMain);
    }

    function prepareGalleryAddToCart(quantity, items, cartGroup, context) {
      const visibleThumbs = visibleGalleryThumbs();
      const selectedThumb = visibleThumbs.find((thumb) => thumb.classList.contains('is-selected')) || visibleThumbs[0];
      const galleryParams = {
        ...galleryMediaParams(selectedThumb, visibleThumbs, state.galleryLastInteraction),
        quantity, cart_item_count: items.length,
        unique_media_count: state.galleryViewedMedia.size,
        gallery_interaction_count: state.galleryInteractionCount,
        ...context,
      };
      const configurationParams = {
        quantity, cart_item_count: items.length, cart_group_id: cartGroup,
        eligible_upsell_keys: eligibleUpsellKeys().join(','),
        ...context,
      };
      return () => {
        sendGalleryAnalytics('pdp_gallery_atc_context', galleryParams);
        sendGalleryAnalytics('pdp_configuration_atc', configurationParams);
      };
    }

    function mediaAltSkus(alt) {
      return [...parseMediaAlt(alt).set];
    }

    function mediaExperimentTag(media) {
      return parseMediaAlt(media?.alt || media?.dataset?.mediaAlt || '').experiment;
    }

    function experimentMediaVisibility(tag, experimentId, experimentVariant) {
      if (!tag) return true;
      if (tag.id !== String(experimentId || '').toLowerCase()) return tag.side === 'live';
      return tag.side === experimentVariant;
    }

    function mediaEligibleForExperiment(media) {
      return experimentMediaVisibility(
        mediaExperimentTag(media),
        galleryExperimentId,
        galleryExperimentVariant
      );
    }

    function mediaIsLiveFallback(media) {
      const tag = mediaExperimentTag(media);
      return !tag || tag.side === 'live';
    }

    function mediaMatchesSku(media, sku, id) {
      if (!sku) return true;
      const alt = media?.alt || media?.dataset?.mediaAlt || '';
      if (!alt) return true;
      const parts = mediaAltSkus(alt);
      if (!parts.length) return true;
      const negatives = parts.filter((part) => part.startsWith('!'));
      if (negatives.length) return !new Set(parts).has(`!${sku}`);
      const positives = new Set(parts);
      return positives.has(sku) || positives.has(String(id));
    }

    function mediaHasPositiveMatch(media, sku, id) {
      if (!sku) return false;
      const alt = media?.alt || media?.dataset?.mediaAlt || '';
      const parts = mediaAltSkus(alt).filter((part) => !part.startsWith('!'));
      if (!parts.length) return false;
      const positives = new Set(parts);
      return positives.has(sku) || positives.has(String(id));
    }

    function normalizedMediaSku(value) {
      return String(value || '').trim().toUpperCase();
    }

    function variantSkuAliases(variant) {
      const sku = normalizedMediaSku(variant?.sku);
      if (!sku) return [];
      const aliases = [sku];
      const parts = sku.split('-').filter(Boolean);
      const accentIndex = parts.indexOf('ACU');
      if (accentIndex >= 0 && parts.length > accentIndex + 1) {
        aliases.push(`ACU-${parts[parts.length - 1]}`);
      }
      return [...new Set(aliases)];
    }

    function mainProductVariantSelectors() {
      if (mainProductVariantSelectors.cache) return mainProductVariantSelectors.cache;
      const selectors = new Set();
      productVariants.forEach((variant) => {
        const sku = normalizedMediaSku(variant?.sku);
        if (sku) selectors.add(sku);
        if (variant?.id != null) selectors.add(String(variant.id));
      });
      mainProductVariantSelectors.cache = selectors;
      return mainProductVariantSelectors.cache;
    }

    function mainProductMediaProfile(media) {
      const selectors = mainProductVariantSelectors();
      const tokens = mediaAltSkus(media?.alt || media?.dataset?.mediaAlt || '')
        .map((token) => String(token || '').trim())
        .filter(Boolean);
      const positives = tokens.filter((token) => !token.startsWith('!'));
      const caseSelectors = positives.filter((token) => selectors.has(normalizedMediaSku(token)) || selectors.has(token));
      const externalSelectors = positives.filter((token) => !selectors.has(normalizedMediaSku(token)) && !selectors.has(token));
      return { caseSelectors, externalSelectors };
    }

    function isMainProductAccentMedia(media) {
      if (!usesMainProductAccentMedia) return false;
      return mainProductMediaProfile(media).externalSelectors.length > 0;
    }

    function mediaMatchesSelectedMainVariant(media) {
      const profile = mainProductMediaProfile(media);
      if (!profile.caseSelectors.length) return false;
      const sku = normalizedMediaSku(state.selectedVariant?.sku);
      const id = String(state.selectedVariant?.id || '');
      return profile.caseSelectors.some((selector) => {
        return normalizedMediaSku(selector) === sku || String(selector) === id;
      });
    }

    function mainProductAccentMediaByKey(accentVariant) {
      const map = {};
      if (!usesMainProductAccentMedia || !accentVariant) return map;
      const accentSelectors = new Set([
        ...variantSkuAliases(accentVariant),
        String(accentVariant.id || ''),
      ].filter(Boolean));

      mediaItems.forEach((media) => {
        if (isUpsellGalleryMedia(media) || !isMainProductAccentMedia(media) || !mediaMatchesSelectedMainVariant(media)) return;
        const values = parseMediaAlt(media.alt);
        if (!values.key) return;
        const profile = mainProductMediaProfile(media);
        const matchesAccent = profile.externalSelectors.some((selector) => {
          return accentSelectors.has(normalizedMediaSku(selector)) || accentSelectors.has(String(selector));
        });
        if (!matchesAccent) return;
        if (!map[values.key]) map[values.key] = [];
        map[values.key].push({ ...values, media });
      });
      return map;
    }

    function deviceProfileFromText(value) {
      const text = String(value || '').toLowerCase()
        .replace(/iphone\s*(\d+)/g, 'iphone $1')
        .replace(/\bi(\d{2})(?=[a-z0-9_-])/g, 'iphone $1 ')
        .replace(/pixel\s*(\d+)/g, 'pixel $1')
        .replace(/\bs(\d{2})(?=[a-z0-9_-])/g, 's $1 ');
      const profile = { family: '', generation: '', modifiers: [] };

      if (/iphone/.test(text)) {
        profile.family = 'iphone';
        profile.generation = (text.match(/iphone\D*(\d{1,2})/) || [])[1] || '';
      } else if (/pixel/.test(text)) {
        profile.family = 'pixel';
        profile.generation = (text.match(/pixel\D*(\d{1,2})/) || [])[1] || '';
      } else if (/(samsung|galaxy|\bs\s*\d{2}\b)/.test(text)) {
        profile.family = 'samsung';
        profile.generation = (text.match(/(?:galaxy|samsung)?\D*s?\s*(\d{2})/) || [])[1] || '';
      }

      profile.modifiers = ['ultra', 'xl', 'max', 'plus', 'pro', 'mini'].filter((modifier) => {
        return new RegExp(`\\b${modifier}\\b`).test(text);
      });
      return profile;
    }

    function mediaMatchesProductDevice(media) {
      const contextProfile = deviceProfileFromText([
        product.handle,
        product.title,
        ...(state.selectedOptions || []),
        state.selectedVariant?.title,
      ].filter(Boolean).join(' '));
      if (!contextProfile.family) return false;

      const mediaProfile = deviceProfileFromText([
        media?.alt,
        mediaPreviewSrc(media),
      ].filter(Boolean).join(' '));
      if (mediaProfile.family !== contextProfile.family) return false;
      if (contextProfile.generation && mediaProfile.generation && mediaProfile.generation !== contextProfile.generation) return false;
      if (contextProfile.modifiers.includes('ultra') && mediaProfile.modifiers.length && !mediaProfile.modifiers.includes('ultra')) return false;
      if (contextProfile.modifiers.includes('xl') && mediaProfile.modifiers.length && !mediaProfile.modifiers.includes('xl')) return false;
      return true;
    }

    function caseButtonProfileFromText(value, options = {}) {
      const text = String(value || '').toLowerCase();
      if (/\bclear\b|(^|[-_\s])cl(\d|s|[-_\s]|$)/.test(text)) return 'clear';
      if (/\bcolor cases?\b|\bcolor\b|\bblack\b|(^|[-_\s])bk(\d|s|[-_\s]|$)/.test(text)) return 'color';
      return options.defaultToColor ? 'color' : '';
    }

    function selectedCaseButtonProfile() {
      const text = [
        state.selectedVariant?.title,
        state.selectedVariant?.sku,
        ...(state.selectedOptions || []),
      ].filter(Boolean).join(' ');
      return caseButtonProfileFromText(text, { defaultToColor: true });
    }

    function variantCaseButtonProfile(variant) {
      return caseButtonProfileFromText([
        variant?.title,
        variant?.sku,
        ...(variant?.options || []),
      ].filter(Boolean).join(' '));
    }

    function accentVariantHasParentMedia(productInfo, variant) {
      const media = productInfo?.media || [];
      const variantMedia = media.filter((bundleMedia) => {
        return mediaHasPositiveMatch(bundleMedia, variant?.sku, variant?.id)
          || mediaMatchesSku(bundleMedia, variant?.sku, variant?.id);
      });
      if (!variantMedia.length) return false;
      const parent = state.selectedVariant || {};
      return variantMedia.some((bundleMedia) => mediaHasPositiveMatch(bundleMedia, parent.sku, parent.id))
        || variantMedia.some((bundleMedia) => mediaMatchesProductDevice(bundleMedia));
    }

    function filterAccentPackVariants(productInfo, variants) {
      if (!variants.length) return variants;
      const selectedProfile = selectedCaseButtonProfile();
      const filtered = variants.filter((variant) => {
        const variantProfile = variantCaseButtonProfile(variant);
        if (selectedProfile && variantProfile && selectedProfile !== variantProfile) return false;
        return accentVariantHasParentMedia(productInfo, variant);
      });
      return filtered.length ? filtered : variants;
    }

    function addonMatchingMedia(item) {
      const media = (item?.product?.media || []).filter((entry) => !isUpsellGalleryMedia(entry));
      if (!media.length) return [];
      const variant = item?.variant || {};
      const variantMatches = media.filter((bundleMedia) => mediaMatchesSku(bundleMedia, variant.sku, variant.id));
      const parent = state.selectedVariant || {};
      const parentSpecific = variantMatches.filter((bundleMedia) => mediaHasPositiveMatch(bundleMedia, parent.sku, parent.id));
      if (parentSpecific.length) return parentSpecific;
      const deviceSpecific = variantMatches.filter((bundleMedia) => mediaMatchesProductDevice(bundleMedia));
      if (deviceSpecific.length) return deviceSpecific;
      const variantSpecific = variantMatches.filter((bundleMedia) => mediaHasPositiveMatch(bundleMedia, variant.sku, variant.id));
      if (variantSpecific.length) return variantSpecific;
      return variantMatches.length ? variantMatches : media;
    }

    function addonOverrideMedia(item) {
      const addonSku = normalizedMediaSku(item?.variant?.sku);
      const parentSku = normalizedMediaSku(state.selectedVariant?.sku);
      if (!addonSku) return null;
      const productSkus = new Set((item?.product?.variants || []).map((variant) => normalizedMediaSku(variant.sku)).filter(Boolean));
      productSkus.add(addonSku);
      const tags = (media) => mediaAltSkus(media.alt).map(normalizedMediaSku);
      const candidates = mediaItems.filter((media) => isUpsellGalleryMedia(media)
        && media.media_type === 'image' && mediaPreviewSrc(media)
        && mediaEligibleForExperiment(media)
        && tags(media).some((sku) => productSkus.has(sku)));
      return candidates.find((media) => tags(media).includes(parentSku) && tags(media).includes(addonSku))
        || candidates.find((media) => tags(media).includes(parentSku))
        || candidates.find((media) => tags(media).includes(addonSku))
        || candidates[0] || null;
    }

    function addonGalleryMedia(item) {
      if (usesMainProductAccentMedia && isAccentPackAddon(item)) {
        const matching = new Set(Object.values(mainProductAccentMediaByKey(item.variant))
          .flat().map((entry) => entry.media));
        const seen = new Set();
        const accents = mediaItems.filter((media) => {
          const src = mediaPreviewSrc(media);
          if (!matching.has(media) || media.media_type !== 'image' || !src
            || !mediaEligibleForExperiment(media) || seen.has(src)) return false;
          seen.add(src);
          return true;
        });
        if (accents.length) return accents;
      }
      const variant = item?.variant || {};
      const featuredId = variant.featured_media?.id || variant.featured_media_id;
      const featuredSrc = firstMediaSrc(variant);
      const compatible = (item?.product?.media || []).filter((media) =>
        !isUpsellGalleryMedia(media) && media.media_type === 'image' && mediaPreviewSrc(media)
        && (mediaMatchesSku(media, variant.sku, variant.id)
          || (featuredId && String(media.id) === String(featuredId))
          || (featuredSrc && mediaPreviewSrc(media) === featuredSrc)));
      let gallery = compatible.filter(mediaEligibleForExperiment);
      if (!gallery.length) {
        const fallback = compatible.filter(mediaIsLiveFallback);
        const first = fallback.find((media) => String(media.id) === String(featuredId))
          || fallback.find((media) => mediaHasPositiveMatch(media, variant.sku, variant.id))
          || fallback.find((media) => !mediaAltSkus(media.alt).length) || fallback[0];
        gallery = first ? [first] : [];
      }
      const override = addonOverrideMedia(item);
      const seen = new Set();
      return (override ? [override, ...gallery] : gallery).filter((media) => {
        const src = mediaPreviewSrc(media);
        if (seen.has(src)) return false;
        seen.add(src);
        return true;
      });
    }

    function openAddonGallery(item, trigger) {
      const galleryThumbs = addonGalleryMedia(item).map((media) => mediaToSyntheticThumb(media, item));
      if (!galleryThumbs.length) return;
      state.addonLightboxThumbs = galleryThumbs;
      openLightbox({ item, trigger });
    }

    function addonCardImageSrc(item) {
      return mediaPreviewSrc(addonMatchingMedia(item)[0])
        || firstMediaSrc(item?.variant)
        || firstMediaSrc(item?.product);
    }

    function shouldUseAddonMediaForAccent(item) {
      if (!isButtonPackAddon(item)) return false;
      return addonMatchingMedia(item).some((media) => !parseMediaAlt(media.alt).key);
    }

    function mediaById(id) {
      return mediaItems.find((media) => String(media.id) === String(id));
    }

    function selectedOptionsFromVariant(variant) {
      return optionValues(variant || productVariants[0]).slice(0, productOptions.length);
    }

    function findExactVariant(options) {
      return productVariants.find((variant) => {
        const values = optionValues(variant);
        return options.every((value, index) => values[index] === value);
      });
    }

    function scoreVariant(variant, desiredOptions, lockedIndex) {
      if (!variant || isHidden(variant)) return -1;
      const values = optionValues(variant);
      if (lockedIndex !== undefined && desiredOptions[lockedIndex] && values[lockedIndex] !== desiredOptions[lockedIndex]) return -1;

      return desiredOptions.reduce((score, value, index) => {
        if (!value) return score;
        const weight = index === lockedIndex ? 100 : 10;
        return score + (values[index] === value ? weight : 0);
      }, variant.available ? 1000 : 0);
    }

    function findNearestVariant(nextOptions, lockedIndex) {
      const exact = findExactVariant(nextOptions);
      if (exact && !isHidden(exact)) return exact;

      return [...productVariants]
        .filter((variant) => scoreVariant(variant, nextOptions, lockedIndex) >= 0)
        .sort((a, b) => scoreVariant(b, nextOptions, lockedIndex) - scoreVariant(a, nextOptions, lockedIndex))[0]
        || productVariants.find((variant) => !isHidden(variant))
        || productVariants[0];
    }

    function pairedOfferValueMatches(value, configuredValue) {
      const candidate = String(value || '').trim().toLowerCase();
      const configured = String(configuredValue || '').trim().toLowerCase();
      return Boolean(candidate && configured && candidate.includes(configured));
    }

    function pairedOfferVariantFor(configuredValue, selectedOptions = state.selectedOptions) {
      if (!pairedOfferEnabled) return null;
      return productVariants.find((variant) => {
        if (isHidden(variant)) return false;
        const values = optionValues(variant);
        if (!pairedOfferValueMatches(values[pairedOfferOptionIndex], configuredValue)) return false;
        return selectedOptions.every((selectedValue, optionIndex) => {
          return optionIndex === pairedOfferOptionIndex || values[optionIndex] === selectedValue;
        });
      }) || null;
    }

    function pairedOfferVariants(selectedOptions = state.selectedOptions) {
      const first = pairedOfferVariantFor(pairedOfferConfig.firstValue, selectedOptions);
      const second = pairedOfferVariantFor(pairedOfferConfig.secondValue, selectedOptions);
      if (!first || !second || String(first.id) === String(second.id)) return [];
      return [first, second];
    }

    function nativePairFor(selectedOptions = state.selectedOptions) {
      const variants = pairedOfferVariants(selectedOptions);
      if (variants.length !== 2) return null;
      return nativePairData?.pairs?.find((pair) =>
        String(pair.leftId) === String(variants[0].id)
        && String(pair.rightId) === String(variants[1].id)) || null;
    }

    async function refreshNativePairStock() {
      const url = new URL(product.url, window.location.origin);
      url.searchParams.set('section_id', 'mb-tesla-pair-json');
      url.searchParams.set('_', String(Date.now()));
      const response = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Unable to check bundle stock. Please try again.');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(html.querySelector('[data-mb-tesla-pair-data]')?.textContent || 'null');
      if (!Array.isArray(data?.pairs)) throw new Error('Unable to check bundle stock. Please try again.');
      nativePairData = data;
      updateOptionUI();
      updatePriceUI();
    }

    function pairedOfferAvailable(selectedOptions = state.selectedOptions) {
      if (nativePairedOffer) {
        const pair = nativePairFor(selectedOptions);
        return Boolean(pair?.available && pair.quantity > 0);
      }
      const variants = pairedOfferVariants(selectedOptions);
      return variants.length === 2 && variants.every(isInStockVariant);
    }

    function pairedOfferDiscountedPrice(variant) {
      const price = Number(variant?.price || 0);
      return Math.round(price * (100 - pairedOfferDiscountPercent) / 100);
    }

    function pairedOfferUnitTotals() {
      if (nativePairedOffer) {
        const pair = nativePairFor();
        return { regular: Number(pair?.regular || 0), discounted: Number(pair?.price || 0) };
      }
      const variants = pairedOfferVariants();
      const regular = variants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
      const percentagePrice = variants.reduce((sum, variant) => sum + pairedOfferDiscountedPrice(variant), 0);
      const discounted = pairedOfferFixedPrice > 0 ? pairedOfferFixedPrice : percentagePrice;
      return { regular, discounted };
    }

    function pairedOfferCartDiscountPercent() {
      const totals = pairedOfferUnitTotals();
      if (!totals.regular || totals.discounted >= totals.regular) return 0;
      return Math.round(((totals.regular - totals.discounted) * 100 / totals.regular) * 1000000) / 1000000;
    }

    function hasVariantWithValue(optionIndex, value) {
      return productVariants.some((variant) => {
        if (!isAvailableVariant(variant)) return false;
        const values = optionValues(variant);
        return values[optionIndex] === value && state.selectedOptions.every((selectedValue, selectedIndex) => {
          return selectedIndex === optionIndex || values[selectedIndex] === selectedValue;
        });
      });
    }

    function hasAnyVariantWithValue(optionIndex, value) {
      return productVariants.some((variant) => {
        if (isHidden(variant)) return false;
        return optionValues(variant)[optionIndex] === value;
      });
    }

    function hasVariantInOptionPath(optionIndex, value) {
      return productVariants.some((variant) => {
        if (isHidden(variant)) return false;
        const values = optionValues(variant);
        return values[optionIndex] === value && state.selectedOptions.every((selectedValue, selectedIndex) => {
          return selectedIndex >= optionIndex || values[selectedIndex] === selectedValue;
        });
      });
    }

    function hasAvailableVariantInOptionPath(optionIndex, value) {
      return productVariants.some((variant) => {
        if (!isAvailableVariant(variant)) return false;
        const values = optionValues(variant);
        return values[optionIndex] === value && state.selectedOptions.every((selectedValue, selectedIndex) => {
          return selectedIndex >= optionIndex || values[selectedIndex] === selectedValue;
        });
      });
    }

    function renderSelectOptions(select, optionIndex, selectedValue) {
      const templates = selectOptionTemplates.get(select);
      if (!templates?.length) return;

      const validOptions = templates.filter((option) => hasVariantInOptionPath(optionIndex, option.value));
      const nextOptions = validOptions.length ? validOptions : templates;
      const currentSignature = Array.from(select.options).map((option) => option.value).join('\n');
      const nextSignature = nextOptions.map((option) => option.value).join('\n');

      if (currentSignature !== nextSignature) {
        select.replaceChildren(...nextOptions.map((template) => {
          const option = template.cloneNode(true);
          option.hidden = false;
          option.disabled = false;
          option.selected = option.value === selectedValue;
          return option;
        }));
      }

      if (selectedValue && Array.from(select.options).some((option) => option.value === selectedValue)) {
        select.value = selectedValue;
      }
    }

    function shouldPruneSelectOptions(group) {
      return /tesla/i.test(product.handle || '')
        && /year/i.test(group?.dataset?.optionName || '');
    }

    function rimcaseWheelKey(value) {
      const text = String(value || '').toLowerCase();
      if (text.includes('uberturbine')) return 'uberturbine';
      if (text.includes('induction')) return 'induction';
      return 'helix';
    }

    function updateRimcasePackArt() {
      const rimcaseArt = productConfig.rimcaseArt;
      if (!rimcaseArt?.pack) return;
      const wheelModelIndex = productOptions.findIndex((name) => /wheel\s*model/i.test(name));
      if (wheelModelIndex < 0) return;
      const wheelKey = rimcaseWheelKey(state.selectedOptions[wheelModelIndex]);
      root.querySelectorAll('[data-mb-rimcase-pack-art]').forEach((image) => {
        const packKey = image.dataset.rimcasePack || 'one';
        const nextSrc = rimcaseArt.pack?.[wheelKey]?.[packKey] || rimcaseArt.model?.[wheelKey];
        if (!nextSrc || image.getAttribute('src') === nextSrc) return;
        image.src = nextSrc;
        image.removeAttribute('srcset');
      });
    }

    function updateOptionUI() {
      optionGroups.forEach((group) => {
        const optionIndex = Number(group.dataset.optionPosition || 1) - 1;
        const selectedValue = state.selectedOptions[optionIndex];
        const legend = group.querySelector('[data-mb-option-legend]');
        const select = group.querySelector('select[data-mb-option-input]');
        if (legend) legend.textContent = euDisplayText(selectedValue || '');
        if (select && shouldPruneSelectOptions(group)) renderSelectOptions(select, optionIndex, selectedValue);

        group.querySelectorAll('[data-mb-option-value]').forEach((label) => {
          const input = label.matches('option') ? label : label.querySelector('input');
          const value = input?.value || label.dataset.mbOptionValue;
          if (!value) return;
          const isPairedOffer = label.hasAttribute('data-mb-paired-offer');
          if (isPairedOffer) {
            const available = pairedOfferAvailable();
            label.hidden = !pairedOfferVisible || !available;
            label.classList.remove('is-oos');
            label.classList.toggle('is-selected', state.pairedOfferSelected);
            if (input) {
              input.checked = state.pairedOfferSelected;
              input.disabled = !pairedOfferVisible || !available;
              input.removeAttribute('aria-disabled');
            }
            return;
          }
          const isSelected = value === selectedValue && !(state.pairedOfferSelected && optionIndex === pairedOfferOptionIndex);
          const hasMatch = hasVariantWithValue(optionIndex, value);
          const hasAnyMatch = hasAnyVariantWithValue(optionIndex, value);
          const isInOptionPath = hasVariantInOptionPath(optionIndex, value);
          const hasAvailablePath = hasAvailableVariantInOptionPath(optionIndex, value);
          const exactVariant = findNearestVariant(state.selectedOptions.map((current, index) => index === optionIndex ? value : current), optionIndex);

          if (input) {
            if (input.matches('option')) {
              input.selected = isSelected;
              input.hidden = !isInOptionPath;
              input.disabled = !isInOptionPath;
            } else {
              input.checked = isSelected;
              input.disabled = !isInOptionPath;
            }
            if (isInOptionPath && !hasAvailablePath) {
              input.setAttribute('aria-disabled', 'true');
            } else {
              input.removeAttribute('aria-disabled');
            }
          }
          label.hidden = !isInOptionPath;
          label.classList.toggle('is-oos', (!hasMatch && !isSelected) || !hasAnyMatch || !hasAvailablePath || (isSelected && !isAvailableVariant(state.selectedVariant)));
          label.classList.toggle('is-selected', isSelected);

          const price = label.querySelector('[data-mb-option-price]');
          const description = label.querySelector('[data-mb-series-description]');
          if (price && exactVariant) price.textContent = money(exactVariant.price);
          if (description) description.textContent = euDisplayText(optionDescription(value));
        });

        if (select && selectedValue) {
          select.value = selectedValue;
        }
      });
      updateRimcasePackArt();
    }

    function compatibleBundles() {
      const pmetas = state.productData?.metafields || {};
      const vmetas = variantMeta(state.selectedVariant);
      const configuredBundles = pmetas.inline_bundles || [];
      const legacyUpsells = configuredBundles.length ? [] : (pmetas.inline_upsells || []);
      const inlineBundles = [
        ...configuredBundles,
        ...legacyUpsells.map((upsell) => ({
          id: `upsell-${upsell?.product?.id || upsell?.tagline || 'unknown'}`,
          tagline: upsell.tagline,
          product: upsell.product,
          default_on: upsell.default === true,
          swatches: upsell.swatches,
          discount_type: '',
          discount_amount: 0,
          optionless: upsell.product?.has_only_default_variant,
          variant_metafields: upsell.variant_metafields,
          is_upsell: true,
        })),
      ];
      const bundleExclusions = new Set(vmetas.bundle_exclusions || []);
      const inlineExclusions = new Set(vmetas.inline_exclusions || []);
      const configsByProduct = {};
      [
        ...(vmetas.bundle_variant_configs || []),
        ...(vmetas.inline_variants || []).map((config) => ({
          ...config,
          variant_id: config.variant_id || config.id,
        })),
      ].forEach((config) => {
        if (!configsByProduct[config.product_id]) configsByProduct[config.product_id] = [];
        configsByProduct[config.product_id].push(config);
      });

      return inlineBundles.map((bundle) => {
        const productInfo = bundle.product;
        if (!productInfo?.id || bundleExclusions.has(bundle.id) || inlineExclusions.has(productInfo.id)) return null;
        const configs = configsByProduct[productInfo.id] || [];
        const configsByVariant = {};
        configs.forEach((config) => { configsByVariant[config.variant_id || config.id] = config; });
        const variantsById = {};
        (productInfo.variants || []).forEach((variant) => { variantsById[variant.id] = variant; });
        let selectedVariantId = state.bundleSelections[productInfo.id];
        let accentSelectionsInitialized = false;
        let selectedAccentIds = [];
        const includedFreeAddon = isIncludedFree(productInfo.id);
        let variantChoices = (productInfo.variants || []).filter((variant) => {
          // EU gifts and add-ons must pass the same reviewed assortment as cases.
          // A free allocation elsewhere cannot override Netherlands eligibility.
          if (Array.isArray(state.productData?.euEligibleVariantIds)
            && isOutsideEuAssortment(variant, productInfo.euEligibleVariantIds || [])) return false;
          // Free inclusions ship from a separate allocation, so this product's stock
          // does not gate them. Filtering them out here would strip the device-matching
          // variant and silently fall through to a wrong-model one below.
          const freeVariant = includedFreeAddon || configsByVariant[variant.id]?.included === true;
          if (!variant?.available && !freeVariant) return false;
          if (isVariantHiddenForCountry(bundle.variant_metafields?.[variant.id], state.productData?.country)) return false;
          return configs.length ? configsByVariant[variant.id] : true;
        });
        variantChoices = filterUpsellVariantsByPlatform(productInfo, variantChoices);
        variantChoices = filterRimcaseTeslaChargerVariants(bundle, productInfo, variantChoices);
        const accentPackAddon = isAccentPackAddon({ bundle, product: productInfo });
        if (accentPackAddon) {
          const enabledKey = String(bundle.id);
          accentSelectionsInitialized = Object.prototype.hasOwnProperty.call(state.accentSelections, enabledKey);
          const previousAccentIds = accentSelectionsInitialized ? state.accentSelections[enabledKey] : [];
          variantChoices = filterAccentPackVariants(productInfo, variantChoices);
          variantChoices = variantChoices.filter((variant) => !accentVariantMatchesParentColor(variant));
          const validAccentIds = new Set(variantChoices.map((variant) => String(variant.id)));
          selectedAccentIds = previousAccentIds.filter((id) => validAccentIds.has(String(id)));
          if (previousAccentIds.length && !selectedAccentIds.length) {
            state.bundleEnabled[enabledKey] = false;
            state.accentSelectionCleared[enabledKey] = true;
          }
          state.accentSelections[enabledKey] = selectedAccentIds;
          selectedVariantId = selectedAccentIds[selectedAccentIds.length - 1];
        }
        const deviceLockedBundle = isDeviceLockedAddon({ bundle, product: productInfo });
        const deviceMatchable = deviceLockedBundle && addonHasDeviceVariants(productInfo, variantChoices);
        const preferredDeviceVariant = deviceMatchable
          ? variantChoices.find((candidate) => variantMatchesParentDevice(candidate))
          : null;
        if (deviceMatchable && !preferredDeviceVariant && !isIncludedFree(productInfo.id)) return null;
        const deviceAutoMatched = deviceMatchable && !!preferredDeviceVariant;
        const variant = preferredDeviceVariant
          || variantChoices.find((candidate) => String(candidate.id) === String(selectedVariantId))
          || variantChoices.find((candidate) => configsByVariant[candidate.id]?.included)
          || variantChoices[0];
        if (!variant) return null;
        const config = configsByVariant[variant.id]
          || configs.find((candidate) => variantsById[candidate.variant_id || candidate.id]?.available)
          || configs[0];
        state.bundleSelections[productInfo.id] = variant.id;
        const enabledKey = String(bundle.id);
        let enabled = Object.prototype.hasOwnProperty.call(state.bundleEnabled, enabledKey)
          ? state.bundleEnabled[enabledKey]
          : bundle.default_on === true || config?.included === true;
        const freeIncluded = config?.included === true || isIncludedFree(productInfo.id);
        if (accentPackAddon) {
          if (!accentSelectionsInitialized && (enabled || freeIncluded)) selectedAccentIds = [variant.id];
          state.accentSelections[enabledKey] = selectedAccentIds;
          enabled = freeIncluded || selectedAccentIds.length > 0;
          state.bundleEnabled[enabledKey] = enabled;
          state.accentSelectionCleared[enabledKey] = selectedAccentIds.length === 0;
        }
        return {
          bundle,
          config,
          product: productInfo,
          variant,
          variantChoices,
          configsByVariant,
          included: freeIncluded,
          selected: freeIncluded || enabled,
          deviceAutoMatched,
          price: discountedPrice(variant, bundle),
        };
      }).filter(Boolean);
    }

    function isIncludedFree(productId) {
      const base = (state.productData && state.productData.metafields && state.productData.metafields.included_free) || [];
      if (!base.length) return false;
      if (!base.map(String).includes(String(productId))) return false;
      const exclude = (variantMeta(state.selectedVariant) || {}).included_free_exclude || [];
      return !exclude.map(String).includes(String(productId));
    }

    function includedScreenProtectorHTML() {
      if (!Array.isArray(state.productData?.euEligibleVariantIds)) return '';
      const includedIds = state.productData?.euIncludedScreenProtectorVariantIds || [];
      if (!includedIds.map(String).includes(String(state.selectedVariant?.id))) return '';
      if (state.bundles.some((item) => item.included && /screen protector/i.test(addonIdentity(item)))) return '';
      // The protector is already inside the case box. This reassurance row has
      // no merchandise ID and never enters bundle selection or cart submission.
      return `<label class="is-selected is-included" data-mb-included-screen-protector>
        <input type="checkbox" checked disabled aria-label="Screen protector included in your case box" data-mb-addon-input>
        <span class="mb-clean-addons__image" aria-hidden="true"><svg viewBox="0 0 56 56" width="56" height="56" fill="none"><rect x="14" y="4" width="28" height="48" rx="5" stroke="currentColor" stroke-width="2"/><path d="M23 9h10M21 29l5 5 10-12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="mb-clean-addons__body"><b>Screen protector</b><small>Included in your case box</small></span>
        <strong><span>Included</span></strong>
      </label>`;
    }

    function renderBundles() {
      if (!addons) return;
      state.bundles = compatibleBundles();
      const includedProtector = includedScreenProtectorHTML();
      if (!state.bundles.length && !includedProtector) {
        state.accentPrefetchObserver?.disconnect?.();
        state.accentPrefetchObserver = null;
        clearUpsellImpressionTracking();
        if (addonsGroup) addonsGroup.hidden = true;
        addons.innerHTML = '';
        return;
      }

      if (addonsGroup) addonsGroup.hidden = false;
      addons.innerHTML = state.bundles.map((item, index) => {
        const hasProperties = addonCartProperties(item).length > 0;
        const galleryMedia = addonGalleryMedia(item);
        const thumbnail = usesMainProductAccentMedia && isAccentPackAddon(item)
          ? galleryMedia[0] : addonOverrideMedia(item);
        const img = escapeHTML(mediaPreviewSrc(thumbnail) || addonCardImageSrc(item));
        const hasGallery = Boolean(lightbox && galleryMedia.length);
        const galleryLabel = escapeAttribute(`${addonGalleryLabel}: ${addonDisplayTitle(item)} ${addonVariantSubtitle(item)}`);
        const title = escapeHTML(euDisplayText(addonDisplayTitle(item)));
        const propertySummary = hasProperties ? addonPropertySummary(item) : '';
        const accentSelectionCleared = isAccentPackAddon(item)
          && state.accentSelectionCleared[String(item.bundle.id)] === true;
        const subtitle = hasProperties
          ? escapeHTML(propertySummary)
          : accentSelectionCleared ? '&nbsp;' : escapeHTML(euDisplayText(addonVariantSubtitle(item)));
        const checked = item.selected ? 'checked' : '';
        const disabled = item.included ? 'disabled' : '';
        const selected = item.selected ? ' is-selected' : '';
        const included = item.included ? ' is-included' : '';
        const propertyClass = hasProperties ? ' has-properties' : '';
        const price = addonPriceHTML(item);
        const variantControls = variantOptionControls(item, index);
        const propertyControls = addonPropertyInputsHTML(item, index);
        return `
          <label class="${selected}${included}${propertyClass}" data-mb-addon-index="${index}" data-mb-upsell-key="${escapeAttribute(addonUpsellMetadata(item).upsell_key)}">
            <input type="checkbox" ${checked} ${disabled} data-mb-addon-input>
            ${hasGallery
              ? `<button type="button" class="mb-clean-addons__image mb-clean-addons__gallery-trigger" data-mb-addon-gallery="${index}" aria-haspopup="dialog" aria-label="${galleryLabel}">${img ? `<img src="${img}" alt="">` : ''}<span class="mb-clean-addons__gallery-icon" aria-hidden="true"><svg fill="none" aria-hidden="true" focusable="false" viewBox="0 0 18 19"><path fill="currentColor" fill-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z" clip-rule="evenodd"/></svg></span></button>`
              : `<span class="mb-clean-addons__image">${img ? `<img src="${img}" alt="">` : ''}</span>`}
            <span class="mb-clean-addons__body"><b>${title}</b>${subtitle ? `<small data-mb-addon-subtitle ${hasProperties ? 'data-mb-addon-property-summary' : ''}>${subtitle}</small>` : hasProperties ? '<small data-mb-addon-subtitle data-mb-addon-property-summary hidden></small>' : ''}${variantControls}${propertyControls}</span>
            ${price}
          </label>
        `;
      }).join('') + includedProtector;

      addons.querySelectorAll('[data-mb-addon-gallery]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const item = state.bundles[Number(button.dataset.mbAddonGallery)];
          if (item) openAddonGallery(item, button);
        });
      });
      setupUpsellImpressionTracking();
      addons.querySelectorAll('[data-mb-addon-input]').forEach((input) => {
        input.addEventListener('change', () => {
          const label = input.closest('label');
          const item = state.bundles[Number(label?.dataset.mbAddonIndex)];
          const previousSelected = item?.selected === true;
          if (item) state.bundleEnabled[String(item.bundle.id)] = input.checked;
          const isAccentPack = item && isAccentPackAddon(item);
          if (isAccentPack) {
            const selectionKey = accentSelectionKey(item);
            if (input.checked) {
              const selectedIds = accentVariantIds(item);
              state.accentSelections[selectionKey] = selectedIds.length ? selectedIds : [item.variant.id];
              const activeAccentIds = state.accentSelections[selectionKey];
              state.bundleSelections[item.product.id] = activeAccentIds[activeAccentIds.length - 1];
              state.accentSelectionCleared[selectionKey] = false;
              prefetchRemainingAccentPrimaryImages(item);
            } else {
              state.accentSelections[selectionKey] = [];
              state.accentSelectionCleared[selectionKey] = true;
            }
          }
          if (item && previousSelected !== input.checked) {
            const action = input.checked ? 'select' : 'deselect';
            trackUpsellInteraction(item, action);
            trackUpsellSelection(item, action);
            trackConfigurationChange(
              isAccentPack ? 'accent' : 'upsell',
              previousSelected ? 'selected' : 'not_selected',
              input.checked ? 'selected' : 'not_selected',
              true,
              'addon_toggle'
            );
          }
          label?.classList.toggle('is-selected', input.checked);
          if (isAccentPack) renderBundles();
          updateGalleryMedia({
            keepSelection: !isAccentPack || input.checked,
            resetToFirst: isAccentPack && !input.checked,
            preferAccentPackMedia: input.checked && isAccentPack,
            focusBundleItem: input.checked ? item : null,
          });
          updatePriceUI();
        });
      });
      addons.querySelectorAll('[data-mb-addon-properties]').forEach((wrapper) => {
        wrapper.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });
      addons.querySelectorAll('[data-mb-addon-property]').forEach((input) => {
        input.addEventListener('focus', () => {
          const item = state.bundles[Number(input.dataset.mbAddonIndex)];
          if (item) trackUpsellInteraction(item, 'open');
        });
        input.addEventListener('input', () => {
          state.bundleProperties[input.dataset.propertyStateKey] = input.value;
          const label = input.closest('label[data-mb-addon-index]');
          const item = state.bundles[Number(label?.dataset.mbAddonIndex)];
          const checkbox = label?.querySelector('[data-mb-addon-input]');
          const summary = label?.querySelector('[data-mb-addon-property-summary]');
          const summaryText = item ? addonPropertySummary(item) : '';
          if (summary) {
            summary.textContent = euDisplayText(summaryText);
            summary.hidden = !summaryText;
          }
          if (!item || item.included || !checkbox || checkbox.checked || !String(input.value || '').trim()) return;
          checkbox.checked = true;
          state.bundleEnabled[String(item.bundle.id)] = true;
          item.selected = true;
          trackUpsellSelection(item, 'select');
          label.classList.add('is-selected');
          updateGalleryMedia({
            keepSelection: true,
            focusBundleItem: item,
          });
          updatePriceUI();
        });
      });
      const updateAddonOption = (control, optionValue) => {
        const label = control.closest('label[data-mb-addon-index]');
        const item = state.bundles[Number(control.dataset.mbAddonIndex)];
        const previousOptionValue = item?.variant?.title || item?.variant?.id || 'not_set';
        const previousSelected = item?.selected === true;
        const isAccentPack = item && isAccentPackAddon(item);
        if (isAccentPack) state.accentSelectionCleared[String(item.bundle.id)] = false;
        const nextOptions = [...(item?.variant.options || [])];
        if (control.dataset.optionScope === 'linked-colors') {
          control.dataset.optionIndex.split(',').forEach((index) => { nextOptions[Number(index)] = optionValue; });
        } else {
          const changedIndex = Number(control.dataset.optionIndex);
          nextOptions[changedIndex] = optionValue;
          nextOptions.slice(changedIndex + 1).forEach((value, offset) => {
            const optionIndex = changedIndex + 1 + offset;
            if (!bundleValuesForLevel(item, optionIndex, nextOptions).includes(value)) nextOptions[optionIndex] = undefined;
          });
        }
        const nextVariant = item ? nearestBundleVariant(item, nextOptions) : null;
        if (!item || !nextVariant) return;
        if (isAccentPack) {
          const selectionKey = accentSelectionKey(item);
          const selectedIds = [...accentVariantIds(item)];
          const selectedIndex = selectedIds.findIndex((id) => String(id) === String(nextVariant.id));
          const action = selectedIndex >= 0 ? 'deselect' : 'select';
          trackUpsellInteraction(item, action, nextVariant);
          if (selectedIndex >= 0) selectedIds.splice(selectedIndex, 1);
          else selectedIds.push(nextVariant.id);
          state.accentSelections[selectionKey] = selectedIds;
          state.bundleEnabled[selectionKey] = selectedIds.length > 0;
          state.accentSelectionCleared[selectionKey] = selectedIds.length === 0;
          const focusedVariantId = selectedIds[selectedIds.length - 1];
          const focusedVariant = item.variantChoices.find((variant) => String(variant.id) === String(focusedVariantId));
          state.bundleSelections[item.product.id] = focusedVariant?.id || nextVariant.id;
          item.variant = focusedVariant || nextVariant;
          item.selected = selectedIds.length > 0;
          trackUpsellSelection(item, action, nextVariant);
          trackConfigurationChange(
            'accent_color',
            previousOptionValue,
            optionValue,
            isAvailableVariant(nextVariant),
            selectedIds.length > 0 ? 'accent_selected' : 'accent_deselected'
          );
          if (selectedIds.length > 0) prefetchRemainingAccentPrimaryImages(item, item.variant);
          renderBundles();
          updateGalleryMedia({
            keepSelection: selectedIds.length > 0,
            resetToFirst: selectedIds.length === 0,
            preferAccentPackMedia: selectedIds.length > 0,
            focusBundleItem: selectedIds.length > 0 ? item : null,
          });
          updatePriceUI();
          return;
        }
        trackUpsellInteraction(item, 'select', nextVariant);
        state.bundleSelections[item.product.id] = nextVariant.id;
        item.variant = nextVariant;
        const nextConfigList = [
          ...(variantMeta(state.selectedVariant).bundle_variant_configs || []),
          ...(variantMeta(state.selectedVariant).inline_variants || []).map((config) => ({
            ...config,
            variant_id: config.variant_id || config.id,
          })),
        ];
        item.config = nextConfigList.find((config) => String(config.variant_id) === String(nextVariant.id)) || item.config;
        item.included = item.config?.included === true || isIncludedFree(item.product.id);
        const input = label.querySelector('[data-mb-addon-input]');
        if (input && !item.included) {
          input.checked = true;
          state.bundleEnabled[String(item.bundle.id)] = true;
        }
        item.selected = item.included || input?.checked;
        if (!previousSelected && item.selected) trackUpsellSelection(item, 'select', nextVariant);
        trackConfigurationChange(
          'upsell_option',
          previousOptionValue,
          optionValue,
          isAvailableVariant(nextVariant),
          'addon_option'
        );
        label.classList.toggle('is-selected', item.selected);
        label.classList.toggle('is-included', item.included);
        item.price = discountedPrice(nextVariant, item.bundle);
        const image = label.querySelector('.mb-clean-addons__image img');
        const nextImageSrc = addonCardImageSrc(item);
        if (image && nextImageSrc) image.src = nextImageSrc;
        const subtitle = label.querySelector('[data-mb-addon-subtitle]');
        if (subtitle) subtitle.textContent = euDisplayText(addonVariantSubtitle(item));
        const price = label.querySelector('[data-mb-addon-price]');
        if (price) price.outerHTML = addonPriceHTML(item);
        renderBundles();
        updateGalleryMedia({
          keepSelection: true,
          preferAccentPackMedia: isAccentPack,
          focusBundleItem: item,
        });
        updatePriceUI();
      };
      addons.querySelectorAll('[data-mb-addon-option-select]').forEach((select) => {
        select.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
        });
        select.addEventListener('click', (event) => {
          event.stopPropagation();
        });
        select.addEventListener('change', (event) => {
          event.stopPropagation();
          updateAddonOption(select, select.value);
        });
      });
      addons.querySelectorAll('[data-mb-addon-option]').forEach((button) => {
        const prefetchControlAccent = (immediate = false) => {
          const item = state.bundles[Number(button.dataset.mbAddonIndex)];
          const variant = accentVariantForControl(button, item);
          if (item && variant) prefetchAccentPrimaryImage(item, variant, { immediate });
        };
        button.addEventListener('pointerenter', () => prefetchControlAccent());
        button.addEventListener('focus', () => prefetchControlAccent());
        button.addEventListener('pointerdown', () => prefetchControlAccent(true), { passive: true });
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          updateAddonOption(button, button.dataset.optionValue);
        });
      });
      setupAccentImagePrefetching();
    }

    function selectedBundles() {
      return selectedPurchasableEntries().map((entry) => entry.item);
    }

    // Identify the accent pack by what it is, not by a hardcoded product id. The
    // previous version matched one specific pack, so every new device-specific
    // pack silently failed to swap the gallery no matter how its media was tagged.
    //
    // isEliteColorAccentAddon (not isAccentPackAddon) is the right test: the
    // broader one also matches button packs, whose taglines read "5-Color Button
    // Set". A PDP using accent media should list only one colour pack -- if more
    // than one qualifies, the first wins.
    function activeAccentPackVariant(focusItem = null) {
      if (!usesMainProductAccentMedia) return null;
      if (focusItem?.variant && isEliteColorAccentAddon(focusItem)) {
        return focusItem.variant;
      }
      const item = state.bundles.find((bundleItem) => isEliteColorAccentAddon(bundleItem));
      if (!item) return null;
      const selectedIds = accentVariantIds(item).map(String);
      if (!selectedIds.length) return null;
      const focusedId = String(state.bundleSelections[item.product.id] || item.variant?.id || '');
      const focusedVariant = (item.variantChoices || []).find((variant) => {
        return String(variant.id) === focusedId && selectedIds.includes(String(variant.id));
      });
      if (focusedVariant) return focusedVariant;
      const fallbackId = selectedIds[selectedIds.length - 1];
      return (item.variantChoices || []).find((variant) => String(variant.id) === fallbackId) || null;
    }

    function selectedPurchasableEntries() {
      return selectedBundleEntries().flatMap((entry) => {
        if (!isAccentPackAddon(entry.item)) return [entry];
        return accentSelectedVariants(entry.item).map((variant) => {
          const config = entry.item.configsByVariant?.[variant.id] || entry.item.config;
          return {
            ...entry,
            item: {
              ...entry.item,
              variant,
              config,
              included: config?.included === true || isIncludedFree(entry.item.product.id),
              price: discountedPrice(variant, entry.item.bundle),
            },
          };
        });
      });
    }

    function selectedBundleMediaByKey(filter = () => true) {
      const map = {};
      selectedBundles().filter(filter).forEach((item) => {
        const media = addonMatchingMedia(item);
        media.forEach((bundleMedia) => {
          const values = parseMediaAlt(bundleMedia.alt);
          if (!values.key) return;
          if (!map[values.key]) map[values.key] = [];
          const replacement = { ...values, media: bundleMedia };
          if (isAccentPackAddon(item)) map[values.key].unshift(replacement);
          else map[values.key].push(replacement);
        });
      });
      return map;
    }

    function mergeMediaReplacementMaps(primary, fallback) {
      const map = {};
      const keys = new Set([...Object.keys(primary || {}), ...Object.keys(fallback || {})]);
      keys.forEach((key) => {
        map[key] = [...(primary?.[key] || []), ...(fallback?.[key] || [])];
      });
      return map;
    }

    function selectedAccentMediaByKey(focusItem = null) {
      const legacy = selectedBundleMediaByKey((item) => isAccentPackAddon(item));
      const mainProductMedia = mainProductAccentMediaByKey(activeAccentPackVariant(focusItem));
      return mergeMediaReplacementMaps(mainProductMedia, legacy);
    }

    function replacementForThumb(thumb, replacements) {
      const values = parseMediaAlt(thumb.dataset.mediaAlt);
      const candidates = replacements[values.key] || [];
      if (!values.key || !candidates.length) return null;
      const thumbSkus = values.csv ? values.csv.split(rgxCommaDelimiter) : [];
      return candidates.find((candidate) => thumbSkus.some((sku) => candidate.set.has(sku)))?.media || null;
    }

    function preferredAccentPackThumb(visibleThumbs, focusItem = null) {
      // When the replacements come from the main product's own gallery, gallery
      // order decides: slot 0 is the curated hero. The keyword chain below was
      // written for pack images labelled "case sandwich", and on a case gallery
      // it matches any slot whose label merely contains "button" -- "side
      // buttons" is how the Z Fold jumped to its buttons shot instead of the
      // hero. Products without custom.main_product_accent_media get {} here and
      // take the original path unchanged.
      const mainProductReplacements = mainProductAccentMediaByKey(activeAccentPackVariant(focusItem));
      const mainProductThumb = visibleThumbs.find((thumb) => replacementForThumb(thumb, mainProductReplacements));
      if (mainProductThumb) return mainProductThumb;

      const replacements = selectedAccentMediaByKey(focusItem);
      const candidates = visibleThumbs.map((thumb) => {
        const replacement = replacementForThumb(thumb, replacements);
        if (!replacement) return null;
        const values = parseMediaAlt(thumb.dataset.mediaAlt);
        return { thumb, key: values.key || '' };
      }).filter(Boolean);

      const replacementThumb = candidates.find((candidate) => /sandwich|back to back/.test(candidate.key))?.thumb
        || candidates.find((candidate) => /accent|button|color/.test(candidate.key))?.thumb
        || candidates[0]?.thumb
        || null;

      if (replacementThumb) return replacementThumb;
      if (shouldUseAddonMediaForAccent(focusItem)) return null;

      const galleryCandidates = visibleThumbs.map((thumb) => {
        const text = [
          thumb.dataset.mediaAlt,
          thumb.dataset.image,
          thumb.dataset.originalImage,
          thumb.dataset.currentImage,
        ].filter(Boolean).join(' ').toLowerCase();
        return { thumb, text };
      }).filter((candidate) => /accent|button|color/.test(candidate.text) && !/camera\s+button/.test(candidate.text));

      return galleryCandidates.find((candidate) => /button/.test(candidate.text))?.thumb
        || galleryCandidates.find((candidate) => /accent/.test(candidate.text))?.thumb
        || galleryCandidates[0]?.thumb
        || null;
    }

    function mediaToSyntheticThumb(media, item) {
      if (!media) return null;
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'mb-clean-gallery__thumb is-selected';
      thumb.dataset.mediaId = `bundle-${media.id || item?.variant?.id || Date.now()}`;
      thumb.dataset.mediaAlt = media.alt || item?.product?.title || '';
      const sources = videoSourcesFromMedia(media);
      thumb.dataset.mediaType = (media.media_type === 'video' && sources.length) ? 'video' : 'image';
      thumb.dataset.image = mediaPreviewSrc(media);
      thumb.dataset.originalImage = thumb.dataset.image;
      thumb.dataset.currentImage = thumb.dataset.image;
      if (thumb.dataset.mediaType === 'video') {
        thumb.dataset.videoSources = JSON.stringify(sources);
      }
      return thumb;
    }

    function preferredBundleMedia(item, options = {}) {
      if (!item || (isAccentPackAddon(item) && !options.allowAccentPack)) return null;
      const candidates = addonMatchingMedia(item);
      if (options.preferPrimaryImage) {
        return candidates.find((bundleMedia) => bundleMedia.media_type !== 'video') || candidates[0] || null;
      }
      return candidates.find((bundleMedia) => {
        return bundleMedia.media_type === 'video' && preferredVideoSource(videoSourcesFromMedia(bundleMedia));
      }) || candidates[0] || null;
    }

    function primaryAccentMedia(item, variant) {
      if (!item || !variant || !isEliteColorAccentAddon(item)) return null;
      const candidateItem = { ...item, variant };
      // mainProductAccentMediaByKey already returns {} when the product does not
      // opt into accent media, so no product-id gate is needed here.
      const mainProductReplacements = mainProductAccentMediaByKey(variant);
      const mainProductCandidates = visibleGalleryThumbs().map((thumb) => {
        const media = replacementForThumb(thumb, mainProductReplacements);
        if (!media) return null;
        return {
          media,
          key: parseMediaAlt(thumb.dataset.mediaAlt).key || '',
        };
      }).filter(Boolean);
      // Gallery order decides: the first slot is the hero, so the first slot with
      // an accent replacement is the image to feature. The keyword heuristic used
      // below for the addon's own media is wrong here -- it was written for pack
      // images labelled "case sandwich", and on a case gallery it matches any
      // slot whose label happens to contain "button", e.g. "side buttons", which
      // is how the Z Fold showed its buttons shot instead of the hero.
      const mainProductPrimary = mainProductCandidates[0];
      if (mainProductPrimary?.media) return mainProductPrimary.media;

      const replacements = {};
      addonMatchingMedia(candidateItem).forEach((bundleMedia) => {
        const values = parseMediaAlt(bundleMedia.alt);
        if (!values.key) return;
        if (!replacements[values.key]) replacements[values.key] = [];
        replacements[values.key].push({ ...values, media: bundleMedia });
      });

      const candidates = visibleGalleryThumbs().map((thumb) => {
        const media = replacementForThumb(thumb, replacements);
        if (!media) return null;
        return {
          media,
          key: parseMediaAlt(thumb.dataset.mediaAlt).key || '',
        };
      }).filter(Boolean);
      const primary = candidates.find((candidate) => /sandwich|back to back/.test(candidate.key))
        || candidates.find((candidate) => /accent|button|color/.test(candidate.key))
        || candidates[0];
      return primary?.media || preferredBundleMedia(candidateItem, {
        allowAccentPack: true,
        preferPrimaryImage: true,
      });
    }

    function prefetchAccentPrimaryImage(item, variant, options = {}) {
      if (!item || !variant || dataSaverEnabled()) return;
      const media = primaryAccentMedia(item, variant);
      const src = mediaPreviewSrc(media);
      if (!src) return;
      const prefetchKey = `accent:${resizedImageSrc(src, 1400)}`;
      if (state.accentPrefetchScheduled.has(prefetchKey)) return;
      state.accentPrefetchScheduled.add(prefetchKey);

      const preload = () => {
        const image = new Image();
        image.decoding = 'async';
        setResponsiveImageSource(image, src, {
          widths: galleryImageWidths,
          sizes: galleryImageSizes,
          fallbackWidth: 1400,
          loading: 'eager',
          fetchPriority: 'low',
        });
      };
      if (options.immediate) {
        preload();
        return;
      }

      const schedule = () => requestGalleryIdle(preload);
      const activeImage = mainImage && !mainImage.hidden ? mainImage : null;
      if (!activeImage || activeImage.complete) {
        schedule();
      } else {
        activeImage.addEventListener('load', schedule, { once: true });
        activeImage.addEventListener('error', schedule, { once: true });
      }
    }

    function prefetchRemainingAccentPrimaryImages(item, focusedVariant = item?.variant) {
      if (!item || dataSaverEnabled()) return;
      const parentVariantId = state.selectedVariant?.id;
      const variants = [
        focusedVariant,
        ...(item.variantChoices || []).filter((variant) => String(variant.id) !== String(focusedVariant?.id)),
      ].filter(Boolean);
      variants.forEach((variant, index) => {
        window.setTimeout(() => {
          if (String(state.selectedVariant?.id) !== String(parentVariantId)) return;
          prefetchAccentPrimaryImage(item, variant, { immediate: true });
        }, index * 120);
      });
    }

    function accentVariantForControl(control, item) {
      if (!control || !item || !isAccentPackAddon(item)) return null;
      const optionValue = control.dataset.optionValue;
      const nextOptions = [...(item.variant.options || [])];
      if (control.dataset.optionScope === 'linked-colors') {
        control.dataset.optionIndex.split(',').forEach((index) => { nextOptions[Number(index)] = optionValue; });
      } else {
        const optionIndex = Number(control.dataset.optionIndex);
        nextOptions[optionIndex] = optionValue;
      }
      return nearestBundleVariant(item, nextOptions);
    }

    function setupAccentImagePrefetching() {
      state.accentPrefetchObserver?.disconnect?.();
      state.accentPrefetchObserver = null;
      if (!addons || dataSaverEnabled() || !('IntersectionObserver' in window)) return;
      const labels = Array.from(addons.querySelectorAll('label[data-mb-addon-index]')).filter((label) => {
        const item = state.bundles[Number(label.dataset.mbAddonIndex)];
        return item && isAccentPackAddon(item);
      });
      if (!labels.length) return;

      state.accentPrefetchObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const label = entry.target;
          const item = state.bundles[Number(label.dataset.mbAddonIndex)];
          if (item && isAccentPackAddon(item)) {
            prefetchAccentPrimaryImage(item, item.variant);
            if (item.selected) prefetchRemainingAccentPrimaryImages(item);
          }
          observer.unobserve(label);
        });
      }, { rootMargin: '480px 0px', threshold: 0.01 });
      labels.forEach((label) => state.accentPrefetchObserver.observe(label));
    }

    function selectThumb(thumb, visibleThumbs, options = {}) {
      if (!thumb || !visibleThumbs.length) return;
      const index = updateGallerySelection(thumb, visibleThumbs);
      renderGalleryMedia(thumb, options);
      syncMobileGalleryTrack(index, options);
      scheduleAdjacentGalleryImage(visibleThumbs, index);
    }

    function updateGalleryScrollIndicators() {
      if (!thumbRail || !galleryScrollButtons.length) return;
      const canScroll = thumbRail.scrollHeight - thumbRail.clientHeight > 2;
      const atTop = thumbRail.scrollTop <= 2;
      const atBottom = thumbRail.scrollTop + thumbRail.clientHeight >= thumbRail.scrollHeight - 2;

      galleryScrollButtons.forEach((button) => {
        const direction = button.dataset.mbGalleryScroll;
        button.classList.toggle('is-hidden', !canScroll || (direction === 'up' ? atTop : atBottom));
      });
    }

    function scrollGalleryThumbs(direction) {
      if (!thumbRail) return;
      const distance = Math.max(thumbRail.clientHeight * 0.72, 120);
      thumbRail.scrollBy({ top: direction * distance, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }

    function currentGalleryMedia() {
      if (mainVideo && !mainVideo.hidden) return mainVideo;
      if (mainImage && !mainImage.hidden) return mainImage;
      return null;
    }

    function clearGalleryGhosts() {
      galleryMain?.querySelectorAll('.mb-clean-gallery__ghost').forEach((node) => node.remove());
    }

    function renderMobileGalleryTrack(visibleThumbs) {
      if (!mobileTrack) return;
      const key = visibleThumbs.map((thumb) => [
        thumb.dataset.mediaId,
        thumb.dataset.currentImage || thumb.dataset.image || thumb.dataset.originalImage,
        thumb.dataset.mediaType,
      ].join(':')).join('|');

      state.mobileTrackThumbs = visibleThumbs;
      galleryMain?.classList.toggle('has-mobile-track', visibleThumbs.length > 0);
      if (state.mobileTrackKey === key) return;

      state.mobileTrackKey = key;
      mobileTrack.replaceChildren(...visibleThumbs.map((thumb, index) => {
        const slide = document.createElement('div');
        slide.className = 'mb-clean-gallery__slide';
        slide.dataset.mbGallerySlide = String(index);

        if (thumb.dataset.mediaType === 'video') {
          slide.appendChild(createMobileVideoPoster(thumb, index));
        } else {
          const image = document.createElement('img');
          image.dataset.mbGallerySlideImage = 'true';
          image.dataset.mbGalleryImageSrc = thumb.dataset.currentImage || thumb.dataset.image || thumb.dataset.originalImage;
          image.alt = parseMediaAlt(thumb.dataset.mediaAlt).key || '';
          image.loading = 'lazy';
          image.decoding = 'async';
          slide.appendChild(image);
        }

        return slide;
      }));
    }

    function createMobileVideoPoster(thumb, index = 0) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mb-clean-gallery__video-poster';
      button.dataset.mbGalleryVideoPoster = 'true';
      button.setAttribute('aria-label', `Play ${parseMediaAlt(thumb.dataset.mediaAlt).key || 'product video'}`);

      const image = document.createElement('img');
      image.dataset.mbGallerySlideImage = 'true';
      image.dataset.mbGalleryImageSrc = thumb.dataset.currentImage || thumb.dataset.image || thumb.dataset.originalImage;
      image.alt = parseMediaAlt(thumb.dataset.mediaAlt).key || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      button.appendChild(image);

      const play = document.createElement('span');
      play.className = 'mb-clean-gallery__video-play';
      play.setAttribute('aria-hidden', 'true');
      button.appendChild(play);

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        loadMobileSlideVideo(button.closest('[data-mb-gallery-slide]'), thumb, 'manual');
      });

      return button;
    }

    function hydrateMobileGallerySlide(index, fetchPriority = 'low') {
      if (!mobileTrack || index < 0 || index >= state.mobileTrackThumbs.length) return null;
      const slide = mobileTrack.querySelector(`[data-mb-gallery-slide="${index}"]`);
      const image = slide?.querySelector('[data-mb-gallery-slide-image]');
      if (!image) return slide;
      const src = image.dataset.mbGalleryImageSrc;
      if (!src) return slide;
      const sourceKey = `${src}|${fetchPriority}`;
      if (image.dataset.mbGalleryHydrated === sourceKey && image.currentSrc) return slide;
      setResponsiveImageSource(image, src, {
        widths: galleryImageWidths,
        sizes: galleryImageSizes,
        fallbackWidth: 1400,
        loading: fetchPriority === 'low' ? 'lazy' : 'eager',
        fetchPriority,
      });
      image.dataset.mbGalleryHydrated = sourceKey;
      return slide;
    }

    function hydrateMobileGalleryNeighbors(index) {
      hydrateMobileGallerySlide(index - 1, 'low');
      hydrateMobileGallerySlide(index + 1, 'low');
    }

    function scheduleMobileGalleryNeighbors(index) {
      const hydrationToken = ++state.mobileGalleryHydrationToken;
      if (!mobileTrack || dataSaverEnabled()) return;
      const trackKey = state.mobileTrackKey;
      const activeSlide = hydrateMobileGallerySlide(index, 'auto');
      const activeImage = activeSlide?.querySelector('[data-mb-gallery-slide-image]');
      const hydrate = () => requestGalleryIdle(() => {
        if (hydrationToken !== state.mobileGalleryHydrationToken || trackKey !== state.mobileTrackKey) return;
        hydrateMobileGalleryNeighbors(index);
      });
      if (!activeImage || activeImage.complete) {
        hydrate();
      } else {
        activeImage.addEventListener('load', hydrate, { once: true });
        activeImage.addEventListener('error', hydrate, { once: true });
      }
    }

    function loadMobileSlideVideo(slide, thumb, trigger = 'autoplay') {
      if (!slide) return;
      if (slide.dataset.mbGalleryVideoLoaded === 'true') {
        const existingVideo = slide.querySelector('video');
        prepareGalleryVideo(existingVideo, thumb, 'main_gallery', trigger);
        existingVideo?.play?.().catch(() => {});
        return;
      }
      const sources = videoSourcesFromThumb(thumb);
      const source = preferredVideoSource(sources);
      if (!source) return;

      const video = document.createElement('video');
      video.className = 'mb-clean-gallery__slide-video';
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'none';
      video.dataset.currentSrc = source.url;
      prepareGalleryVideo(video, thumb, 'main_gallery', trigger);

      video.replaceChildren(...sources.map((item) => {
        const sourceNode = document.createElement('source');
        sourceNode.src = item.url;
        sourceNode.type = item.mime_type;
        return sourceNode;
      }));

      slide.dataset.mbGalleryVideoLoaded = 'true';
      slide.appendChild(video);

      let revealed = false;
      const reveal = () => {
        if (revealed) return;
        revealed = true;
        video.classList.add('is-ready');
        window.requestAnimationFrame(() => {
          slide.querySelector('[data-mb-gallery-video-poster]')?.remove();
        });
      };
      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(() => reveal());
      } else {
        video.addEventListener('loadeddata', reveal, { once: true });
        video.addEventListener('playing', reveal, { once: true });
      }
      video.load();
      video.play?.().catch(() => {});
    }

    function syncMobileSlideVideos(activeIndex) {
      if (!mobileTrack || !isMobileGallery()) return;
      const slides = Array.from(mobileTrack.querySelectorAll('[data-mb-gallery-slide]'));
      slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (index !== activeIndex) {
          video?.pause?.();
          return;
        }

        const thumb = state.mobileTrackThumbs[index];
        if (thumb?.dataset.mediaType === 'video') {
          loadMobileSlideVideo(slide, thumb, 'autoplay');
        } else {
          video?.pause?.();
        }
      });
    }

    function syncMobileGalleryTrack(index, options = {}) {
      if (!mobileTrack || !isMobileGallery()) return;
      hydrateMobileGallerySlide(index, 'auto');
      scheduleMobileGalleryNeighbors(index);
      const left = Math.max(0, index) * mobileTrack.clientWidth;
      state.mobileTrackProgrammatic = true;
      state.mobileTrackProgrammaticTarget = left;
      state.mobileTrackPendingThumb = null;
      state.mobileTrackUserStartMediaId = null;
      window.clearTimeout(state.mobileTrackAnalyticsTimer);
      window.clearTimeout(state.mobileTrackProgrammaticTimer);
      state.mobileTrackProgrammaticTimer = window.setTimeout(() => {
        state.mobileTrackProgrammatic = false;
        state.mobileTrackProgrammaticTarget = null;
      }, Math.abs(mobileTrack.scrollLeft - left) <= 2 ? 200 : 1200);
      mobileTrack.scrollTo({
        left,
        behavior: options.immediate || prefersReducedMotion() ? 'auto' : 'smooth',
      });
      window.requestAnimationFrame(() => syncMobileSlideVideos(index));
    }

    function visibleLightboxThumbs() {
      if (state.addonLightboxThumbs) return state.addonLightboxThumbs;
      if (state.focusedBundleThumb) return [state.focusedBundleThumb];
      return thumbs.filter((thumb) => !thumb.hidden);
    }

    const lightboxZoomMax = 4;
    const lightboxDoubleTapZoom = 2.5;
    const lightboxZoomHintKey = `mb-lightbox-zoom-hint:${product.handle}`;
    const clampLightboxValue = (value, minimum, maximum) => Math.max(minimum, Math.min(maximum, value));

    function highResolutionImageSrc(src) {
      return resizedImageSrc(src, 2800);
    }

    function loadLightboxHighResolution(image) {
      if (!image || image.dataset.zoomLoaded === 'true' || image.dataset.zoomLoading === 'true') return;
      const zoomSrc = image.dataset.zoomSrc;
      if (!zoomSrc || zoomSrc === image.src) {
        image.dataset.zoomLoaded = 'true';
        return;
      }
      image.dataset.zoomLoading = 'true';
      const highResolutionImage = new Image();
      highResolutionImage.decoding = 'async';

      const loadPromise = new Promise((resolve, reject) => {
        highResolutionImage.onload = resolve;
        highResolutionImage.onerror = reject;
      });

      const decodeAndLayer = async () => {
        try {
          highResolutionImage.src = zoomSrc;
          if (typeof highResolutionImage.decode === 'function') {
            try {
              await highResolutionImage.decode();
            } catch (error) {
              await loadPromise;
            }
          } else {
            await loadPromise;
          }

          await new Promise((resolve) => window.requestAnimationFrame(resolve));
          const zoomViewport = image.parentElement;
          if (image.isConnected && zoomViewport?.matches('[data-mb-lightbox-zoom]')) {
            highResolutionImage.alt = '';
            highResolutionImage.draggable = false;
            highResolutionImage.dataset.mbLightboxZoomHigh = 'true';
            highResolutionImage.dataset.zoomScale = image.dataset.zoomScale || '1.000';
            highResolutionImage.setAttribute('aria-hidden', 'true');
            highResolutionImage.style.transform = image.style.transform;
            zoomViewport.appendChild(highResolutionImage);
            image.dataset.zoomLoaded = 'true';
          }
        } catch (error) {
        } finally {
          delete image.dataset.zoomLoading;
        }
      };

      decodeAndLayer();
    }

    function hideLightboxZoomHint(markSeen = true) {
      window.clearTimeout(state.lightboxZoomHintTimer);
      state.lightboxZoomHintTimer = null;
      if (lightboxZoomHint) {
        lightboxZoomHint.hidden = true;
        lightboxZoomHint.classList.remove('is-visible');
      }
      if (!markSeen) return;
      try {
        window.sessionStorage.setItem(lightboxZoomHintKey, 'true');
      } catch (error) {}
    }

    function showLightboxZoomHint(slide) {
      if (!lightboxZoomHint || !slide?.querySelector('[data-mb-lightbox-zoom]')) return;
      try {
        if (window.sessionStorage.getItem(lightboxZoomHintKey) === 'true') return;
      } catch (error) {}
      lightboxZoomHint.hidden = false;
      window.requestAnimationFrame(() => lightboxZoomHint.classList.add('is-visible'));
      window.clearTimeout(state.lightboxZoomHintTimer);
      state.lightboxZoomHintTimer = window.setTimeout(() => hideLightboxZoomHint(true), 3200);
    }

    function updateLightboxZoomedState() {
      const activeZoom = lightboxTrack?.querySelector('.mb-clean-lightbox__slide.is-active [data-mb-lightbox-zoom].is-zoomed');
      lightbox?.classList.toggle('is-zoomed', Boolean(activeZoom));
    }

    function resetLightboxZoom(slide = null) {
      const scope = slide || lightboxTrack;
      scope?.querySelectorAll('[data-mb-lightbox-zoom]').forEach((zoomViewport) => {
        zoomViewport._mbResetZoom?.();
      });
      updateLightboxZoomedState();
    }

    function lockLightboxScroll() {
      if (state.lightboxScrollLock) return;
      const body = document.body;
      const scrollY = window.scrollY;
      state.lightboxScrollLock = {
        scrollY,
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
      };
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    }

    function unlockLightboxScroll() {
      const lock = state.lightboxScrollLock;
      if (!lock) return;
      const body = document.body;
      body.style.position = lock.position;
      body.style.top = lock.top;
      body.style.left = lock.left;
      body.style.right = lock.right;
      body.style.width = lock.width;
      state.lightboxScrollLock = null;
      window.scrollTo(window.scrollX, lock.scrollY);
    }

    function setupLightboxZoom(zoomViewport, image, thumb) {
      const zoom = {
        scale: 1,
        x: 0,
        y: 0,
        pointers: new Map(),
        singleStart: null,
        pinchStart: null,
        gestureHadPinch: false,
        lastTapAt: 0,
        lastTapX: 0,
        lastTapY: 0,
      };

      const panBounds = (scale = zoom.scale) => ({
        x: Math.max(0, ((image.offsetWidth || zoomViewport.clientWidth) * scale - zoomViewport.clientWidth) / 2),
        y: Math.max(0, ((image.offsetHeight || zoomViewport.clientHeight) * scale - zoomViewport.clientHeight) / 2),
      });

      const applyZoom = (animate = false) => {
        const bounds = panBounds();
        zoom.x = clampLightboxValue(zoom.x, -bounds.x, bounds.x);
        zoom.y = clampLightboxValue(zoom.y, -bounds.y, bounds.y);
        zoomViewport.classList.toggle('is-zoomed', zoom.scale > 1.01);
        zoomViewport.classList.toggle('is-animating', animate);
        const transform = `translate3d(${zoom.x.toFixed(2)}px, ${zoom.y.toFixed(2)}px, 0) scale(${zoom.scale.toFixed(3)})`;
        zoomViewport.querySelectorAll(':scope > img').forEach((zoomImage) => {
          zoomImage.style.transform = transform;
          zoomImage.dataset.zoomScale = zoom.scale.toFixed(3);
        });
        window.requestAnimationFrame(updateLightboxZoomedState);
      };

      const recordZoom = (method) => {
        state.zoomedMedia.add(galleryMediaKey(thumb));
        sendGalleryAnalytics('pdp_gallery_zoom', {
          ...galleryMediaParams(thumb, visibleLightboxThumbs(), method, false),
          zoom_method: method,
          zoom_scale: Number(zoom.scale.toFixed(2)),
        });
      };

      const setZoomAtPoint = (targetScale, clientX, clientY, method) => {
        const previousScale = zoom.scale;
        const nextScale = clampLightboxValue(targetScale, 1, lightboxZoomMax);
        if (nextScale <= 1.01) {
          zoom.scale = 1;
          zoom.x = 0;
          zoom.y = 0;
          applyZoom(true);
          return;
        }
        const rect = zoomViewport.getBoundingClientRect();
        const offsetX = clientX - (rect.left + rect.width / 2);
        const offsetY = clientY - (rect.top + rect.height / 2);
        zoom.x = offsetX - ((offsetX - zoom.x) / previousScale) * nextScale;
        zoom.y = offsetY - ((offsetY - zoom.y) / previousScale) * nextScale;
        zoom.scale = nextScale;
        loadLightboxHighResolution(image);
        hideLightboxZoomHint(true);
        applyZoom(true);
        if (previousScale <= 1.01) recordZoom(method);
      };

      const toggleZoomAtPoint = (clientX, clientY, method) => {
        setZoomAtPoint(zoom.scale > 1.01 ? 1 : lightboxDoubleTapZoom, clientX, clientY, method);
      };

      zoomViewport._mbResetZoom = () => {
        zoom.scale = 1;
        zoom.x = 0;
        zoom.y = 0;
        zoom.pointers.clear();
        zoom.singleStart = null;
        zoom.pinchStart = null;
        zoom.gestureHadPinch = false;
        zoomViewport.classList.remove('is-zoomed', 'is-dragging', 'is-gesturing');
        zoomViewport.querySelectorAll(':scope > img').forEach((zoomImage) => {
          zoomImage.style.transform = '';
          zoomImage.dataset.zoomScale = '1.000';
        });
      };

      zoomViewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        hideLightboxZoomHint(true);
        try {
          zoomViewport.setPointerCapture?.(event.pointerId);
        } catch (error) {}
        zoom.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        zoomViewport.classList.add('is-gesturing');

        if (zoom.pointers.size === 1) {
          zoom.singleStart = {
            x: event.clientX,
            y: event.clientY,
            time: Date.now(),
            panX: zoom.x,
            panY: zoom.y,
          };
        } else if (zoom.pointers.size === 2) {
          const [first, second] = [...zoom.pointers.values()];
          const rect = zoomViewport.getBoundingClientRect();
          const midpointX = (first.x + second.x) / 2;
          const midpointY = (first.y + second.y) / 2;
          zoom.gestureHadPinch = true;
          zoom.pinchStart = {
            distance: Math.hypot(second.x - first.x, second.y - first.y) || 1,
            scale: zoom.scale,
            x: zoom.x,
            y: zoom.y,
            localX: (midpointX - (rect.left + rect.width / 2) - zoom.x) / zoom.scale,
            localY: (midpointY - (rect.top + rect.height / 2) - zoom.y) / zoom.scale,
          };
          loadLightboxHighResolution(image);
        }
      });

      zoomViewport.addEventListener('pointermove', (event) => {
        if (!zoom.pointers.has(event.pointerId)) return;
        zoom.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        if (zoom.pointers.size >= 2 && zoom.pinchStart) {
          event.preventDefault();
          const [first, second] = [...zoom.pointers.values()];
          const rect = zoomViewport.getBoundingClientRect();
          const midpointX = (first.x + second.x) / 2;
          const midpointY = (first.y + second.y) / 2;
          const distance = Math.hypot(second.x - first.x, second.y - first.y) || 1;
          const previousScale = zoom.scale;
          zoom.scale = clampLightboxValue(zoom.pinchStart.scale * (distance / zoom.pinchStart.distance), 1, lightboxZoomMax);
          zoom.x = midpointX - (rect.left + rect.width / 2) - zoom.pinchStart.localX * zoom.scale;
          zoom.y = midpointY - (rect.top + rect.height / 2) - zoom.pinchStart.localY * zoom.scale;
          applyZoom(false);
          if (previousScale <= 1.01 && zoom.scale > 1.01) recordZoom('pinch');
          return;
        }

        if (zoom.scale > 1.01 && zoom.singleStart) {
          event.preventDefault();
          zoom.x = zoom.singleStart.panX + (event.clientX - zoom.singleStart.x);
          zoom.y = zoom.singleStart.panY + (event.clientY - zoom.singleStart.y);
          zoomViewport.classList.add('is-dragging');
          applyZoom(false);
        }
      });

      const finishPointer = (event) => {
        const pointer = zoom.pointers.get(event.pointerId);
        if (!pointer) return;
        zoom.pointers.delete(event.pointerId);
        try {
          if (!zoomViewport.hasPointerCapture || zoomViewport.hasPointerCapture(event.pointerId)) {
            zoomViewport.releasePointerCapture?.(event.pointerId);
          }
        } catch (error) {}
        zoomViewport.classList.remove('is-dragging');

        if (zoom.pointers.size === 1 && zoom.gestureHadPinch) {
          const remaining = [...zoom.pointers.values()][0];
          zoom.singleStart = {
            x: remaining.x,
            y: remaining.y,
            time: Date.now(),
            panX: zoom.x,
            panY: zoom.y,
          };
        }

        if (!zoom.pointers.size) {
          const start = zoom.singleStart;
          const deltaX = start ? event.clientX - start.x : 0;
          const deltaY = start ? event.clientY - start.y : 0;
          const moved = Math.hypot(deltaX, deltaY);

          if (!zoom.gestureHadPinch && zoom.scale <= 1.01 && Math.abs(deltaX) > 52 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
            syncLightbox(state.lightboxIndex + (deltaX < 0 ? 1 : -1));
          } else if (!zoom.gestureHadPinch && moved < 14 && Date.now() - (start?.time || 0) < 320 && event.pointerType !== 'mouse') {
            const now = Date.now();
            if (now - zoom.lastTapAt < 320 && Math.hypot(event.clientX - zoom.lastTapX, event.clientY - zoom.lastTapY) < 32) {
              toggleZoomAtPoint(event.clientX, event.clientY, 'double_tap');
              zoom.lastTapAt = 0;
            } else {
              zoom.lastTapAt = now;
              zoom.lastTapX = event.clientX;
              zoom.lastTapY = event.clientY;
            }
          }

          zoom.singleStart = null;
          zoom.pinchStart = null;
          zoom.gestureHadPinch = false;
          zoomViewport.classList.remove('is-gesturing');
          if (zoom.scale <= 1.01) zoomViewport._mbResetZoom();
          applyZoom(true);
        }
      };

      zoomViewport.addEventListener('pointerup', finishPointer);
      zoomViewport.addEventListener('pointercancel', finishPointer);
      zoomViewport.addEventListener('dblclick', (event) => {
        event.preventDefault();
        toggleZoomAtPoint(event.clientX, event.clientY, 'double_click');
      });
      zoomViewport.addEventListener('dragstart', (event) => event.preventDefault());
    }

    function renderLightboxSlide(thumb, index) {
      const slide = document.createElement('div');
      slide.className = 'mb-clean-lightbox__slide';
      slide.dataset.lightboxIndex = String(index);
      slide._mbLightboxThumb = thumb;

      if (thumb.dataset.mediaType === 'video') {
        const sources = videoSourcesFromThumb(thumb);
        const posterSrc = thumb.dataset.currentImage || thumb.dataset.image || thumb.dataset.originalImage || '';

        const media = document.createElement('div');
        media.className = 'mb-clean-lightbox__slide-media';

        const posterImg = document.createElement('img');
        posterImg.dataset.mbLightboxPoster = 'true';
        posterImg.dataset.mbLightboxImageSrc = posterSrc;
        posterImg.alt = parseMediaAlt(thumb.dataset.mediaAlt).key || product.title;
        posterImg.loading = 'lazy';
        posterImg.decoding = 'async';
        posterImg.dataset.mbLightboxVideoPoster = 'true';
        media.appendChild(posterImg);

        const video = document.createElement('video');
        video.controls = true;
        video.loop = true;
        video.muted = true;
        video.playsInline = true;
        video.preload = 'none';
        video._mbLightboxSources = sources;
        prepareGalleryVideo(video, thumb, 'expanded_viewer', 'autoplay');
        media.appendChild(video);

        let revealed = false;
        const reveal = () => {
          if (revealed) return;
          revealed = true;
          video.classList.add('is-ready');
          window.requestAnimationFrame(() => posterImg.remove());
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(() => reveal());
        } else {
          video.addEventListener('loadeddata', reveal, { once: true });
          video.addEventListener('playing', reveal, { once: true });
        }

        slide.appendChild(media);
      } else {
        const zoomViewport = document.createElement('div');
        zoomViewport.className = 'mb-clean-lightbox__zoom';
        zoomViewport.dataset.mbLightboxZoom = 'true';
        const image = document.createElement('img');
        const imageSrc = thumb.dataset.currentImage || thumb.dataset.image || thumb.dataset.originalImage;
        image.dataset.mbLightboxImage = 'true';
        image.dataset.mbLightboxImageSrc = imageSrc;
        image.dataset.zoomSrc = highResolutionImageSrc(imageSrc);
        image.dataset.zoomScale = '1.000';
        image.alt = parseMediaAlt(thumb.dataset.mediaAlt).key || product.title;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.draggable = false;
        zoomViewport.appendChild(image);
        setupLightboxZoom(zoomViewport, image, thumb);
        slide.appendChild(zoomViewport);
      }

      return slide;
    }

    function hydrateLightboxSlide(slide, options = {}) {
      if (!slide) return;
      const image = slide.querySelector('[data-mb-lightbox-image]');
      const poster = slide.querySelector('[data-mb-lightbox-poster]');
      const visual = image || poster;
      const visualSrc = visual?.dataset.mbLightboxImageSrc;
      if (visual && visualSrc && visual.dataset.mbLightboxHydrated !== 'true') {
        setResponsiveImageSource(visual, visualSrc, {
          widths: galleryImageWidths,
          sizes: '100vw',
          fallbackWidth: 1400,
          loading: options.active ? 'eager' : 'lazy',
          fetchPriority: options.active ? 'auto' : 'low',
        });
        visual.dataset.mbLightboxHydrated = 'true';
      }

      if (!options.active) return;
      const video = slide.querySelector('video');
      if (!video || video.dataset.mbLightboxSourcesLoaded === 'true') return;
      const sources = video._mbLightboxSources || [];
      video.replaceChildren(...sources.map((item) => {
        const source = document.createElement('source');
        source.src = item.url;
        source.type = item.mime_type;
        return source;
      }));
      video.dataset.mbLightboxSourcesLoaded = 'true';
      video.preload = 'metadata';
      video.load();
    }

    function hydrateLightboxWindow(index) {
      const slides = Array.from(lightboxTrack?.querySelectorAll('.mb-clean-lightbox__slide') || []);
      slides.forEach((slide, slideIndex) => {
        if (Math.abs(slideIndex - index) <= 1) {
          hydrateLightboxSlide(slide, { active: slideIndex === index });
        }
      });
    }

    function syncLightbox(index = state.lightboxIndex, options = {}) {
      const slides = Array.from(lightboxTrack?.querySelectorAll('.mb-clean-lightbox__slide') || []);
      if (!lightboxTrack || !slides.length) return;
      const previousIndex = state.lightboxIndex;
      state.lightboxIndex = Math.max(0, Math.min(slides.length - 1, index));
      if (state.lightboxIndex !== previousIndex) resetLightboxZoom();
      hydrateLightboxWindow(state.lightboxIndex);
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === state.lightboxIndex);
        slide.querySelectorAll('video').forEach((video) => {
          if (slideIndex === state.lightboxIndex) video.play?.().catch(() => {});
          else video.pause?.();
        });
      });
      if (lightboxCount) lightboxCount.textContent = `${state.lightboxIndex + 1} / ${slides.length}`;
      if (lightboxPrev) lightboxPrev.disabled = state.lightboxIndex === 0;
      if (lightboxNext) lightboxNext.disabled = state.lightboxIndex === slides.length - 1;
      updateLightboxZoomedState();
      window.requestAnimationFrame(() => showLightboxZoomHint(slides[state.lightboxIndex]));
      window.clearTimeout(state.lightboxProgrammaticScroll);
      state.lightboxProgrammaticScroll = window.setTimeout(() => {
        state.lightboxProgrammaticScroll = null;
      }, options.immediate ? 80 : 420);
      const targetScroll = state.lightboxIndex * lightboxTrack.clientWidth;
      if (options.immediate || prefersReducedMotion()) {
        const prevBehavior = lightboxTrack.style.scrollBehavior;
        lightboxTrack.style.scrollBehavior = 'auto';
        lightboxTrack.scrollLeft = targetScroll;
        lightboxTrack.style.scrollBehavior = prevBehavior;
      } else {
        try {
          lightboxTrack.scrollTo({ left: targetScroll, behavior: 'smooth' });
        } catch (error) {
          lightboxTrack.scrollLeft = targetScroll;
        }
      }
    }

    function updateLightboxFromScroll() {
      if (!lightbox || lightbox.hidden || !lightboxTrack) return;
      if (state.lightboxProgrammaticScroll) return;
      window.cancelAnimationFrame(state.lightboxScrollRaf);
      state.lightboxScrollRaf = window.requestAnimationFrame(() => {
        const slides = Array.from(lightboxTrack.querySelectorAll('.mb-clean-lightbox__slide'));
        if (!slides.length) return;
        const width = lightboxTrack.clientWidth || 1;
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(lightboxTrack.scrollLeft / width)));
        if (index !== state.lightboxIndex) syncLightbox(index, { immediate: true });
      });
    }

    function openLightbox(options = {}) {
      if (!lightbox || !lightboxTrack) return;
      if (!options.item) state.addonLightboxThumbs = null;
      const visibleThumbs = visibleLightboxThumbs();
      if (!visibleThumbs.length) return;
      const selectedIndex = Math.max(0, visibleThumbs.findIndex((thumb) => thumb.classList.contains('is-selected')));
      if (options.item) {
        trackUpsellInteraction(options.item, 'open_gallery');
        trackUpsellEvent('pdp_upsell_gallery_open', options.item, 'open_gallery');
      } else {
        state.galleryInteractionCount += 1;
        if (state.galleryFirstInteractionAt === null) state.galleryFirstInteractionAt = performance.now();
        state.galleryLastInteraction = 'lightbox';
        state.lightboxOpenedAt = performance.now();
        sendGalleryAnalytics('pdp_gallery_lightbox_open', galleryMediaParams(
          visibleThumbs[selectedIndex], visibleThumbs, 'lightbox', false
        ));
      }
      const dialog = lightbox.querySelector('[role="dialog"]');
      if (dialog) {
        if (!dialog.dataset.defaultLabel) dialog.dataset.defaultLabel = dialog.getAttribute('aria-label') || '';
        dialog.setAttribute('aria-label', options.item
          ? `${addonGalleryLabel}: ${addonDisplayTitle(options.item)} ${addonVariantSubtitle(options.item)}`
          : dialog.dataset.defaultLabel);
      }
      state.lightboxReturnFocus = options.trigger || (document.activeElement instanceof HTMLElement ? document.activeElement : lightboxOpen);
      lightboxTrack.replaceChildren(...visibleThumbs.map(renderLightboxSlide));
      hydrateLightboxWindow(selectedIndex);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mb-clean-lightbox-open');
      lockLightboxScroll();
      state.lightboxIndex = selectedIndex;
      window.requestAnimationFrame(() => syncLightbox(selectedIndex, { immediate: true }));
      const initialFocus = lightbox.querySelector('.mb-clean-lightbox__close') || lightbox.querySelector('[data-mb-lightbox-close]') || lightbox;
      if (typeof trapFocus === 'function') {
        trapFocus(lightbox, initialFocus);
      } else {
        initialFocus.focus?.({ preventScroll: true });
      }
    }

    function closeLightbox() {
      if (!lightbox || !lightboxTrack) return;
      const returnFocus = state.lightboxReturnFocus || lightboxOpen;
      const visibleThumbs = visibleLightboxThumbs();
      const finalThumb = visibleThumbs[state.lightboxIndex];
      const previousThumb = visibleThumbs.find((thumb) => thumb.classList.contains('is-selected'));
      if (finalThumb && !state.addonLightboxThumbs) {
        selectThumb(finalThumb, visibleThumbs, { immediate: true });
        if (finalThumb !== previousThumb) trackGalleryMediaView(finalThumb, visibleThumbs, 'lightbox');
      }
      hideLightboxZoomHint(false);
      resetLightboxZoom();
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.hidden = true;
      document.documentElement.classList.remove('mb-clean-lightbox-open');
      lightbox.classList.remove('is-zoomed');
      lightboxTrack.querySelectorAll('video').forEach((video) => video.pause?.());
      if (state.lightboxOpenedAt !== null) {
        state.lightboxVisibleMs += Math.max(0, performance.now() - state.lightboxOpenedAt);
        state.lightboxOpenedAt = null;
      }
      unlockLightboxScroll();
      state.lightboxReturnFocus = null;
      state.addonLightboxThumbs = null;
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(returnFocus);
      } else {
        returnFocus?.focus?.({ preventScroll: true });
      }
    }

    function updateGallerySelection(thumb, visibleThumbs) {
      thumbs.forEach((node) => node.classList.remove('is-selected'));
      dots.forEach((node) => node.classList.remove('is-active'));
      const index = Math.max(0, visibleThumbs.indexOf(thumb));
      thumb.classList.add('is-selected');
      dots[index]?.classList.add('is-active');
      if (counter) {
        counter.textContent = `${index + 1} / ${visibleThumbs.length}`;
        updateGalleryOpenLabel();
      }
      window.requestAnimationFrame(() => {
        if (thumbRail?.contains(thumb) && thumbRail.clientHeight > 0) {
          if (isMobileGallery()) {
            centerMobileGalleryThumb(thumb, prefersReducedMotion() ? 'auto' : 'smooth');
            updateGalleryScrollIndicators();
            return;
          }
          const railRect = thumbRail.getBoundingClientRect();
          const thumbRect = thumb.getBoundingClientRect();
          if (thumbRect.top < railRect.top) {
            thumbRail.scrollTop += thumbRect.top - railRect.top;
          } else if (thumbRect.bottom > railRect.bottom) {
            thumbRail.scrollTop += thumbRect.bottom - railRect.bottom;
          }
        }
        updateGalleryScrollIndicators();
      });
      return index;
    }

    function updateGalleryOpenLabel() {
      if (!lightboxOpen || !counter) return;
      const mediaCount = counter.textContent.trim();
      lightboxOpen.setAttribute('aria-label', mediaCount ? `${mediaCount} - ${galleryOpenLabel}` : galleryOpenLabel);
    }

    function renderGalleryMedia(thumb, options = {}) {
      const updateMedia = () => {
        const mediaType = thumb.dataset.mediaType;
        if (mediaType === 'video' && mainVideo) {
          const sources = videoSourcesFromThumb(thumb);
          const source = preferredVideoSource(sources);
          if (source) {
            if (mainVideo.dataset.currentSrc !== source.url) {
              mainVideo.replaceChildren(...sources.map((item) => {
                const sourceNode = document.createElement('source');
                sourceNode.src = item.url;
                sourceNode.type = item.mime_type;
                return sourceNode;
              }));
              mainVideo.dataset.currentSrc = source.url;
              // paint the (already-shown) image as the poster so the video box
              // never flashes white while it buffers its first frame
              mainVideo.poster = resizedImageSrc(
                thumb.dataset.currentImage || thumb.dataset.image || thumb.dataset.originalImage || mainVideo.poster || '',
                1100
              );
              mainVideo.load();
            }
            if (mainImage) mainImage.hidden = true;
            mainVideo.hidden = false;
            prepareGalleryVideo(mainVideo, thumb, 'main_gallery', 'autoplay');
            mainVideo.play?.().catch(() => {});
            return;
          }
        }

        if (mainVideo) {
          mainVideo.pause?.();
          mainVideo.hidden = true;
        }

        if (mainImage) {
          mainImage.hidden = false;
          const mediaSrc = thumb.dataset.currentImage || thumb.dataset.image || thumb.dataset.originalImage;
          const loadToken = ++state.mediaLoadToken;
          if (state.galleryExposureTracked) {
            mainImage.addEventListener('error', () => {
              if (loadToken !== state.mediaLoadToken) return;
              sendGalleryAnalytics('pdp_media_error', {
                ...galleryMediaParams(thumb, visibleGalleryThumbs(), state.galleryLastInteraction, false),
                media_error_type: 'image_load',
              });
            }, { once: true });
          }
          setResponsiveImageSource(
            mainImage,
            mediaSrc,
            {
              widths: galleryImageWidths,
              sizes: galleryImageSizes,
              fallbackWidth: 1400,
              loading: 'eager',
            }
          );
          mainImage.alt = parseMediaAlt(thumb.dataset.mediaAlt).key || mainImage.alt;
        }
      };

      window.clearTimeout(state.galleryTransition);
      if (options.immediate) {
        galleryMain?.classList.remove('is-switching', 'is-slide-next', 'is-slide-prev');
        clearGalleryGhosts();
        updateMedia();
        return;
      }

      if (!options.direction || !galleryMain) {
        galleryMain?.classList.add('is-switching');
        state.galleryTransition = window.setTimeout(() => {
          updateMedia();
          window.requestAnimationFrame(() => {
            galleryMain?.classList.remove('is-switching');
          });
        }, 90);
        return;
      }

      clearGalleryGhosts();
      const outgoing = currentGalleryMedia()?.cloneNode(true);
      if (outgoing) {
        outgoing.hidden = false;
        outgoing.removeAttribute('data-mb-main-image');
        outgoing.removeAttribute('data-mb-main-video');
        outgoing.classList.add('mb-clean-gallery__ghost');
        galleryMain.appendChild(outgoing);
      }

      galleryMain.classList.remove('is-switching', 'is-slide-next', 'is-slide-prev');
      galleryMain.classList.add(options.direction > 0 ? 'is-slide-next' : 'is-slide-prev');
      updateMedia();

      state.galleryTransition = window.setTimeout(() => {
        galleryMain.classList.remove('is-slide-next', 'is-slide-prev');
        clearGalleryGhosts();
      }, 460);
    }

    function ensureGalleryDots(count) {
      if (!dotContainer) return;
      while (dotContainer.children.length < count) {
        dotContainer.appendChild(document.createElement('span'));
      }
      while (dotContainer.children.length > count) {
        dotContainer.lastElementChild?.remove();
      }
      dots = Array.from(dotContainer.querySelectorAll('span'));
    }

    function scheduleAdjacentGalleryImage(visibleThumbs, selectedIndex) {
      const token = ++state.galleryAdjacentPreloadToken;
      if (isMobileGallery() || dataSaverEnabled() || visibleThumbs.length < 2) return;
      const adjacentThumb = visibleThumbs[selectedIndex + 1] || visibleThumbs[selectedIndex - 1];
      if (!adjacentThumb || adjacentThumb.dataset.mediaType === 'video') return;
      const src = adjacentThumb.dataset.currentImage || adjacentThumb.dataset.image || adjacentThumb.dataset.originalImage;
      const preloadKey = resizedImageSrc(src, 1400);
      if (!src || state.preloadedImages.has(preloadKey)) return;
      const preload = () => requestGalleryIdle(() => {
        if (token !== state.galleryAdjacentPreloadToken || state.preloadedImages.has(preloadKey)) return;
        state.preloadedImages.add(preloadKey);
        const image = new Image();
        image.decoding = 'async';
        setResponsiveImageSource(image, src, {
          widths: galleryImageWidths,
          sizes: galleryImageSizes,
          fallbackWidth: 1400,
          loading: 'eager',
          fetchPriority: 'low',
        });
      });
      const activeImage = mainImage && !mainImage.hidden ? mainImage : null;
      if (!activeImage || activeImage.complete) {
        preload();
      } else {
        activeImage.addEventListener('load', preload, { once: true });
        activeImage.addEventListener('error', preload, { once: true });
      }
    }

    function visibleGalleryThumbs() {
      return thumbs.filter((node) => !node.hidden);
    }

    function selectAdjacentThumb(direction) {
      if (isMobileGallery() && mobileTrack) {
        mobileTrack.scrollBy({ left: direction * mobileTrack.clientWidth, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        return null;
      }
      const visibleThumbs = visibleGalleryThumbs();
      if (visibleThumbs.length < 2) return null;
      const selectedIndex = Math.max(0, visibleThumbs.findIndex((thumb) => thumb.classList.contains('is-selected')));
      const nextIndex = (selectedIndex + direction + visibleThumbs.length) % visibleThumbs.length;
      selectThumb(visibleThumbs[nextIndex], visibleThumbs, { direction });
      return { thumb: visibleThumbs[nextIndex], visibleThumbs };
    }

    function setupGallerySwipe() {
      if (!galleryMain) return;
      let startX = 0;
      let startY = 0;
      let pointerId = null;
      let isDragging = false;

      galleryMain.addEventListener('pointerdown', (event) => {
        if (event.target.closest?.('[data-mb-gallery-track]')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        isDragging = true;
        galleryMain.setPointerCapture?.(event.pointerId);
      });

      galleryMain.addEventListener('pointerup', (event) => {
        if (!isDragging || pointerId !== event.pointerId) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        isDragging = false;
        pointerId = null;
        galleryMain.releasePointerCapture?.(event.pointerId);

        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;
        galleryMain.dataset.mbGallerySwiped = 'true';
        window.setTimeout(() => { delete galleryMain.dataset.mbGallerySwiped; }, 260);
        const selection = selectAdjacentThumb(deltaX < 0 ? 1 : -1);
        if (selection) {
          trackGalleryMediaView(selection.thumb, selection.visibleThumbs, 'swipe');
        }
      });

      galleryMain.addEventListener('pointercancel', (event) => {
        if (pointerId === event.pointerId) {
          isDragging = false;
          pointerId = null;
        }
      });
    }

    function updateGalleryMedia(options = {}) {
      const variant = state.selectedVariant;
      if (!variant) return;

      const featuredMediaId = variant.featured_media?.id || variant.featured_media_id;
      const legacyReplacements = selectedBundleMediaByKey((item) => isAccentPackAddon(item));
      const mainProductReplacements = mainProductAccentMediaByKey(
        activeAccentPackVariant(options.focusBundleItem)
      );
      const replacements = mergeMediaReplacementMaps(mainProductReplacements, legacyReplacements);
      const skuCompatibleThumbs = thumbs.filter((thumb) => {
        if (isUpsellGalleryMedia(thumb)) return false;
        if (Array.isArray(state.productData?.euEligibleVariantIds)
          && /screen protector|\bincluded\b|colou?r ways|screen and camera lens protection/i.test(thumb.dataset.mediaAlt || '')) return false;
        if (isMainProductAccentMedia(thumb)) return false;
        return mediaMatchesSku(thumb, variant.sku, variant.id) || String(thumb.dataset.mediaId) === String(featuredMediaId);
      });
      const compatibleThumbs = skuCompatibleThumbs.filter(mediaEligibleForExperiment);
      let visibleThumbs = compatibleThumbs;
      state.galleryFallbackUsed = compatibleThumbs.length === 0;

      if (!visibleThumbs.length) {
        const fallbackThumbs = skuCompatibleThumbs.filter(mediaIsLiveFallback);
        const fallbackThumb = fallbackThumbs.find((thumb) => String(thumb.dataset.mediaId) === String(featuredMediaId))
          || fallbackThumbs.find((thumb) => mediaHasPositiveMatch(thumb, variant.sku, variant.id))
          || fallbackThumbs.find((thumb) => mediaAltSkus(thumb.dataset.mediaAlt).length === 0)
          || fallbackThumbs[0];
        visibleThumbs = fallbackThumb ? [fallbackThumb] : [];
      }
      state.galleryEligibleMediaCount = visibleThumbs.length;

      thumbs.forEach((thumb) => {
        const visible = visibleThumbs.includes(thumb);
        thumb.hidden = !visible;
        const img = thumb.querySelector('[data-mb-thumb-image]') || thumb.querySelector('img');
        if (!visible) {
          clearResponsiveImageSource(img);
          return;
        }

        const replacement = replacementForThumb(thumb, replacements);
        const replacementSrc = mediaPreviewSrc(replacement);
        thumb.dataset.currentImage = replacementSrc || thumb.dataset.originalImage || thumb.dataset.image;

        if (img && thumb.dataset.currentImage) {
          setResponsiveImageSource(img, thumb.dataset.currentImage, {
            widths: thumbnailImageWidths,
            sizes: thumbnailImageSizes,
            fallbackWidth: 260,
            loading: 'lazy',
            fetchPriority: 'low',
          });
        }
      });

      ensureGalleryDots(visibleThumbs.length);
      renderMobileGalleryTrack(visibleThumbs);

      dots.forEach((dot, index) => {
        dot.hidden = index >= visibleThumbs.length;
        dot.classList.toggle('is-active', index === 0);
      });

      const accentPackThumb = options.preferAccentPackMedia ? preferredAccentPackThumb(visibleThumbs, options.focusBundleItem) : null;
      const featuredThumb = visibleThumbs.find((thumb) => String(thumb.dataset.mediaId) === String(featuredMediaId));
      const currentSelected = visibleThumbs.find((thumb) => thumb.classList.contains('is-selected'));
      const skuMatchedThumb = visibleThumbs.find((thumb) => mediaHasPositiveMatch(thumb, variant.sku, variant.id));
      const nextThumb = accentPackThumb || (options.resetToFirst
        ? visibleThumbs[0]
        : options.keepSelection && currentSelected
          ? currentSelected
          : skuMatchedThumb || featuredThumb || visibleThumbs[0]);
      state.focusedBundleThumb = null;
      if (galleryBack) galleryBack.hidden = true;
      selectThumb(nextThumb, visibleThumbs, { immediate: true });
      if (lightbox && !lightbox.hidden && !state.addonLightboxThumbs) {
        const lightboxThumbs = visibleLightboxThumbs();
        lightboxTrack?.replaceChildren(...lightboxThumbs.map(renderLightboxSlide));
        syncLightbox(Math.max(0, lightboxThumbs.indexOf(state.focusedBundleThumb || nextThumb)), { immediate: true });
      }
      window.requestAnimationFrame(updateGalleryScrollIndicators);
    }

    const returnToMainGallery = (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
      updateGalleryMedia({ keepSelection: true });
    };

    galleryBack?.addEventListener('pointerdown', (event) => {
      event.stopPropagation();
      event.stopImmediatePropagation?.();
    }, { capture: true });
    galleryBack?.addEventListener('click', returnToMainGallery, { capture: true });

    function updatePriceUI() {
      root.querySelectorAll('[data-mb-vat-note]').forEach((note) => {
        note.hidden = !(state.productData?.euTaxesIncluded && state.selectedVariant?.taxable);
      });
      const qtyValue = currentQuantity();
      const bundles = selectedBundles();
      const preorderSelection = (state.productData?.euPreorderVariantIds || []).includes(String(state.selectedVariant?.id))
        || bundles.some(item => (item.product?.euPreorderVariantIds || []).includes(String(item.variant?.id)));
      root.querySelectorAll('[data-mb-eu-dispatch]').forEach(node => {
        node.textContent = preorderSelection ? 'Preorder · Dispatches in 5 days' : node.dataset.defaultText;
      });
      const pairedTotals = pairedOfferUnitTotals();
      const baseTotal = state.pairedOfferSelected
        ? pairedTotals.discounted * qtyValue
        : Number(state.selectedVariant?.price || 0) * qtyValue;
      const compareTotal = state.pairedOfferSelected
        ? pairedTotals.regular * qtyValue
        : Number(state.selectedVariant?.compare_at_price || state.selectedVariant?.price || 0) * qtyValue;
      const bundleTotal = bundles.filter((item) => !item.included).reduce((sum, item) => sum + item.price * qtyValue, 0);
      const bundleCompare = bundles.filter((item) => !item.included).reduce((sum, item) => sum + Number(item.variant.compare_at_price || item.variant.price || 0) * qtyValue, 0);
      const total = baseTotal + bundleTotal;
      const compare = compareTotal + bundleCompare;
      const savings = Math.max(0, compare - total);
      const itemCount = (state.pairedOfferSelected ? 2 : 1) + bundles.filter((item) => !item.included).length;
      const additionalItemCount = Math.max(0, itemCount - 1);

      root.querySelectorAll('[data-mb-price-current]').forEach((node) => { node.textContent = money(total); });
      root.querySelectorAll('[data-mb-price-compare]').forEach((node) => {
        node.textContent = compare > total ? money(compare) : '';
        node.hidden = compare <= total;
      });
      root.querySelectorAll('[data-mb-price-save]').forEach((node) => {
        node.textContent = savings > 0 ? `Save ${money(savings)}` : '';
        node.hidden = savings <= 0;
      });

      const soldOut = state.pairedOfferSelected
        ? !pairedOfferAvailable()
        : !isAvailableVariant(state.selectedVariant);
      const notifyEligible = soldOut && canNotifySelection();
      updateShipBadge(state.selectedVariant, notifyEligible);
      const unavailableLabel = notifyEligible ? 'Notify Me ✉️' : 'Sold out';
      if (addButton) {
        addButton.classList.toggle('is-notify', notifyEligible);
        addButton.disabled = !!state.cartSubmissionPending || (soldOut && !notifyEligible);
        addButton.querySelector('.mb-clean-atc__desktop').textContent = soldOut ? unavailableLabel : euDisplayText(`Add ${itemCount} item${itemCount === 1 ? '' : 's'} to cart`);
        addButton.querySelector('.mb-clean-atc__mobile').textContent = soldOut ? unavailableLabel : `Add · ${money(total)}`;
      }
      if (stickySubmit) {
        stickySubmit.classList.toggle('is-notify', notifyEligible);
        stickySubmit.disabled = !!state.cartSubmissionPending || (soldOut && !notifyEligible);
        stickySubmit.textContent = soldOut ? unavailableLabel : euDisplayText('Add to cart');
      }
      if (stickyCount) {
        stickyCount.textContent = additionalItemCount > 0 ? `+${additionalItemCount}` : '';
        stickyCount.hidden = additionalItemCount <= 0;
        stickyCount.setAttribute('aria-label', additionalItemCount > 0 ? `${additionalItemCount} additional item${additionalItemCount === 1 ? '' : 's'}` : '');
      }
    }

    function updateShipBadge(variant, notifyEligible = false) {
      if (!shipBadges.length) return;
      const message = notifyEligible
        ? { text: 'SOLD OUT', tone: 'sold-out' }
        : state.productData?.euShippingText
        ? { text: state.productData.euShippingText, tone: 'low' }
        : parseShipMessage(variant);
      shipBadges.forEach((badge) => {
        if (!message) {
          badge.hidden = true;
          badge.textContent = '';
          badge.removeAttribute('data-tone');
          return;
        }

        badge.hidden = false;
        badge.textContent = message.text;
        badge.dataset.tone = message.tone;
      });
    }

    function updateEyebrow(variant) {
      if (!eyebrow) return;
      const primary = resolveBadgeCopy(variant, 'badge_primary');
      const secondary = resolveBadgeCopy(variant, 'badge_secondary');

      if (eyebrowPrimary) {
        eyebrowPrimary.textContent = euDisplayText(primary);
        eyebrowPrimary.hidden = !primary;
      }
      if (eyebrowSecondary) {
        eyebrowSecondary.textContent = euDisplayText(secondary);
        eyebrowSecondary.hidden = !secondary;
      }

      const isEmpty = !primary && !secondary;
      eyebrow.hidden = isEmpty;
      if (form) form.classList.toggle('has-no-eyebrow', isEmpty);
    }

    function updateTeslaScreenHelp() {
      if (!teslaScreenHelp) return;
      const selectedModel = teslaModelOptionIndex >= 0 ? state.selectedOptions[teslaModelOptionIndex] : '';
      const showHelper = /\bmodel\s*y\b/i.test(String(selectedModel || ''));
      if (!showHelper) {
        const helper = teslaScreenHelp.querySelector('[data-mb-find-phone]');
        if (helper) helper.open = false;
      }
      teslaScreenHelp.hidden = !showHelper;
    }

    function announceVariantChange(variant) {
      if (!variant) return;
      const detail = {
        variant,
        sku: variant.sku || '',
        id: variant.id,
        sectionId: root.dataset.sectionId,
        productId: product.id,
      };
      window.MagBakPdpVariant = detail;
      document.dispatchEvent(new CustomEvent('mb:pdp:variant-change', { detail }));
    }

    function updateVariant(variant, options = {}) {
      if (!variant) return;
      state.selectedVariant = variant;
      state.selectedOptions = selectedOptionsFromVariant(variant);
      updateTeslaScreenHelp();
      if (hiddenId) {
        hiddenId.value = variant.id;
        hiddenId.disabled = !isAvailableVariant(variant);
      }
      if (stickyTitle) stickyTitle.textContent = euDisplayText(stickyDisplayTitle);
      if (stickyVariant) {
        const stickyOptionSummary = displaySelectedOptionSummary();
        stickyVariant.textContent = euDisplayText(stickyOptionSummary);
        stickyVariant.hidden = !stickyOptionSummary;
      }
      if (stickyImage) {
        const src = variantImageSrc(variant);
        if (src) {
          setResponsiveImageSource(stickyImage, src, {
            widths: [60, 90, 120],
            sizes: '60px',
            fallbackWidth: 120,
            loading: 'lazy',
            fetchPriority: 'low',
          });
        }
      }
      if (productSubtitle) {
        const productDescription = plainText(product.description);
        productSubtitle.textContent = euDisplayText(productSummary || truncateWords(productDescription));
      }

      updateOptionUI();
      renderBundles();
      renderInfoAccordion(variant);
      updatePriceUI();
      updateEyebrow(variant);
      updateGalleryMedia({
        keepSelection: options.keepImage,
        resetToFirst: !options.keepImage,
      });
      announceVariantChange(variant);

      if (!options.skipHistory && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function preserveViewport(callback, scrollPosition = {}) {
      const x = typeof scrollPosition.x === 'number' ? scrollPosition.x : window.scrollX;
      const y = typeof scrollPosition.y === 'number' ? scrollPosition.y : window.scrollY;
      callback();
      window.requestAnimationFrame(() => { window.scrollTo(x, y); });
      window.setTimeout(() => { window.scrollTo(x, y); }, 0);
    }

    function chooseOption(optionIndex, value, options = {}) {
      const choosingPairedOffer = pairedOfferVisible
        && optionIndex === pairedOfferOptionIndex
        && String(value || '') === String(pairedOfferConfig.label || '');
      const previousValue = state.pairedOfferSelected && optionIndex === pairedOfferOptionIndex
        ? pairedOfferConfig.label
        : state.selectedOptions[optionIndex];
      if (choosingPairedOffer) {
        const variants = pairedOfferVariants();
        if (!pairedOfferAvailable()) return;
        state.pairedOfferSelected = true;
        if (options.preserveViewport) {
          preserveViewport(() => updateVariant(variants[0]), options.scrollPosition);
        } else {
          updateVariant(variants[0]);
        }
        if (String(previousValue || '') !== String(value || '')) {
          trackConfigurationChange(
            analyticsOptionCategory(productOptions[optionIndex], optionIndex),
            previousValue,
            value,
            true,
            'paired_offer'
          );
        }
        return;
      }
      if (optionIndex === pairedOfferOptionIndex) state.pairedOfferSelected = false;
      const nextOptions = [...state.selectedOptions];
      nextOptions[optionIndex] = value;
      if (state.pairedOfferSelected && !pairedOfferAvailable(nextOptions)) state.pairedOfferSelected = false;
      const nextVariant = findNearestVariant(nextOptions, optionIndex);
      if (options.preserveViewport) {
        preserveViewport(() => updateVariant(nextVariant), options.scrollPosition);
      } else {
        updateVariant(nextVariant);
      }
      if (String(previousValue || '') !== String(value || '')) {
        trackConfigurationChange(
          analyticsOptionCategory(productOptions[optionIndex], optionIndex),
          previousValue,
          value,
          isAvailableVariant(nextVariant),
          'product_option'
        );
      }
    }

    function resetProductFormAfterCartAdd() {
      const variant = resetVariant
        || productVariants.find((candidate) => candidate.id === initialVariantId)
        || productVariants.find((candidate) => !isHidden(candidate))
        || productVariants[0];

      state.bundleSelections = {};
      state.bundleEnabled = {};
      state.accentSelections = {};
      state.accentSelectionCleared = {};
      state.bundleProperties = {};
      state.focusedBundleThumb = null;
      state.pairedOfferSelected = false;
      if (galleryBack) galleryBack.hidden = true;
      if (qty) qty.value = 1;
      updateVariant(variant);
      updateMobileGalleryPinState();
    }

    function parseProductData(sectionHTML) {
      const doc = new DOMParser().parseFromString(sectionHTML || '', 'text/html');
      const script = doc.querySelector('script[type="application/json"]');
      return script ? JSON.parse(script.textContent || '{}') : null;
    }

    function requestJSON(url) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url.toString(), true);
        xhr.responseType = 'json';
        xhr.onload = () => {
          if (xhr.status < 200 || xhr.status >= 300) {
            reject(new Error(`Request failed with ${xhr.status}`));
            return;
          }

          resolve(xhr.response || JSON.parse(xhr.responseText || '{}'));
        };
        xhr.onerror = () => reject(new Error('Request failed'));
        xhr.send();
      });
    }

    async function fetchProductData() {
      if (productConfig.productData) {
        state.productData = productConfig.productData;
        // The payload sets productData.product to null to avoid serializing
        // the product twice; the top-level copy is the same object.
        if (!state.productData.product) {
          state.productData.product = product;
        }
        return;
      }

      try {
        const url = new URL(root.dataset.productUrl || window.location.pathname, window.location.origin);
        url.searchParams.set('sections', 'mb-product-json');
        const sections = await requestJSON(url);
        state.productData = parseProductData(sections['mb-product-json']);
      } catch (error) {
        console.warn('MagBak redesign product data unavailable', error);
        state.productData = { product, metafields: {}, variant_metafields: {} };
      }
    }

    function flushMobileTrackAnalytics() {
      const thumb = state.mobileTrackPendingThumb;
      const visibleThumbs = state.mobileTrackThumbs;
      const startMediaId = state.mobileTrackUserStartMediaId;
      state.mobileTrackPendingThumb = null;
      state.mobileTrackUserStartMediaId = null;
      if (!thumb || String(thumb.dataset.mediaId || '') === String(startMediaId || '')) return;
      trackGalleryMediaView(thumb, visibleThumbs, 'swipe');
    }

    function scheduleMobileTrackAnalytics() {
      window.clearTimeout(state.mobileTrackAnalyticsTimer);
      state.mobileTrackAnalyticsTimer = window.setTimeout(flushMobileTrackAnalytics, 180);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const visibleThumbs = visibleGalleryThumbs();
        const selectedIndex = Math.max(0, visibleThumbs.findIndex((node) => node.classList.contains('is-selected')));
        const nextIndex = Math.max(0, visibleThumbs.indexOf(thumb));
        selectThumb(thumb, visibleThumbs, { direction: nextIndex >= selectedIndex ? 1 : -1 });
        trackGalleryMediaView(thumb, visibleThumbs, 'thumbnail', nextIndex !== selectedIndex);
      });
    });

    mobileTrack?.addEventListener('pointerdown', () => {
      if (!isMobileGallery() || !state.mobileTrackThumbs.length) return;
      window.clearTimeout(state.mobileTrackProgrammaticTimer);
      state.mobileTrackProgrammatic = false;
      state.mobileTrackProgrammaticTarget = null;
      const selectedIndex = Math.max(0, state.mobileTrackThumbs.findIndex((thumb) => thumb.classList.contains('is-selected')));
      hydrateMobileGalleryNeighbors(selectedIndex);
    }, { passive: true });

    mobileTrack?.addEventListener('scroll', () => {
      if (!isMobileGallery() || !state.mobileTrackThumbs.length) return;
      if (
        state.mobileTrackProgrammatic
        && Math.abs(mobileTrack.scrollLeft - (state.mobileTrackProgrammaticTarget ?? mobileTrack.scrollLeft)) <= 2
      ) {
        window.clearTimeout(state.mobileTrackProgrammaticTimer);
        state.mobileTrackProgrammaticTimer = window.setTimeout(() => {
          state.mobileTrackProgrammatic = false;
          state.mobileTrackProgrammaticTarget = null;
        }, 200);
      }
      window.cancelAnimationFrame(state.mobileTrackScrollRaf);
      state.mobileTrackScrollRaf = window.requestAnimationFrame(() => {
        if (state.mobileTrackProgrammatic) return;
        const width = mobileTrack.clientWidth || 1;
        const index = Math.max(0, Math.min(state.mobileTrackThumbs.length - 1, Math.round(mobileTrack.scrollLeft / width)));
        const thumb = state.mobileTrackThumbs[index];
        syncMobileSlideVideos(index);
        const selectedThumb = state.mobileTrackThumbs.find((node) => node.classList.contains('is-selected'));
        if (thumb && !thumb.classList.contains('is-selected')) {
          hydrateMobileGallerySlide(index, 'auto');
          scheduleMobileGalleryNeighbors(index);
          updateGallerySelection(thumb, state.mobileTrackThumbs);
          if (!state.mobileTrackProgrammatic) {
            if (state.mobileTrackUserStartMediaId == null) {
              state.mobileTrackUserStartMediaId = selectedThumb?.dataset.mediaId || '';
            }
            state.mobileTrackPendingThumb = thumb;
          }
        }
        if (!state.mobileTrackProgrammatic && state.mobileTrackPendingThumb) {
          scheduleMobileTrackAnalytics();
        }
      });
    }, { passive: true });

    lightboxOpen?.addEventListener('click', (event) => {
      if (galleryMain?.dataset.mbGallerySwiped === 'true') return;
      if (event.target.closest?.('[data-mb-gallery-scroll], [data-mb-gallery-thumb], [data-mb-gallery-back]')) return;
      openLightbox();
    });

    lightboxOpen?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openLightbox();
    });

    root.querySelectorAll('[data-mb-lightbox-close]').forEach((button) => {
      button.addEventListener('click', closeLightbox);
    });

    lightboxPrev?.addEventListener('click', () => syncLightbox(state.lightboxIndex - 1));
    lightboxNext?.addEventListener('click', () => syncLightbox(state.lightboxIndex + 1));
    lightboxTrack?.addEventListener('scroll', updateLightboxFromScroll, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
      }
      if (event.key === 'ArrowLeft') syncLightbox(state.lightboxIndex - 1);
      if (event.key === 'ArrowRight') syncLightbox(state.lightboxIndex + 1);
    });

    thumbRail?.addEventListener('scroll', updateGalleryScrollIndicators, { passive: true });
    window.addEventListener('resize', updateGalleryScrollIndicators);
    window.addEventListener('resize', () => { state.cssRem = null; state.galleryStickyTop = null; });
    window.addEventListener('resize', requestMobileGalleryPinUpdate);
    window.addEventListener('scroll', requestMobileGalleryPinUpdate, { passive: true });

    const mbBarEls = ['.announcement-bar-section', '.section-header'].map((s) => document.querySelector(s)).filter(Boolean);
    const MB_BAR_EASE = 'transform 240ms cubic-bezier(0.22, 1, 0.36, 1)';
    let mbBarLastY = window.scrollY || 0;
    let mbBarOffset = 0;
    let mbBarH = 0;
    const mbBarMeasure = () => { mbBarH = mbBarEls.reduce((h, el) => h + (el.offsetHeight || 0), 0) || 108; };
    mbBarMeasure();
    window.addEventListener('resize', mbBarMeasure);
    const mbBarApply = (offset, animate) => {
      mbBarEls.forEach((el) => {
        el.style.setProperty('transition', animate ? MB_BAR_EASE : 'none', 'important');
        if (offset <= 0) el.style.removeProperty('transform');
        else el.style.setProperty('transform', `translate3d(0, -${offset}px, 0)`, 'important');
      });
    };
    window.addEventListener('scroll', () => {
      if (!isMobileGallery() || prefersReducedMotion()) {
        if (mbBarOffset !== 0) { mbBarOffset = 0; mbBarApply(0, false); }
        mbBarLastY = window.scrollY || 0;
        return;
      }
      const y = Math.max(0, window.scrollY || 0);
      const delta = y - mbBarLastY;
      mbBarLastY = y;
      let next = mbBarOffset;
      if (y <= 0) next = 0;               // at top: shown
      else if (delta > 2) next = mbBarH;  // scrolling down: hide
      else if (delta < -2) next = 0;      // scrolling up: reveal
      if (next === mbBarOffset) return;   // no direction change → no work
      mbBarOffset = next;
      mbBarApply(next, true);             // one smooth eased slide (both directions)
    }, { passive: true });
    galleryScrollButtons.forEach((button) => {
      button.addEventListener('click', () => {
        scrollGalleryThumbs(button.dataset.mbGalleryScroll === 'up' ? -1 : 1);
      });
    });

    setupGallerySwipe();

    optionGroups.forEach((group) => {
      const optionIndex = Number(group.dataset.optionPosition || 1) - 1;
      group.querySelectorAll('[data-mb-option-input]').forEach((input) => {
        const label = input.closest('[data-mb-option-value]');
        let pointerStart = null;

        label?.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          pointerStart = {
            x: event.clientX,
            y: event.clientY,
            scrollX: window.scrollX,
            scrollY: window.scrollY,
          };
        });

        label?.addEventListener('click', (event) => {
          const moved = pointerStart
            && (Math.abs(event.clientX - pointerStart.x) > 8 || Math.abs(event.clientY - pointerStart.y) > 8);
          if (moved) {
            event.preventDefault();
            pointerStart = null;
            return;
          }

          // Cancelling a direct radio click restores its previous checked state.
          // Only suppress the label's synthetic click; let the input commit its state.
          if (event.target !== input) event.preventDefault();
          chooseOption(optionIndex, input.value, {
            preserveViewport: true,
            scrollPosition: pointerStart ? { x: pointerStart.scrollX, y: pointerStart.scrollY } : undefined,
          });
          pointerStart = null;
        });

        input.addEventListener('change', () => {
          chooseOption(optionIndex, input.value);
        });
      });
    });

    root.querySelector('[data-mb-qty-minus]')?.addEventListener('click', () => {
      qty.value = Math.max(1, Number(qty.value || 1) - 1);
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    });
    root.querySelector('[data-mb-qty-plus]')?.addEventListener('click', () => {
      qty.value = Number(qty.value || 1) + 1;
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qty?.addEventListener('change', updatePriceUI);
    stickySubmit?.addEventListener('click', () => {
      if (stickySubmit.disabled || !addButton) return;
      state.pendingAtcSource = 'sticky';
      if (typeof form?.requestSubmit === 'function') {
        form.requestSubmit(addButton);
        return;
      }
      addButton.click();
    });
    addButton?.addEventListener('click', (event) => {
      if (event.isTrusted) state.pendingAtcSource = 'primary';
    });

    if (stickyAtc && addButton && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const stuck = !entry.isIntersecting;
        root.classList.toggle('is-sticky-atc-visible', stuck);
        // top-level hook so CSS can lift the (externally-injected) Richpanel
        // chat launcher above the sticky bar on mobile — see mb-theme.css
        document.documentElement.classList.toggle('mb-sticky-atc-on', stuck);
        stickyAtc.setAttribute('aria-hidden', String(entry.isIntersecting));
      }, { threshold: 0.05 });
      stickyObserver.observe(addButton);
    }

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (state.cartSubmissionPending) return;
      if (pairStockCheckPending) return;
      if (nativePairedOffer && state.pairedOfferSelected) {
        pairStockCheckPending = true;
        if (addButton) addButton.disabled = true;
        try {
          await refreshNativePairStock();
          if (!pairedOfferAvailable() || nativePairFor().quantity < currentQuantity()) {
            throw new Error('Both chargers are no longer in stock in the requested quantity. Please choose another option.');
          }
        } catch (error) {
          const wrapper = root.querySelector('.product-form__error-message-wrapper');
          const message = root.querySelector('.product-form__error-message');
          if (message) message.textContent = error.message;
          if (wrapper) wrapper.hidden = false;
          if (addButton) addButton.disabled = !pairedOfferAvailable();
          return;
        } finally {
          pairStockCheckPending = false;
        }
      }

      if (canNotifySelection()) {
        openNotifyDialog();
        state.pendingAtcSource = 'primary';
        return;
      }
      const selectedPairedVariants = state.pairedOfferSelected ? pairedOfferVariants() : [];
      const atcAvailable = Boolean(addButton) && (state.pairedOfferSelected
        ? pairedOfferAvailable()
        : isAvailableVariant(state.selectedVariant));
      state.atcAttemptId = galleryMeasurementSessionId + ':atc:' + Date.now() + ':' + (++measurementSequence);
      sendGalleryAnalytics('pdp_add_to_cart_attempt', {
        cta_source: state.pendingAtcSource,
        selection_available: atcAvailable ? 'available' : 'unavailable',
        ...analyticsConfiguration(),
      });
      if (!atcAvailable) {
        sendGalleryAnalytics('pdp_add_to_cart_error', {
          cta_source: state.pendingAtcSource,
          atc_error_type: 'unavailable_variant',
          ...analyticsConfiguration(),
        });
        state.pendingAtcSource = 'primary';
        return;
      }

      const quantity = currentQuantity();
      const cartGroup = `${Date.now()}-${state.selectedVariant.id}`;
      const selectedEntries = selectedPurchasableEntries();
      const selectedPaidEntries = selectedEntries.filter((entry) => !entry.item.included);
      const relationshipChildKinds = selectedPaidEntries.map(({ item }) => (
        isEngravingAddon(item)
          ? window.MagBakCartRelationship?.KINDS.PERSONALIZATION
          : window.MagBakCartRelationship?.KINDS.DEPENDENT
      ));
      const pairedOfferCartPercent = pairedOfferCartDiscountPercent();
      let relationshipPilotPlan = null;
      if (relationshipWriterEnabled()) {
        try {
          relationshipPilotPlan = state.pairedOfferSelected && !nativePairedOffer
            ? window.MagBakCartRelationship.planNewBundleRelationshipGroup([
              { childKinds: relationshipChildKinds },
              { childKinds: [] },
            ], {
              tiers: [{ count: 2, percent: pairedOfferCartPercent }],
            })
            : selectedPaidEntries.length > 0
              ? window.MagBakCartRelationship.planNewRelationshipGroup(selectedPaidEntries.length, {
                childKinds: relationshipChildKinds,
              })
              : null;
        } catch (error) {
          console.error('Cart relationship metadata could not be created.', error);
        }
      }
      if (((state.pairedOfferSelected && !nativePairedOffer) || selectedPaidEntries.length > 0) && !relationshipPilotPlan) {
        const relationshipErrorWrapper = root.querySelector('.product-form__error-message-wrapper');
        const relationshipErrorMessage = root.querySelector('.product-form__error-message');
        if (relationshipErrorMessage) {
          relationshipErrorMessage.textContent = 'Your setup could not be added safely. Please refresh and try again.';
        }
        if (relationshipErrorWrapper) relationshipErrorWrapper.hidden = false;
        sendGalleryAnalytics('pdp_add_to_cart_error', {
          cta_source: state.pendingAtcSource,
          atc_error_type: 'relationship_metadata',
          ...analyticsConfiguration(),
        });
        state.pendingAtcSource = 'primary';
        return;
      }
      const relationshipRootLink = state.pairedOfferSelected && !nativePairedOffer
        ? relationshipPilotPlan?.primaryLinks?.[0]
        : relationshipPilotPlan?.rootLink;
      const relationshipDependentLinks = state.pairedOfferSelected && !nativePairedOffer
        ? relationshipPilotPlan?.childLinks?.[0] || []
        : relationshipPilotPlan?.dependentLinks || [];
      const relationshipRoot = relationshipRootLink
        ? window.MagBakCartRelationship.safeParseLink(relationshipRootLink)
        : null;
      const manifestCartGroup = relationshipRoot?.ok ? relationshipRoot.link.group : cartGroup;
      // The deployed bundle-tier Function still needs these two private inputs
      // for paired fixed-price offers whose exact discount is fractional. Keep
      // the compatibility bridge scoped to the paired offer only; ordinary
      // PDP upsells continue to write the compact relationship contract alone.
      const pairedPricingProperties = state.pairedOfferSelected && !nativePairedOffer ? {
        _bundle_key: `paired-${cartGroup}`,
        _bundle_tiers: `2:${pairedOfferCartPercent}`,
      } : {};
      const mainItem = {
        id: state.pairedOfferSelected && nativePairedOffer ? nativePairFor().id : state.selectedVariant.id,
        quantity,
        properties: relationshipRootLink
          ? { _mb_link: relationshipRootLink, ...pairedPricingProperties }
          : pairedPricingProperties,
      };
      const items = [mainItem];
      if (state.pairedOfferSelected && !nativePairedOffer) {
        const pairedComponent = selectedPairedVariants.find((variant) => String(variant.id) !== String(state.selectedVariant.id));
        if (pairedComponent) {
          items.push({
            id: pairedComponent.id,
            quantity,
            properties: {
              _mb_link: relationshipPilotPlan.primaryLinks[1],
              ...pairedPricingProperties,
            },
          });
        }
      }
      let validationFailed = false;
      let relationshipDependentIndex = 0;
      const trackedUpsellEntries = [];
      selectedEntries.forEach((entry) => {
        const { item } = entry;
        if (item.included) return;
        const cartPropertyResult = readAddonCartProperties(entry);
        if (!cartPropertyResult.valid) {
          validationFailed = true;
          return;
        }
        const relationshipLink = relationshipDependentLinks[relationshipDependentIndex++] || '';
        const usePersonalizationAllowlist = Boolean(
          relationshipLink
          && isEngravingAddon(item)
          && window.MagBakCartRelationship?.fulfillmentProperties
        );
        const properties = usePersonalizationAllowlist
          ? window.MagBakCartRelationship.fulfillmentProperties({
            engravingText: cartPropertyResult.properties['Engrave Text'],
            parentSku: state.selectedVariant.sku,
            link: relationshipLink,
          })
          : {
            _mb_link: relationshipLink,
            ...cartPropertyResult.properties,
          };
        trackedUpsellEntries.push({ ...entry, relationshipLink });
        items.push({
          id: item.variant.id,
          quantity,
          properties,
        });
      });
      if (validationFailed) {
        sendGalleryAnalytics('pdp_add_to_cart_error', {
          cta_source: state.pendingAtcSource,
          atc_error_type: 'addon_validation',
          ...analyticsConfiguration(),
        });
        state.pendingAtcSource = 'primary';
        return;
      }

      // Freeze the submitted cascade before the asynchronous cart request.
      const atcContext = { ...galleryAnalyticsBase(), ...analyticsConfiguration(),
        cta_source: state.pendingAtcSource, atc_attempt_id: state.atcAttemptId };
      const confirmGallery = prepareGalleryAddToCart(quantity, items, manifestCartGroup, atcContext);
      const confirmUpsells = prepareUpsellAddToCart(trackedUpsellEntries, manifestCartGroup, atcContext);
      state.cartSubmissionPending = true;
      addButton.disabled = true;
      addButton.classList.add('loading');
      const errorWrapper = root.querySelector('.product-form__error-message-wrapper');
      const errorMessage = root.querySelector('.product-form__error-message');
      if (errorWrapper) errorWrapper.hidden = true;
      if (errorMessage) errorMessage.textContent = '';
      if (stickySubmit) {
        stickySubmit.disabled = true;
        stickySubmit.textContent = 'Adding...';
      }

      try {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const sectionIds = cart?.getSectionsToRender?.().map((section) => section.id) || [];
        const body = { items };
        if (sectionIds.length) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }

        const response = await fetchWithRetry(ajaxCartUrl(window.routes?.cart_add_url, '/cart/add.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        }, 1);
        const responseText = await response.text();
        const data = parseCartAddResponse(responseText);

        if (!response.ok) throw new Error(data?.description || data?.message || "Unable to add to cart");
        if (!data) throw new Error("Cart response could not be confirmed. Check your cart before trying again.");
        // The Shopify mutation succeeded. Drawer rendering is a separate outcome.
        confirmGallery();
        confirmUpsells();
        try {
          if (cart?.renderContents && data.sections) await cart.renderContents(data);
          else await refreshCartDrawer(cart);
          document.dispatchEvent(new CustomEvent("cart:refresh", {detail:data}));
        } catch {
          sendGalleryAnalytics("pdp_cart_drawer_error", atcContext);
        }
        resetProductFormAfterCartAdd();
      } catch (error) {
        sendGalleryAnalytics('pdp_add_to_cart_error', {
          cta_source: state.pendingAtcSource,
          atc_error_type: /network|fetch/i.test(String(error?.message || '')) ? 'network' : 'cart_request',
          ...atcContext,
        });
        if (errorWrapper && errorMessage) {
          errorMessage.textContent = error.message;
          errorWrapper.hidden = false;
        }
      } finally {
        state.cartSubmissionPending = false;
        state.pendingAtcSource = 'primary';
        addButton.classList.remove('loading');
        updatePriceUI();
      }
    }, true);

    state.selectedVariant = productVariants.find((variant) => variant.id === productConfig.currentVariantId) || productVariants[0];
    resetVariant = state.selectedVariant;
    resetOptions = selectedOptionsFromVariant(state.selectedVariant);
    state.selectedOptions = [...resetOptions];
    updateVariant(state.selectedVariant, { skipHistory: true, keepImage: true });
    fetchProductData().then(() => {
      resetVariant = findNearestVariant(resetOptions);
      updateVariant(resetVariant, { skipHistory: true, keepImage: true });
    });
    if (nativePairedOffer) {
      const refreshPair = () => refreshNativePairStock().catch(() => {
        nativePairData = { pairs: (nativePairData?.pairs || []).map((pair) => ({ ...pair, available: false })) };
        updateOptionUI();
        updatePriceUI();
      });
      window.addEventListener('pageshow', refreshPair);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) refreshPair();
      });
      window.setInterval(() => { if (!document.hidden && !pairStockCheckPending) refreshPair(); }, 30000);
    }
    updateGalleryOpenLabel();
    updateMobileGalleryPinState();
    startGalleryAnalytics();
    startGalleryDiagnostics();

  })();
